
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $54cd03c1d32ebcab$var$n, $54cd03c1d32ebcab$export$41c562ebe57d11e2, $54cd03c1d32ebcab$var$u, $54cd03c1d32ebcab$export$a8257692ac88316c, $54cd03c1d32ebcab$var$i, $54cd03c1d32ebcab$var$o, $54cd03c1d32ebcab$var$r, $54cd03c1d32ebcab$var$f, $54cd03c1d32ebcab$var$e, $54cd03c1d32ebcab$var$c, $54cd03c1d32ebcab$var$s, $54cd03c1d32ebcab$var$a, $54cd03c1d32ebcab$var$h = {}, $54cd03c1d32ebcab$var$p = [], $54cd03c1d32ebcab$var$v = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $54cd03c1d32ebcab$var$y = Array.isArray;
function $54cd03c1d32ebcab$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $54cd03c1d32ebcab$var$w(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $54cd03c1d32ebcab$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $54cd03c1d32ebcab$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $54cd03c1d32ebcab$var$g(l, f, i, o, null);
}
function $54cd03c1d32ebcab$var$g(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$54cd03c1d32ebcab$var$u : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $54cd03c1d32ebcab$export$41c562ebe57d11e2.vnode && $54cd03c1d32ebcab$export$41c562ebe57d11e2.vnode(f), f;
}
function $54cd03c1d32ebcab$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $54cd03c1d32ebcab$export$ffb0004e005737fa(n) {
    return n.children;
}
function $54cd03c1d32ebcab$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $54cd03c1d32ebcab$var$x(n, l) {
    if (null == l) return n.__ ? $54cd03c1d32ebcab$var$x(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $54cd03c1d32ebcab$var$x(n) : null;
}
function $54cd03c1d32ebcab$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $54cd03c1d32ebcab$var$C(n);
    }
}
function $54cd03c1d32ebcab$var$M(n) {
    (!n.__d && (n.__d = !0) && $54cd03c1d32ebcab$var$i.push(n) && !$54cd03c1d32ebcab$var$P.__r++ || $54cd03c1d32ebcab$var$o !== $54cd03c1d32ebcab$export$41c562ebe57d11e2.debounceRendering) && (($54cd03c1d32ebcab$var$o = $54cd03c1d32ebcab$export$41c562ebe57d11e2.debounceRendering) || $54cd03c1d32ebcab$var$r)($54cd03c1d32ebcab$var$P);
}
function $54cd03c1d32ebcab$var$P() {
    var n, u, t, o, r, e, c, s;
    for($54cd03c1d32ebcab$var$i.sort($54cd03c1d32ebcab$var$f); n = $54cd03c1d32ebcab$var$i.shift();)n.__d && (u = $54cd03c1d32ebcab$var$i.length, o = void 0, e = (r = (t = n).__v).__e, c = [], s = [], t.__P && ((o = $54cd03c1d32ebcab$var$d({}, r)).__v = r.__v + 1, $54cd03c1d32ebcab$export$41c562ebe57d11e2.vnode && $54cd03c1d32ebcab$export$41c562ebe57d11e2.vnode(o), $54cd03c1d32ebcab$var$O(t.__P, o, r, t.__n, t.__P.namespaceURI, 32 & r.__u ? [
        e
    ] : null, c, null == e ? $54cd03c1d32ebcab$var$x(r) : e, !!(32 & r.__u), s), o.__v = r.__v, o.__.__k[o.__i] = o, $54cd03c1d32ebcab$var$j(c, o, s), o.__e != e && $54cd03c1d32ebcab$var$C(o)), $54cd03c1d32ebcab$var$i.length > u && $54cd03c1d32ebcab$var$i.sort($54cd03c1d32ebcab$var$f));
    $54cd03c1d32ebcab$var$P.__r = 0;
}
function $54cd03c1d32ebcab$var$S(n, l, u, t, i, o, r, f, e, c, s) {
    var a, v, y, d, w, _ = t && t.__k || $54cd03c1d32ebcab$var$p, g = l.length;
    for(u.__d = e, $54cd03c1d32ebcab$var$$(u, l, _), e = u.__d, a = 0; a < g; a++)null != (y = u.__k[a]) && "boolean" != typeof y && "function" != typeof y && (v = -1 === y.__i ? $54cd03c1d32ebcab$var$h : _[y.__i] || $54cd03c1d32ebcab$var$h, y.__i = a, $54cd03c1d32ebcab$var$O(n, y, v, i, o, r, f, e, c, s), d = y.__e, y.ref && v.ref != y.ref && (v.ref && $54cd03c1d32ebcab$var$N(v.ref, null, y), s.push(y.ref, y.__c || d, y)), null == w && null != d && (w = d), 65536 & y.__u || v.__k === y.__k ? e = $54cd03c1d32ebcab$var$I(y, e, n) : "function" == typeof y.type && void 0 !== y.__d ? e = y.__d : d && (e = d.nextSibling), y.__d = void 0, y.__u &= -196609);
    u.__d = e, u.__e = w;
}
function $54cd03c1d32ebcab$var$$(n, l, u) {
    var t, i, o, r, f, e = l.length, c = u.length, s = c, a = 0;
    for(n.__k = [], t = 0; t < e; t++)r = t + a, null != (i = n.__k[t] = null == (i = l[t]) || "boolean" == typeof i || "function" == typeof i ? null : "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? $54cd03c1d32ebcab$var$g(null, i, null, null, null) : $54cd03c1d32ebcab$var$y(i) ? $54cd03c1d32ebcab$var$g($54cd03c1d32ebcab$export$ffb0004e005737fa, {
        children: i
    }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? $54cd03c1d32ebcab$var$g(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) ? (i.__ = n, i.__b = n.__b + 1, f = $54cd03c1d32ebcab$var$L(i, u, r, s), i.__i = f, o = null, -1 !== f && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f == r - 1 ? a = f - r : f == r + 1 ? a++ : f > r ? s > e - r ? a += f - r : a-- : f < r && a++, f !== t + a && (i.__u |= 65536))) : (o = u[r]) && null == o.key && o.__e && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $54cd03c1d32ebcab$var$x(o)), $54cd03c1d32ebcab$var$V(o, o, !1), u[r] = null, s--);
    if (s) for(t = 0; t < c; t++)null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $54cd03c1d32ebcab$var$x(o)), $54cd03c1d32ebcab$var$V(o, o));
}
function $54cd03c1d32ebcab$var$I(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $54cd03c1d32ebcab$var$I(t[i], l, u));
        return l;
    }
    n.__e != l && (l && n.type && !u.contains(l) && (l = $54cd03c1d32ebcab$var$x(n)), u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 === l.nodeType);
    return l;
}
function $54cd03c1d32ebcab$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($54cd03c1d32ebcab$var$y(n) ? n.some(function(n) {
        $54cd03c1d32ebcab$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $54cd03c1d32ebcab$var$L(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type && 0 == (131072 & e.__u)) return u;
    if (t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $54cd03c1d32ebcab$var$T(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $54cd03c1d32ebcab$var$v.test(l) ? u : u + "px";
}
function $54cd03c1d32ebcab$var$A(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $54cd03c1d32ebcab$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $54cd03c1d32ebcab$var$T(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/i, "$1")), l = l.toLowerCase() in n || "onFocusOut" === l || "onFocusIn" === l ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = $54cd03c1d32ebcab$var$e, n.addEventListener(l, o ? $54cd03c1d32ebcab$var$s : $54cd03c1d32ebcab$var$c, o)) : n.removeEventListener(l, o ? $54cd03c1d32ebcab$var$s : $54cd03c1d32ebcab$var$c, o);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $54cd03c1d32ebcab$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $54cd03c1d32ebcab$var$e++;
            else if (u.t < t.u) return;
            return t($54cd03c1d32ebcab$export$41c562ebe57d11e2.event ? $54cd03c1d32ebcab$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $54cd03c1d32ebcab$var$O(n, u, t, i, o, r, f, e, c, s) {
    var a, h, p, v, w, _, g, m, x, C, M, P, $, I, H, L, T = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        e = u.__e = t.__e
    ]), (a = $54cd03c1d32ebcab$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof T) try {
        if (m = u.props, x = "prototype" in T && T.prototype.render, C = (a = T.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? g = (h = u.__c = t.__c).__ = h.__E : (x ? u.__c = h = new T(m, M) : (u.__c = h = new $54cd03c1d32ebcab$export$16fa2f45be04daa8(m, M), h.constructor = T, h.render = $54cd03c1d32ebcab$var$q), C && C.sub(h), h.props = m, h.state || (h.state = {}), h.context = M, h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), x && null == h.__s && (h.__s = h.state), x && null != T.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $54cd03c1d32ebcab$var$d({}, h.__s)), $54cd03c1d32ebcab$var$d(h.__s, T.getDerivedStateFromProps(m, h.__s))), v = h.props, w = h.state, h.__v = u, p) x && null == T.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), x && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (x && null == T.getDerivedStateFromProps && m !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(m, M), !h.__e && (null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(m, h.__s, M) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (h.props = m, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.forEach(function(n) {
                    n && (n.__ = u);
                }), P = 0; P < h._sb.length; P++)h.__h.push(h._sb[P]);
                h._sb = [], h.__h.length && f.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(m, h.__s, M), x && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, w, _);
            });
        }
        if (h.context = M, h.props = m, h.__P = n, h.__e = !1, $ = $54cd03c1d32ebcab$export$41c562ebe57d11e2.__r, I = 0, x) {
            for(h.state = h.__s, h.__d = !1, $ && $(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, $ && $(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++I < 25);
        h.state = h.__s, null != h.getChildContext && (i = $54cd03c1d32ebcab$var$d($54cd03c1d32ebcab$var$d({}, i), h.getChildContext())), x && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(v, w)), $54cd03c1d32ebcab$var$S(n, $54cd03c1d32ebcab$var$y(L = null != a && a.type === $54cd03c1d32ebcab$export$ffb0004e005737fa && null == a.key ? a.props.children : a) ? L : [
            L
        ], u, t, i, o, r, f, e, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && f.push(h), g && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != r) {
            for(u.__u |= c ? 160 : 32; e && 8 === e.nodeType && e.nextSibling;)e = e.nextSibling;
            r[r.indexOf(e)] = null, u.__e = e;
        } else u.__e = t.__e, u.__k = t.__k;
        $54cd03c1d32ebcab$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $54cd03c1d32ebcab$var$z(t.__e, u, t, i, o, r, f, c, s);
    (a = $54cd03c1d32ebcab$export$41c562ebe57d11e2.diffed) && a(u);
}
function $54cd03c1d32ebcab$var$j(n, u, t) {
    u.__d = void 0;
    for(var i = 0; i < t.length; i++)$54cd03c1d32ebcab$var$N(t[i], t[++i], t[++i]);
    $54cd03c1d32ebcab$export$41c562ebe57d11e2.__c && $54cd03c1d32ebcab$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $54cd03c1d32ebcab$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $54cd03c1d32ebcab$var$z(l, u, t, i, o, r, f, e, c) {
    var s, a, p, v, d, _, g, m = t.props, k = u.props, b = u.type;
    if ("svg" === b ? o = "http://www.w3.org/2000/svg" : "math" === b ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != r) {
        for(s = 0; s < r.length; s++)if ((d = r[s]) && "setAttribute" in d == !!b && (b ? d.localName === b : 3 === d.nodeType)) {
            l = d, r[s] = null;
            break;
        }
    }
    if (null == l) {
        if (null === b) return document.createTextNode(k);
        l = document.createElementNS(o, b, k.is && k), r = null, e = !1;
    }
    if (null === b) m === k || e && l.data === k || (l.data = k);
    else {
        if (r = r && $54cd03c1d32ebcab$var$n.call(l.childNodes), m = t.props || $54cd03c1d32ebcab$var$h, !e && null != r) for(m = {}, s = 0; s < l.attributes.length; s++)m[(d = l.attributes[s]).name] = d.value;
        for(s in m)if (d = m[s], "children" == s) ;
        else if ("dangerouslySetInnerHTML" == s) p = d;
        else if ("key" !== s && !(s in k)) {
            if ("value" == s && "defaultValue" in k || "checked" == s && "defaultChecked" in k) continue;
            $54cd03c1d32ebcab$var$A(l, s, null, d, o);
        }
        for(s in k)d = k[s], "children" == s ? v = d : "dangerouslySetInnerHTML" == s ? a = d : "value" == s ? _ = d : "checked" == s ? g = d : "key" === s || e && "function" != typeof d || m[s] === d || $54cd03c1d32ebcab$var$A(l, s, d, m[s], o);
        if (a) e || p && (a.__html === p.__html || a.__html === l.innerHTML) || (l.innerHTML = a.__html), u.__k = [];
        else if (p && (l.innerHTML = ""), $54cd03c1d32ebcab$var$S(l, $54cd03c1d32ebcab$var$y(v) ? v : [
            v
        ], u, t, i, "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : o, r, f, r ? r[0] : t.__k && $54cd03c1d32ebcab$var$x(t, 0), e, c), null != r) for(s = r.length; s--;)null != r[s] && $54cd03c1d32ebcab$var$w(r[s]);
        e || (s = "value", void 0 !== _ && (_ !== l[s] || "progress" === b && !_ || "option" === b && _ !== m[s]) && $54cd03c1d32ebcab$var$A(l, s, _, m[s], o), s = "checked", void 0 !== g && g !== l[s] && $54cd03c1d32ebcab$var$A(l, s, g, m[s], o));
    }
    return l;
}
function $54cd03c1d32ebcab$var$N(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $54cd03c1d32ebcab$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $54cd03c1d32ebcab$var$V(n, u, t) {
    var i, o;
    if ($54cd03c1d32ebcab$export$41c562ebe57d11e2.unmount && $54cd03c1d32ebcab$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $54cd03c1d32ebcab$var$N(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $54cd03c1d32ebcab$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $54cd03c1d32ebcab$var$V(i[o], u, t || "function" != typeof n.type);
    t || null == n.__e || $54cd03c1d32ebcab$var$w(n.__e), n.__c = n.__ = n.__e = n.__d = void 0;
}
function $54cd03c1d32ebcab$var$q(n, l, u) {
    return this.constructor(n, u);
}
function $54cd03c1d32ebcab$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, f, e;
    $54cd03c1d32ebcab$export$41c562ebe57d11e2.__ && $54cd03c1d32ebcab$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, f = [], e = [], $54cd03c1d32ebcab$var$O(t, u = (!o && i || t).__k = $54cd03c1d32ebcab$export$c8a8987d4410bf2d($54cd03c1d32ebcab$export$ffb0004e005737fa, null, [
        u
    ]), r || $54cd03c1d32ebcab$var$h, $54cd03c1d32ebcab$var$h, t.namespaceURI, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $54cd03c1d32ebcab$var$n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o, e), $54cd03c1d32ebcab$var$j(f, u, e);
}
function $54cd03c1d32ebcab$export$fa8d919ba61d84db(n, l) {
    $54cd03c1d32ebcab$export$b3890eb0ae9dca99(n, l, $54cd03c1d32ebcab$export$fa8d919ba61d84db);
}
function $54cd03c1d32ebcab$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, f, e = $54cd03c1d32ebcab$var$d({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? $54cd03c1d32ebcab$var$n.call(arguments, 2) : t), $54cd03c1d32ebcab$var$g(l.type, e, i || l.key, o || l.ref, null);
}
function $54cd03c1d32ebcab$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $54cd03c1d32ebcab$var$a++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, t;
            return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function() {
                return t;
            }, this.componentWillUnmount = function() {
                u = null;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $54cd03c1d32ebcab$var$M(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u && u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$54cd03c1d32ebcab$var$n = $54cd03c1d32ebcab$var$p.slice, $54cd03c1d32ebcab$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $54cd03c1d32ebcab$var$u = 0, $54cd03c1d32ebcab$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $54cd03c1d32ebcab$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $54cd03c1d32ebcab$var$d({}, this.state), "function" == typeof n && (n = n($54cd03c1d32ebcab$var$d({}, u), this.props)), n && $54cd03c1d32ebcab$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $54cd03c1d32ebcab$var$M(this));
}, $54cd03c1d32ebcab$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $54cd03c1d32ebcab$var$M(this));
}, $54cd03c1d32ebcab$export$16fa2f45be04daa8.prototype.render = $54cd03c1d32ebcab$export$ffb0004e005737fa, $54cd03c1d32ebcab$var$i = [], $54cd03c1d32ebcab$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $54cd03c1d32ebcab$var$f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $54cd03c1d32ebcab$var$P.__r = 0, $54cd03c1d32ebcab$var$e = 0, $54cd03c1d32ebcab$var$c = $54cd03c1d32ebcab$var$F(!1), $54cd03c1d32ebcab$var$s = $54cd03c1d32ebcab$var$F(!0), $54cd03c1d32ebcab$var$a = 0;


var $45c58de8213b6dd9$var$t = /["&<]/;
function $45c58de8213b6dd9$var$n(r) {
    if (0 === r.length || !1 === $45c58de8213b6dd9$var$t.test(r)) return r;
    for(var e = 0, n = 0, o = "", f = ""; n < r.length; n++){
        switch(r.charCodeAt(n)){
            case 34:
                f = "&quot;";
                break;
            case 38:
                f = "&amp;";
                break;
            case 60:
                f = "&lt;";
                break;
            default:
                continue;
        }
        n !== e && (o += r.slice(e, n)), o += f, e = n + 1;
    }
    return n !== e && (o += r.slice(e, n)), o;
}
var $45c58de8213b6dd9$var$o = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $45c58de8213b6dd9$var$f = 0, $45c58de8213b6dd9$var$i = Array.isArray;
function $45c58de8213b6dd9$export$34b9dba7ce09269b(e, t, n, o, i, u) {
    t || (t = {});
    var a, c, p = t;
    if ("ref" in p) for(c in p = {}, t)"ref" == c ? a = t[c] : p[c] = t[c];
    var l = {
        type: e,
        props: p,
        key: n,
        ref: a,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: --$45c58de8213b6dd9$var$f,
        __i: -1,
        __u: 0,
        __source: i,
        __self: u
    };
    if ("function" == typeof e && (a = e.defaultProps)) for(c in a)void 0 === p[c] && (p[c] = a[c]);
    return (0, $54cd03c1d32ebcab$export$41c562ebe57d11e2).vnode && (0, $54cd03c1d32ebcab$export$41c562ebe57d11e2).vnode(l), l;
}
function $45c58de8213b6dd9$export$45700d561b2268ac(r) {
    var t = $45c58de8213b6dd9$export$34b9dba7ce09269b((0, $54cd03c1d32ebcab$export$ffb0004e005737fa), {
        tpl: r,
        exprs: [].slice.call(arguments, 1)
    });
    return t.key = t.__v, t;
}
var $45c58de8213b6dd9$var$c = {}, $45c58de8213b6dd9$var$p = /[A-Z]/g;
function $45c58de8213b6dd9$export$991f6ffe102e5bac(e, t) {
    if ((0, $54cd03c1d32ebcab$export$41c562ebe57d11e2).attr) {
        var f = (0, $54cd03c1d32ebcab$export$41c562ebe57d11e2).attr(e, t);
        if ("string" == typeof f) return f;
    }
    if ("ref" === e || "key" === e) return "";
    if ("style" === e && "object" == typeof t) {
        var i = "";
        for(var u in t){
            var a = t[u];
            if (null != a && "" !== a) {
                var l = "-" == u[0] ? u : $45c58de8213b6dd9$var$c[u] || ($45c58de8213b6dd9$var$c[u] = u.replace($45c58de8213b6dd9$var$p, "-$&").toLowerCase()), _ = ";";
                "number" != typeof a || l.startsWith("--") || $45c58de8213b6dd9$var$o.test(l) || (_ = "px;"), i = i + l + ":" + a + _;
            }
        }
        return e + '="' + i + '"';
    }
    return null == t || !1 === t || "function" == typeof t || "object" == typeof t ? "" : !0 === t ? e : e + '="' + $45c58de8213b6dd9$var$n(t) + '"';
}
function $45c58de8213b6dd9$export$40e96e718441efeb(r) {
    if (null == r || "boolean" == typeof r || "function" == typeof r) return null;
    if ("object" == typeof r) {
        if (void 0 === r.constructor) return r;
        if ($45c58de8213b6dd9$var$i(r)) {
            for(var e = 0; e < r.length; e++)r[e] = $45c58de8213b6dd9$export$40e96e718441efeb(r[e]);
            return r;
        }
    }
    return $45c58de8213b6dd9$var$n("" + r);
}








var $533c30c7538d0ac3$exports = {};
$533c30c7538d0ac3$exports = new URL("wattpad.dacae05b.svg", import.meta.url).toString();


var $e62867419c0be676$exports = {};
$e62867419c0be676$exports = new URL("AO3Logo.2ad5c229.svg", import.meta.url).toString();


var $2d511e294a23bdc8$exports = {};
$2d511e294a23bdc8$exports = new URL("epub.04a23c02.svg", import.meta.url).toString();


var $1ee0f1ea517deac2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $1ee0f1ea517deac2$export$2e2bcd8739ae039 {
    constructor(){
        this._locked = false;
        this.toCome = [];
        this.release = this.release.bind(this);
    }
    /**
     * Returns the state of the Locken
     *
     * @returns {boolean}
     */ get locked() {
        return this._locked;
    }
    /**
     * Waits till lock is free and returns a release function
     *
     * @return {function}
     */ getLock() {
        return $1ee0f1ea517deac2$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._locked) return {
                release: this.lock()
            };
            else return new Promise((resolve)=>{
                this.toCome.push(()=>{
                    resolve({
                        release: this.lock()
                    });
                });
            });
        });
    }
    lock() {
        this._locked = true;
        return this.release;
    }
    release() {
        return $1ee0f1ea517deac2$var$__awaiter(this, void 0, void 0, function*() {
            let next = this.toCome.shift();
            if (next) next();
            else this._locked = false;
        });
    }
}


var $f1f0edacc5982840$var$_a;
const $f1f0edacc5982840$var$ClosedSymbol = Symbol("Observable Closed");
class $f1f0edacc5982840$export$2e2bcd8739ae039 {
    constructor(collect_intervall = 100){
        this.collect_intervall = collect_intervall;
        this.subscriber = [];
        this.subscriberCollect = [];
        this.events = [];
        this.timeout = undefined;
        // Use symbol to make sure this property cannot be changed from the outside
        this[$f1f0edacc5982840$var$_a] = false;
    }
    get closed() {
        return this[$f1f0edacc5982840$var$ClosedSymbol];
    }
    subscribe(callback) {
        if (this[$f1f0edacc5982840$var$ClosedSymbol]) throw new Error("Observable is closed!");
        let oldcb = this.subscriber.find((e)=>e === callback);
        if (!oldcb) this.subscriber.push(callback);
        return ()=>this.unsubscribe(callback);
    }
    unsubscribe(callback) {
        if (this[$f1f0edacc5982840$var$ClosedSymbol]) return;
        let idx = this.subscriber.findIndex((e)=>e === callback);
        if (idx >= 0) this.subscriber.splice(idx, 1);
        else {
            idx = this.subscriberCollect.findIndex((e)=>e === callback);
            if (idx >= 0) this.subscriberCollect.splice(idx, 1);
        }
    }
    subscribeCollect(callback) {
        if (this[$f1f0edacc5982840$var$ClosedSymbol]) throw new Error("Observable is closed!");
        let oldcb = this.subscriberCollect.find((e)=>e === callback);
        if (!oldcb) this.subscriberCollect.push(callback);
        return ()=>this.unsubscribe(callback);
    }
    /**
     * Creates Public API with subscribe and unsubscribe
     *
     * @returns {object}
     */ getPublicApi() {
        if (this[$f1f0edacc5982840$var$ClosedSymbol]) throw new Error("Observable is closed!");
        return {
            subscribe: (callback)=>this.subscribe(callback),
            unsubscribe: (callback)=>this.unsubscribe(callback),
            subscribeCollect: (callback)=>this.subscribeCollect(callback)
        };
    }
    /**
     * Sends data to all subscribers
     * @param data data to be sent
     */ send(data) {
        if (this[$f1f0edacc5982840$var$ClosedSymbol]) throw new Error("Observable is closed!");
        Array.from(this.subscriber.values()).forEach((e)=>{
            try {
                e(data);
            } catch (err) {
                // Catch error, so it doesn't affect other subscribers
                console.error(err);
            }
        });
        if (this.subscribeCollect.length > 0) {
            this.events.push(data);
            if (!this.timeout) this.timeout = setTimeout(()=>{
                this.subscriberCollect.forEach((cb)=>{
                    cb(this.events);
                });
                this.events = [];
                this.timeout = undefined;
            }, this.collect_intervall);
        }
    }
    /**
     * Closes Observable. This will remove all subscribers and mark this observable as closed.
     * You won't be able to reopen this observable. All maybe collected data will be discardet.
     */ close() {
        this[$f1f0edacc5982840$var$ClosedSymbol] = true;
        this.subscriber = [];
        this.subscriberCollect = [];
        this.events = [];
        if (this.timeout) clearTimeout(this.timeout);
    }
}
$f1f0edacc5982840$var$_a = $f1f0edacc5982840$var$ClosedSymbol;



class $d79c62a22096991c$export$2e2bcd8739ae039 {
    constructor(_value){
        this._value = _value;
        this.observable = new (0, $f1f0edacc5982840$export$2e2bcd8739ae039)();
        this.subscribe = this.subscribe.bind(this);
        this.unsubscribe = this.unsubscribe.bind(this);
    }
    /**
     * Get the current value
     */ get value() {
        return this._value;
    }
    /**
     * Set a new value and notify subscribers
     * @param value Value to be set
     */ send(value) {
        this._value = value;
        this.observable.send(value);
    }
    /**
     * Get the current value as well as all changes
     * @param handler Handler called on change
     */ subscribe(handler) {
        handler(this._value);
        return this.observable.subscribe(handler);
    }
    /**
     * Unsubscribe from changes
     * @param handler The handler to unsubscribe
     */ unsubscribe(handler) {
        this.observable.unsubscribe(handler);
    }
    /**
     * Await a specific value and return.
     *
     * For example if val = true then this function would block until the value
     * is actually true. If it is true, then the promise will resolve immediatly
     *
     * @param val Value to await
     */ awaitValue(val) {
        let ignore = ()=>undefined;
        let prms = new Promise((yes)=>{
            const cb = ()=>{
                if (typeof val === "function") {
                    if (val(this._value)) {
                        yes();
                        this.unsubscribe(cb);
                    }
                } else if (this._value === val) {
                    yes();
                    this.unsubscribe(cb);
                }
            };
            this.subscribe(cb);
        });
        return {
            then: prms.then.bind(prms),
            catch: prms.catch.bind(prms),
            ignore: ()=>ignore()
        };
    }
    /**
     * Creates Public API with subscribe and unsubscribe
     *
     * @returns {object}
     */ getPublicApi() {
        if (this.observable.closed) throw new Error("Observable is closed!");
        return {
            subscribe: (callback)=>this.subscribe(callback),
            unsubscribe: (callback)=>this.unsubscribe(callback),
            awaitValue: (value)=>this.awaitValue(value)
        };
    }
    /**
     * Close this store. All subscribers will be unsubscribed and any further operations will fail
     */ close() {
        this.observable.close();
    }
}



class $7c4ea253722c24ef$export$2e2bcd8739ae039 {
    constructor(){
        this.awaiter = [];
    }
    sendSignal() {
        this.awaiter.forEach((a)=>a());
        this.awaiter = [];
    }
    awaitSignal() {
        return new Promise((resolve)=>{
            this.awaiter.push(resolve);
        });
    }
}


var $ddc935938937be64$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ddc935938937be64$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
};
var $ddc935938937be64$var$_onClose, $ddc935938937be64$var$_onData;
class $ddc935938937be64$export$2e2bcd8739ae039 {
    constructor(){
        $ddc935938937be64$var$_onClose.set(this, []);
        $ddc935938937be64$var$_onData.set(this, new (0, $f1f0edacc5982840$export$2e2bcd8739ae039)());
    }
    onClose(callback) {
        $ddc935938937be64$var$__classPrivateFieldGet(this, $ddc935938937be64$var$_onClose).push(callback);
    }
    getCallback() {
        return (error, data)=>{
            $ddc935938937be64$var$__classPrivateFieldGet(this, $ddc935938937be64$var$_onData).send({
                error: error,
                data: data,
                close: undefined
            });
        };
    }
    send(data) {
        $ddc935938937be64$var$__classPrivateFieldGet(this, $ddc935938937be64$var$_onData).send({
            error: undefined,
            data: data,
            close: undefined
        });
    }
    close() {
        $ddc935938937be64$var$__classPrivateFieldGet(this, $ddc935938937be64$var$_onData).send({
            close: true,
            data: undefined,
            error: undefined
        });
        $ddc935938937be64$var$__classPrivateFieldGet(this, $ddc935938937be64$var$_onData).close();
        $ddc935938937be64$var$__classPrivateFieldGet(this, $ddc935938937be64$var$_onClose).forEach((cb)=>cb());
    }
    [($ddc935938937be64$var$_onClose = new WeakMap(), $ddc935938937be64$var$_onData = new WeakMap(), Symbol.asyncIterator)]() {
        const queue = [];
        const signal = new (0, $7c4ea253722c24ef$export$2e2bcd8739ae039)();
        $ddc935938937be64$var$__classPrivateFieldGet(this, $ddc935938937be64$var$_onData).subscribe((data)=>{
            queue.push(data);
            signal.sendSignal();
        });
        return {
            next () {
                return $ddc935938937be64$var$__awaiter(this, void 0, void 0, function*() {
                    const send = ()=>{
                        const value = queue.shift();
                        if (!value) throw new Error("Error in AsyncIter");
                        if (value.close) return {
                            done: true,
                            value: undefined
                        };
                        else if (value.error) throw value.error;
                        else return {
                            done: false,
                            value: value.data
                        };
                    };
                    if (queue.length > 0) return send();
                    else {
                        yield signal.awaitSignal();
                        return send();
                    }
                });
            }
        };
    }
}





var $4672ca3638a76ec7$exports = {};
"use strict";
Object.defineProperty($4672ca3638a76ec7$exports, "__esModule", {
    value: true
});
var $46b246f610bc4d5f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $46b246f610bc4d5f$export$2e2bcd8739ae039 {
    constructor(){
        this._locked = false;
        this.toCome = [];
        this.release = this.release.bind(this);
    }
    /**
     * Returns the state of the Locken
     *
     * @returns {boolean}
     */ get locked() {
        return this._locked;
    }
    /**
     * Waits till lock is free and returns a release function
     *
     * @return {function}
     */ getLock() {
        return $46b246f610bc4d5f$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._locked) return {
                release: this.lock()
            };
            else return new Promise((resolve)=>{
                this.toCome.push(()=>{
                    resolve({
                        release: this.lock()
                    });
                });
            });
        });
    }
    lock() {
        this._locked = true;
        return this.release;
    }
    release() {
        return $46b246f610bc4d5f$var$__awaiter(this, void 0, void 0, function*() {
            let next = this.toCome.shift();
            if (next) next();
            else this._locked = false;
        });
    }
}


var $e8eab699cb9bf42c$var$_a;
const $e8eab699cb9bf42c$var$ClosedSymbol = Symbol("Observable Closed");
class $e8eab699cb9bf42c$export$2e2bcd8739ae039 {
    constructor(collect_intervall = 100){
        this.collect_intervall = collect_intervall;
        this.subscriber = [];
        this.subscriberCollect = [];
        this.events = [];
        this.timeout = undefined;
        // Use symbol to make sure this property cannot be changed from the outside
        this[$e8eab699cb9bf42c$var$_a] = false;
    }
    get closed() {
        return this[$e8eab699cb9bf42c$var$ClosedSymbol];
    }
    subscribe(callback) {
        if (this[$e8eab699cb9bf42c$var$ClosedSymbol]) throw new Error("Observable is closed!");
        let oldcb = this.subscriber.find((e)=>e === callback);
        if (!oldcb) this.subscriber.push(callback);
        return ()=>this.unsubscribe(callback);
    }
    unsubscribe(callback) {
        if (this[$e8eab699cb9bf42c$var$ClosedSymbol]) return;
        let idx = this.subscriber.findIndex((e)=>e === callback);
        if (idx >= 0) this.subscriber.splice(idx, 1);
        else {
            idx = this.subscriberCollect.findIndex((e)=>e === callback);
            if (idx >= 0) this.subscriberCollect.splice(idx, 1);
        }
    }
    subscribeCollect(callback) {
        if (this[$e8eab699cb9bf42c$var$ClosedSymbol]) throw new Error("Observable is closed!");
        let oldcb = this.subscriberCollect.find((e)=>e === callback);
        if (!oldcb) this.subscriberCollect.push(callback);
        return ()=>this.unsubscribe(callback);
    }
    /**
     * Creates Public API with subscribe and unsubscribe
     *
     * @returns {object}
     */ getPublicApi() {
        if (this[$e8eab699cb9bf42c$var$ClosedSymbol]) throw new Error("Observable is closed!");
        return {
            subscribe: (callback)=>this.subscribe(callback),
            unsubscribe: (callback)=>this.unsubscribe(callback),
            subscribeCollect: (callback)=>this.subscribeCollect(callback)
        };
    }
    /**
     * Sends data to all subscribers
     * @param data data to be sent
     */ send(data) {
        if (this[$e8eab699cb9bf42c$var$ClosedSymbol]) throw new Error("Observable is closed!");
        Array.from(this.subscriber.values()).forEach((e)=>{
            try {
                e(data);
            } catch (err) {
                // Catch error, so it doesn't affect other subscribers
                console.error(err);
            }
        });
        if (this.subscribeCollect.length > 0) {
            this.events.push(data);
            if (!this.timeout) this.timeout = setTimeout(()=>{
                this.subscriberCollect.forEach((cb)=>{
                    cb(this.events);
                });
                this.events = [];
                this.timeout = undefined;
            }, this.collect_intervall);
        }
    }
    /**
     * Closes Observable. This will remove all subscribers and mark this observable as closed.
     * You won't be able to reopen this observable. All maybe collected data will be discardet.
     */ close() {
        this[$e8eab699cb9bf42c$var$ClosedSymbol] = true;
        this.subscriber = [];
        this.subscriberCollect = [];
        this.events = [];
        if (this.timeout) clearTimeout(this.timeout);
    }
}
$e8eab699cb9bf42c$var$_a = $e8eab699cb9bf42c$var$ClosedSymbol;



class $b32e16791444e3a4$export$2e2bcd8739ae039 {
    constructor(_value){
        this._value = _value;
        this.observable = new (0, $e8eab699cb9bf42c$export$2e2bcd8739ae039)();
        this.subscribe = this.subscribe.bind(this);
        this.unsubscribe = this.unsubscribe.bind(this);
    }
    /**
     * Get the current value
     */ get value() {
        return this._value;
    }
    /**
     * Set a new value and notify subscribers
     * @param value Value to be set
     */ send(value) {
        this._value = value;
        this.observable.send(value);
    }
    /**
     * Get the current value as well as all changes
     * @param handler Handler called on change
     */ subscribe(handler) {
        handler(this._value);
        return this.observable.subscribe(handler);
    }
    /**
     * Unsubscribe from changes
     * @param handler The handler to unsubscribe
     */ unsubscribe(handler) {
        this.observable.unsubscribe(handler);
    }
    /**
     * Await a specific value and return.
     *
     * For example if val = true then this function would block until the value
     * is actually true. If it is true, then the promise will resolve immediatly
     *
     * @param val Value to await
     */ awaitValue(val) {
        let ignore = ()=>undefined;
        let prms = new Promise((yes)=>{
            const cb = ()=>{
                if (typeof val === "function") {
                    if (val(this._value)) {
                        yes();
                        this.unsubscribe(cb);
                    }
                } else if (this._value === val) {
                    yes();
                    this.unsubscribe(cb);
                }
            };
            this.subscribe(cb);
        });
        return {
            then: prms.then.bind(prms),
            catch: prms.catch.bind(prms),
            ignore: ()=>ignore()
        };
    }
    /**
     * Creates Public API with subscribe and unsubscribe
     *
     * @returns {object}
     */ getPublicApi() {
        if (this.observable.closed) throw new Error("Observable is closed!");
        return {
            subscribe: (callback)=>this.subscribe(callback),
            unsubscribe: (callback)=>this.unsubscribe(callback),
            awaitValue: (value)=>this.awaitValue(value)
        };
    }
    /**
     * Close this store. All subscribers will be unsubscribed and any further operations will fail
     */ close() {
        this.observable.close();
    }
}



class $d5f49b0a50618e97$export$2e2bcd8739ae039 {
    constructor(){
        this.awaiter = [];
    }
    sendSignal() {
        this.awaiter.forEach((a)=>a());
        this.awaiter = [];
    }
    awaitSignal() {
        return new Promise((resolve)=>{
            this.awaiter.push(resolve);
        });
    }
}


var $90dc53da6b3695a8$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $90dc53da6b3695a8$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
};
var $90dc53da6b3695a8$var$_onClose, $90dc53da6b3695a8$var$_onData;
class $90dc53da6b3695a8$export$2e2bcd8739ae039 {
    constructor(){
        $90dc53da6b3695a8$var$_onClose.set(this, []);
        $90dc53da6b3695a8$var$_onData.set(this, new (0, $e8eab699cb9bf42c$export$2e2bcd8739ae039)());
    }
    onClose(callback) {
        $90dc53da6b3695a8$var$__classPrivateFieldGet(this, $90dc53da6b3695a8$var$_onClose).push(callback);
    }
    getCallback() {
        return (error, data)=>{
            $90dc53da6b3695a8$var$__classPrivateFieldGet(this, $90dc53da6b3695a8$var$_onData).send({
                error: error,
                data: data,
                close: undefined
            });
        };
    }
    send(data) {
        $90dc53da6b3695a8$var$__classPrivateFieldGet(this, $90dc53da6b3695a8$var$_onData).send({
            error: undefined,
            data: data,
            close: undefined
        });
    }
    close() {
        $90dc53da6b3695a8$var$__classPrivateFieldGet(this, $90dc53da6b3695a8$var$_onData).send({
            close: true,
            data: undefined,
            error: undefined
        });
        $90dc53da6b3695a8$var$__classPrivateFieldGet(this, $90dc53da6b3695a8$var$_onData).close();
        $90dc53da6b3695a8$var$__classPrivateFieldGet(this, $90dc53da6b3695a8$var$_onClose).forEach((cb)=>cb());
    }
    [($90dc53da6b3695a8$var$_onClose = new WeakMap(), $90dc53da6b3695a8$var$_onData = new WeakMap(), Symbol.asyncIterator)]() {
        const queue = [];
        const signal = new (0, $d5f49b0a50618e97$export$2e2bcd8739ae039)();
        $90dc53da6b3695a8$var$__classPrivateFieldGet(this, $90dc53da6b3695a8$var$_onData).subscribe((data)=>{
            queue.push(data);
            signal.sendSignal();
        });
        return {
            next () {
                return $90dc53da6b3695a8$var$__awaiter(this, void 0, void 0, function*() {
                    const send = ()=>{
                        const value = queue.shift();
                        if (!value) throw new Error("Error in AsyncIter");
                        if (value.close) return {
                            done: true,
                            value: undefined
                        };
                        else if (value.error) throw value.error;
                        else return {
                            done: false,
                            value: value.data
                        };
                    };
                    if (queue.length > 0) return send();
                    else {
                        yield signal.awaitSignal();
                        return send();
                    }
                });
            }
        };
    }
}





const $bbe306abd77ff1e3$export$db3b6bfb95261072 = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $bbe306abd77ff1e3$var$idbProxyableTypes;
let $bbe306abd77ff1e3$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $bbe306abd77ff1e3$var$getIdbProxyableTypes() {
    return $bbe306abd77ff1e3$var$idbProxyableTypes || ($bbe306abd77ff1e3$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $bbe306abd77ff1e3$var$getCursorAdvanceMethods() {
    return $bbe306abd77ff1e3$var$cursorAdvanceMethods || ($bbe306abd77ff1e3$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $bbe306abd77ff1e3$var$cursorRequestMap = new WeakMap();
const $bbe306abd77ff1e3$var$transactionDoneMap = new WeakMap();
const $bbe306abd77ff1e3$var$transactionStoreNamesMap = new WeakMap();
const $bbe306abd77ff1e3$var$transformCache = new WeakMap();
const $bbe306abd77ff1e3$export$4368d992c4eafac0 = new WeakMap();
function $bbe306abd77ff1e3$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($bbe306abd77ff1e3$export$407448d2b89b1813(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $bbe306abd77ff1e3$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $bbe306abd77ff1e3$export$4368d992c4eafac0.set(promise, request);
    return promise;
}
function $bbe306abd77ff1e3$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($bbe306abd77ff1e3$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error);
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $bbe306abd77ff1e3$var$transactionDoneMap.set(tx, done);
}
let $bbe306abd77ff1e3$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $bbe306abd77ff1e3$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $bbe306abd77ff1e3$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $bbe306abd77ff1e3$export$407448d2b89b1813(target[prop]);
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $bbe306abd77ff1e3$export$8b22cf2602fb60ce(callback) {
    $bbe306abd77ff1e3$var$idbProxyTraps = callback($bbe306abd77ff1e3$var$idbProxyTraps);
}
function $bbe306abd77ff1e3$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($bbe306abd77ff1e3$export$f1e1789686576879(this), storeNames, ...args);
        $bbe306abd77ff1e3$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $bbe306abd77ff1e3$export$407448d2b89b1813(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($bbe306abd77ff1e3$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($bbe306abd77ff1e3$export$f1e1789686576879(this), args);
        return $bbe306abd77ff1e3$export$407448d2b89b1813($bbe306abd77ff1e3$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $bbe306abd77ff1e3$export$407448d2b89b1813(func.apply($bbe306abd77ff1e3$export$f1e1789686576879(this), args));
    };
}
function $bbe306abd77ff1e3$var$transformCachableValue(value) {
    if (typeof value === "function") return $bbe306abd77ff1e3$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $bbe306abd77ff1e3$var$cacheDonePromiseForTransaction(value);
    if ($bbe306abd77ff1e3$export$db3b6bfb95261072(value, $bbe306abd77ff1e3$var$getIdbProxyableTypes())) return new Proxy(value, $bbe306abd77ff1e3$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $bbe306abd77ff1e3$export$407448d2b89b1813(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $bbe306abd77ff1e3$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($bbe306abd77ff1e3$var$transformCache.has(value)) return $bbe306abd77ff1e3$var$transformCache.get(value);
    const newValue = $bbe306abd77ff1e3$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $bbe306abd77ff1e3$var$transformCache.set(value, newValue);
        $bbe306abd77ff1e3$export$4368d992c4eafac0.set(newValue, value);
    }
    return newValue;
}
const $bbe306abd77ff1e3$export$f1e1789686576879 = (value)=>$bbe306abd77ff1e3$export$4368d992c4eafac0.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $6b5215e7a1b75948$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $bbe306abd77ff1e3$export$407448d2b89b1813)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, $bbe306abd77ff1e3$export$407448d2b89b1813)(request.result), event.oldVersion, event.newVersion, (0, $bbe306abd77ff1e3$export$407448d2b89b1813)(request.transaction));
    });
    if (blocked) request.addEventListener("blocked", ()=>blocked());
    if (blocking) openPromise.then((db)=>db.addEventListener("versionchange", blocking)).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $6b5215e7a1b75948$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", ()=>blocked());
    return (0, $bbe306abd77ff1e3$export$407448d2b89b1813)(request).then(()=>undefined);
}
const $6b5215e7a1b75948$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $6b5215e7a1b75948$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $6b5215e7a1b75948$var$cachedMethods = new Map();
function $6b5215e7a1b75948$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($6b5215e7a1b75948$var$cachedMethods.get(prop)) return $6b5215e7a1b75948$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $6b5215e7a1b75948$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $6b5215e7a1b75948$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        const returnVal = target[targetFuncName](...args);
        if (isWrite) await tx.done;
        return returnVal;
    };
    $6b5215e7a1b75948$var$cachedMethods.set(prop, method);
    return method;
}
(0, $bbe306abd77ff1e3$export$8b22cf2602fb60ce)((oldTraps)=>({
        get: (target, prop, receiver)=>$6b5215e7a1b75948$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$6b5215e7a1b75948$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


class $4672ca3638a76ec7$var$IDB {
    constructor(database, stores, upgrade_fkt){
        this.stores = stores;
        this.initLock = new $46b246f610bc4d5f$export$2e2bcd8739ae039();
        this.initLock.getLock().then(async (l)=>{
            let v = localStorage.getItem(database + "_version");
            let version = 0;
            if (v) version = Number(v);
            let lastStoresS = localStorage.getItem(database + "_stores");
            if (!lastStoresS) lastStoresS = "";
            let lastStores = lastStoresS.split(",").filter((e)=>e !== "");
            if (!stores.every((e)=>lastStores.indexOf(e) >= 0) || !lastStores.every((e)=>stores.indexOf(e) >= 0)) version++;
            localStorage.setItem(database + "_version", version.toString());
            localStorage.setItem(database + "_stores", stores.join(","));
            this.db = await (0, $6b5215e7a1b75948$export$ca0ed41b1a2af7e)(database, version, {
                upgrade: (db)=>{
                    console.log("IndexedDB need update");
                    const check = (name)=>db.objectStoreNames.contains ? db.objectStoreNames.contains(name) : db.objectStoreNames.find((e)=>e === name);
                    stores.forEach((store)=>{
                        if (!check(store)) db.createObjectStore(store);
                    });
                }
            });
            console.log("Got DATABASE", this.db);
            l.release();
            if (upgrade_fkt) upgrade_fkt(this.db.transaction(stores, "readwrite"));
        });
    }
    async transaction(...stores) {
        if (stores.length < 1) stores = this.stores;
        let s;
        if (typeof stores[0] === "string") s = stores;
        else s = stores.map((e)=>e.name);
        (await this.initLock.getLock()).release();
        return this.db.transaction(s, "readwrite");
    }
    getStore(name) {
        return {
            name: name,
            transaction: async ()=>{
                (await this.initLock.getLock()).release();
                return this.db.transaction(name, "readwrite");
            },
            get: async (key, transaction)=>{
                (await this.initLock.getLock()).release();
                return (transaction || this.db.transaction(name)).objectStore(name).get(key);
            },
            getAll: async (transaction)=>{
                (await this.initLock.getLock()).release();
                return (transaction || this.db.transaction(name)).objectStore(name).getAll();
            },
            set: async (key, val, transaction)=>{
                (await this.initLock.getLock()).release();
                const tx = transaction || this.db.transaction(name, "readwrite");
                return tx.objectStore(name).put(val, key);
            // return tx.done;
            },
            delete: async (key, transaction)=>{
                (await this.initLock.getLock()).release();
                const tx = transaction || this.db.transaction(name, "readwrite");
                return tx.objectStore(name).delete(key);
            // return tx.done;
            },
            clear: async (transaction)=>{
                (await this.initLock.getLock()).release();
                const tx = transaction || this.db.transaction(name, "readwrite");
                return tx.objectStore(name).clear();
            // return tx.done;
            },
            keys: async (transaction)=>{
                (await this.initLock.getLock()).release();
                const tx = transaction || this.db.transaction(name);
                const store = tx.objectStore(name);
                return store.getAllKeys().then((res)=>res.map((e)=>e.toString()));
            }
        };
    }
}
$4672ca3638a76ec7$exports.default = $4672ca3638a76ec7$var$IDB;




var $365fd75a9a8bbb7f$export$a3d46f0bb1b148e5;
(function(LoggingTypes) {
    LoggingTypes[LoggingTypes["Debug"] = 0] = "Debug";
    LoggingTypes[LoggingTypes["Log"] = 1] = "Log";
    LoggingTypes[LoggingTypes["Warning"] = 2] = "Warning";
    LoggingTypes[LoggingTypes["Error"] = 3] = "Error";
})($365fd75a9a8bbb7f$export$a3d46f0bb1b148e5 || ($365fd75a9a8bbb7f$export$a3d46f0bb1b148e5 = {}));
const $365fd75a9a8bbb7f$export$ba6e9f03e4136c09 = {
    Reset: "\x1b[0m",
    Bold: "\x1b[1m",
    Underscore: "\x1b[4m",
    Blink: "\x1b[5m",
    Reverse: "\x1b[7m",
    Hidden: "\x1b[8m",
    FgBlack: "\x1b[30m",
    FgRed: "\x1b[31m",
    FgGreen: "\x1b[32m",
    FgYellow: "\x1b[33m",
    FgBlue: "\x1b[34m",
    FgMagenta: "\x1b[35m",
    FgCyan: "\x1b[36m",
    FgWhite: "\x1b[37m",
    BgBlack: "\x1b[40m",
    BgRed: "\x1b[41m",
    BgGreen: "\x1b[42m",
    BgYellow: "\x1b[43m",
    BgBlue: "\x1b[44m",
    BgMagenta: "\x1b[45m",
    BgCyan: "\x1b[46m",
    BgWhite: "\x1b[47m"
};
var $365fd75a9a8bbb7f$export$f010f239efc4d445;
(function(FormatTypes) {
    FormatTypes[FormatTypes["COLOR"] = 0] = "COLOR";
    FormatTypes[FormatTypes["BOLD"] = 1] = "BOLD";
    FormatTypes[FormatTypes["UNDERSCORE"] = 2] = "UNDERSCORE";
    FormatTypes[FormatTypes["BLINK"] = 3] = "BLINK";
})($365fd75a9a8bbb7f$export$f010f239efc4d445 || ($365fd75a9a8bbb7f$export$f010f239efc4d445 = {}));
var $365fd75a9a8bbb7f$export$c537fa0d021d010b;
(function(Colors) {
    Colors[Colors["NONE"] = 0] = "NONE";
    Colors[Colors["RED"] = 1] = "RED";
    Colors[Colors["GREEN"] = 2] = "GREEN";
    Colors[Colors["YELLOW"] = 3] = "YELLOW";
    Colors[Colors["BLUE"] = 4] = "BLUE";
    Colors[Colors["MAGENTA"] = 5] = "MAGENTA";
    Colors[Colors["CYAN"] = 6] = "CYAN";
    Colors[Colors["WHITE"] = 7] = "WHITE";
})($365fd75a9a8bbb7f$export$c537fa0d021d010b || ($365fd75a9a8bbb7f$export$c537fa0d021d010b = {}));
function $365fd75a9a8bbb7f$var$colorFormat(color) {
    return {
        type: $365fd75a9a8bbb7f$export$f010f239efc4d445.COLOR,
        color: color
    };
}
const $365fd75a9a8bbb7f$var$boldFormat = {
    type: $365fd75a9a8bbb7f$export$f010f239efc4d445.BOLD
};
class $365fd75a9a8bbb7f$export$1abd5c3e02935dac {
    constructor(){
        this.error = [
            $365fd75a9a8bbb7f$var$colorFormat($365fd75a9a8bbb7f$export$c537fa0d021d010b.RED),
            $365fd75a9a8bbb7f$var$boldFormat
        ];
        this.warning = [
            $365fd75a9a8bbb7f$var$colorFormat($365fd75a9a8bbb7f$export$c537fa0d021d010b.YELLOW),
            $365fd75a9a8bbb7f$var$boldFormat
        ];
        this.log = [
            $365fd75a9a8bbb7f$var$colorFormat($365fd75a9a8bbb7f$export$c537fa0d021d010b.NONE),
            $365fd75a9a8bbb7f$var$boldFormat
        ];
        this.debug = [
            $365fd75a9a8bbb7f$var$colorFormat($365fd75a9a8bbb7f$export$c537fa0d021d010b.CYAN),
            $365fd75a9a8bbb7f$var$boldFormat
        ];
        this.date = [
            $365fd75a9a8bbb7f$var$colorFormat($365fd75a9a8bbb7f$export$c537fa0d021d010b.NONE)
        ];
        this.file = [
            $365fd75a9a8bbb7f$var$colorFormat($365fd75a9a8bbb7f$export$c537fa0d021d010b.NONE)
        ];
    }
}


const $60c5eee14646e14a$var$browser = typeof window !== "undefined" && typeof Deno === "undefined";
class $60c5eee14646e14a$export$c3b072b48cd5b818 {
    constructor(colors = true){
        this.colors = colors;
    }
    init(observable) {
        observable.subscribe(this.onMessage.bind(this));
    }
    flush() {}
    // TODO: Check if required!
    // private escape(text: string): string {
    //    return text
    //       .replace(/%s/g, "%%s")
    //       .replace(/%c/g, "%%c")
    // }
    formatLine(line) {
        let text = "";
        let style_formats = [];
        if (!$60c5eee14646e14a$var$browser) for (let part of line){
            let formats = "";
            for (let format of part.formats)switch(format.type){
                case (0, $365fd75a9a8bbb7f$export$f010f239efc4d445).BOLD:
                    formats += (0, $365fd75a9a8bbb7f$export$ba6e9f03e4136c09).Bold;
                    break;
                case (0, $365fd75a9a8bbb7f$export$f010f239efc4d445).UNDERSCORE:
                    formats += (0, $365fd75a9a8bbb7f$export$ba6e9f03e4136c09).Underscore;
                    break;
                case (0, $365fd75a9a8bbb7f$export$f010f239efc4d445).BLINK:
                    formats += (0, $365fd75a9a8bbb7f$export$ba6e9f03e4136c09).Blink;
                    break;
                case (0, $365fd75a9a8bbb7f$export$f010f239efc4d445).COLOR:
                    switch(format.color){
                        case (0, $365fd75a9a8bbb7f$export$c537fa0d021d010b).RED:
                            formats += (0, $365fd75a9a8bbb7f$export$ba6e9f03e4136c09).FgRed;
                            break;
                        case (0, $365fd75a9a8bbb7f$export$c537fa0d021d010b).GREEN:
                            formats += (0, $365fd75a9a8bbb7f$export$ba6e9f03e4136c09).FgGreen;
                            break;
                        case (0, $365fd75a9a8bbb7f$export$c537fa0d021d010b).YELLOW:
                            formats += (0, $365fd75a9a8bbb7f$export$ba6e9f03e4136c09).FgYellow;
                            break;
                        case (0, $365fd75a9a8bbb7f$export$c537fa0d021d010b).BLUE:
                            formats += (0, $365fd75a9a8bbb7f$export$ba6e9f03e4136c09).FgBlue;
                            break;
                        case (0, $365fd75a9a8bbb7f$export$c537fa0d021d010b).MAGENTA:
                            formats += (0, $365fd75a9a8bbb7f$export$ba6e9f03e4136c09).FgMagenta;
                            break;
                        case (0, $365fd75a9a8bbb7f$export$c537fa0d021d010b).CYAN:
                            formats += (0, $365fd75a9a8bbb7f$export$ba6e9f03e4136c09).FgCyan;
                            break;
                        case (0, $365fd75a9a8bbb7f$export$c537fa0d021d010b).WHITE:
                            formats += (0, $365fd75a9a8bbb7f$export$ba6e9f03e4136c09).FgWhite;
                            break;
                    }
                    break;
            }
            text += formats + part.text + (0, $365fd75a9a8bbb7f$export$ba6e9f03e4136c09).Reset;
        }
        else for (let part of line){
            let styles = [];
            let resetStyles = [];
            for (let format of part.formats)switch(format.type){
                case (0, $365fd75a9a8bbb7f$export$f010f239efc4d445).BOLD:
                    styles.push("font-weight: bold;");
                    resetStyles.push("font-weight: unset");
                    break;
                case (0, $365fd75a9a8bbb7f$export$f010f239efc4d445).UNDERSCORE:
                    styles.push("text-decoration: underline");
                    resetStyles.push("text-decoration: unset");
                    break;
                case (0, $365fd75a9a8bbb7f$export$f010f239efc4d445).BLINK:
                    styles.push("text-decoration: blink");
                    resetStyles.push("text-decoration: unset");
                    break;
                case (0, $365fd75a9a8bbb7f$export$f010f239efc4d445).COLOR:
                    let color = "";
                    switch(format.color){
                        case (0, $365fd75a9a8bbb7f$export$c537fa0d021d010b).RED:
                            color = "red";
                            break;
                        case (0, $365fd75a9a8bbb7f$export$c537fa0d021d010b).GREEN:
                            color = "green";
                            break;
                        case (0, $365fd75a9a8bbb7f$export$c537fa0d021d010b).YELLOW:
                            color = "gold";
                            break;
                        case (0, $365fd75a9a8bbb7f$export$c537fa0d021d010b).BLUE:
                            color = "blue";
                            break;
                        case (0, $365fd75a9a8bbb7f$export$c537fa0d021d010b).MAGENTA:
                            color = "magenta";
                            break;
                        case (0, $365fd75a9a8bbb7f$export$c537fa0d021d010b).CYAN:
                            color = "cyan";
                            break;
                        case (0, $365fd75a9a8bbb7f$export$c537fa0d021d010b).WHITE:
                            color = "white";
                            break;
                    }
                    styles.push("color: " + color);
                    resetStyles.push("color: unset");
                    break;
            }
            text += "%c" + part.text.replace(/%c/g, "%%c") + "%c";
            style_formats.push(styles.join(";"), resetStyles.join(";"));
        }
        return [
            text,
            style_formats
        ];
    }
    onMessage(message) {
        let lines = message.text.formatted;
        let prefix = "";
        if (message.name) prefix = `[${message.name}]=>`;
        if ($60c5eee14646e14a$var$browser) {
            if (this.colors) {
                let formats = [];
                let text = lines.map((line)=>{
                    let [t, fmts] = this.formatLine(line);
                    formats.push(...fmts);
                    return prefix + t;
                }).join("\n");
                // console.log(formats);
                console.log(text, ...formats);
            } else console.log(message.text.raw.join("\n"));
        } else if (this.colors) lines.forEach((line)=>{
            let [text] = this.formatLine(line);
            console.log(prefix + text);
        });
        else message.text.raw.forEach((line)=>console.log(prefix + line));
    }
}


/**
 * Module exports.
 */ /**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 * @license MIT (© Joyent)
 */ /* legacy: obj, showHidden, depth, colors*/ function $118b38c65580de59$export$2e2bcd8739ae039(obj, opts) {
    // default options
    let ctx = {
        seen: [],
        stylize: $118b38c65580de59$var$stylizeNoColor,
        depth: undefined,
        colors: undefined,
        showHidden: undefined,
        customInspect: undefined
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($118b38c65580de59$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    $118b38c65580de59$var$_extend(ctx, opts);
    // set default options
    if ($118b38c65580de59$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($118b38c65580de59$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($118b38c65580de59$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($118b38c65580de59$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $118b38c65580de59$var$stylizeWithColor;
    return $118b38c65580de59$var$formatValue(ctx, obj, ctx.depth);
}
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$118b38c65580de59$export$2e2bcd8739ae039.colors = {
    bold: [
        1,
        22
    ],
    italic: [
        3,
        23
    ],
    underline: [
        4,
        24
    ],
    inverse: [
        7,
        27
    ],
    white: [
        37,
        39
    ],
    grey: [
        90,
        39
    ],
    black: [
        30,
        39
    ],
    blue: [
        34,
        39
    ],
    cyan: [
        36,
        39
    ],
    green: [
        32,
        39
    ],
    magenta: [
        35,
        39
    ],
    red: [
        31,
        39
    ],
    yellow: [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$118b38c65580de59$export$2e2bcd8739ae039.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    // "name": intentionally not styling
    regexp: "red"
};
function $118b38c65580de59$var$stylizeNoColor(str, styleType) {
    return str;
}
function $118b38c65580de59$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
function $118b38c65580de59$var$isUndefined(arg) {
    return arg === void 0;
}
function $118b38c65580de59$var$stylizeWithColor(str, styleType) {
    var style = $118b38c65580de59$export$2e2bcd8739ae039.styles[styleType];
    if (style) return "\x1b[" + $118b38c65580de59$export$2e2bcd8739ae039.colors[style][0] + "m" + str + "\x1b[" + $118b38c65580de59$export$2e2bcd8739ae039.colors[style][1] + "m";
    else return str;
}
function $118b38c65580de59$var$isFunction(arg) {
    return typeof arg === "function";
}
function $118b38c65580de59$var$isString(arg) {
    return typeof arg === "string";
}
function $118b38c65580de59$var$isNumber(arg) {
    return typeof arg === "number";
}
function $118b38c65580de59$var$isNull(arg) {
    return arg === null;
}
function $118b38c65580de59$var$hasOwn(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function $118b38c65580de59$var$isRegExp(re) {
    return $118b38c65580de59$var$isObject(re) && $118b38c65580de59$var$objectToString(re) === "[object RegExp]";
}
function $118b38c65580de59$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
function $118b38c65580de59$var$isError(e) {
    return $118b38c65580de59$var$isObject(e) && ($118b38c65580de59$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
function $118b38c65580de59$var$isDate(d) {
    return $118b38c65580de59$var$isObject(d) && $118b38c65580de59$var$objectToString(d) === "[object Date]";
}
function $118b38c65580de59$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $118b38c65580de59$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $118b38c65580de59$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($118b38c65580de59$var$hasOwn(value, String(i))) output.push($118b38c65580de59$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($118b38c65580de59$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $118b38c65580de59$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $118b38c65580de59$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $118b38c65580de59$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== $118b38c65580de59$export$2e2bcd8739ae039 && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$118b38c65580de59$var$isString(ret)) ret = $118b38c65580de59$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $118b38c65580de59$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $118b38c65580de59$var$arrayToHash(keys);
    try {
        if (ctx.showHidden && Object.getOwnPropertyNames) keys = Object.getOwnPropertyNames(value);
    } catch (e) {
    // ignore
    }
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($118b38c65580de59$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $118b38c65580de59$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($118b38c65580de59$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($118b38c65580de59$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($118b38c65580de59$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($118b38c65580de59$var$isError(value)) return $118b38c65580de59$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if (Array.isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($118b38c65580de59$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($118b38c65580de59$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($118b38c65580de59$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($118b38c65580de59$var$isError(value)) base = " " + $118b38c65580de59$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($118b38c65580de59$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $118b38c65580de59$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $118b38c65580de59$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $118b38c65580de59$var$reduceToSingleString(output, base, braces);
}
function $118b38c65580de59$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = {
        value: void 0
    };
    try {
        // ie6 › navigator.toString
        // throws Error: Object doesn't support this property or method
        desc.value = value[key];
    } catch (e) {
    // ignore
    }
    try {
        // ie10 › Object.getOwnPropertyDescriptor(window.location, 'hash')
        // throws TypeError: Object doesn't support this action
        if (Object.getOwnPropertyDescriptor) desc = Object.getOwnPropertyDescriptor(value, key) || desc;
    } catch (e) {
    // ignore
    }
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$118b38c65580de59$var$hasOwn(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($118b38c65580de59$var$isNull(recurseTimes)) str = $118b38c65580de59$var$formatValue(ctx, desc.value, null);
            else str = $118b38c65580de59$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").substr(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($118b38c65580de59$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.substr(1, name.length - 2);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $118b38c65580de59$var$formatPrimitive(ctx, value) {
    if ($118b38c65580de59$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($118b38c65580de59$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($118b38c65580de59$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($118b38c65580de59$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($118b38c65580de59$var$isNull(value)) return ctx.stylize("null", "null");
}
function $118b38c65580de59$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}
function $118b38c65580de59$var$_extend(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$118b38c65580de59$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
}



var $c68e419b2a37d2b9$exports = {};
// shim for using process in browser
var $c68e419b2a37d2b9$var$process = $c68e419b2a37d2b9$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $c68e419b2a37d2b9$var$cachedSetTimeout;
var $c68e419b2a37d2b9$var$cachedClearTimeout;
function $c68e419b2a37d2b9$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $c68e419b2a37d2b9$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $c68e419b2a37d2b9$var$cachedSetTimeout = setTimeout;
        else $c68e419b2a37d2b9$var$cachedSetTimeout = $c68e419b2a37d2b9$var$defaultSetTimout;
    } catch (e) {
        $c68e419b2a37d2b9$var$cachedSetTimeout = $c68e419b2a37d2b9$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $c68e419b2a37d2b9$var$cachedClearTimeout = clearTimeout;
        else $c68e419b2a37d2b9$var$cachedClearTimeout = $c68e419b2a37d2b9$var$defaultClearTimeout;
    } catch (e) {
        $c68e419b2a37d2b9$var$cachedClearTimeout = $c68e419b2a37d2b9$var$defaultClearTimeout;
    }
})();
function $c68e419b2a37d2b9$var$runTimeout(fun) {
    if ($c68e419b2a37d2b9$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($c68e419b2a37d2b9$var$cachedSetTimeout === $c68e419b2a37d2b9$var$defaultSetTimout || !$c68e419b2a37d2b9$var$cachedSetTimeout) && setTimeout) {
        $c68e419b2a37d2b9$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $c68e419b2a37d2b9$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $c68e419b2a37d2b9$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $c68e419b2a37d2b9$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $c68e419b2a37d2b9$var$runClearTimeout(marker) {
    if ($c68e419b2a37d2b9$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($c68e419b2a37d2b9$var$cachedClearTimeout === $c68e419b2a37d2b9$var$defaultClearTimeout || !$c68e419b2a37d2b9$var$cachedClearTimeout) && clearTimeout) {
        $c68e419b2a37d2b9$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $c68e419b2a37d2b9$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $c68e419b2a37d2b9$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $c68e419b2a37d2b9$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $c68e419b2a37d2b9$var$queue = [];
var $c68e419b2a37d2b9$var$draining = false;
var $c68e419b2a37d2b9$var$currentQueue;
var $c68e419b2a37d2b9$var$queueIndex = -1;
function $c68e419b2a37d2b9$var$cleanUpNextTick() {
    if (!$c68e419b2a37d2b9$var$draining || !$c68e419b2a37d2b9$var$currentQueue) return;
    $c68e419b2a37d2b9$var$draining = false;
    if ($c68e419b2a37d2b9$var$currentQueue.length) $c68e419b2a37d2b9$var$queue = $c68e419b2a37d2b9$var$currentQueue.concat($c68e419b2a37d2b9$var$queue);
    else $c68e419b2a37d2b9$var$queueIndex = -1;
    if ($c68e419b2a37d2b9$var$queue.length) $c68e419b2a37d2b9$var$drainQueue();
}
function $c68e419b2a37d2b9$var$drainQueue() {
    if ($c68e419b2a37d2b9$var$draining) return;
    var timeout = $c68e419b2a37d2b9$var$runTimeout($c68e419b2a37d2b9$var$cleanUpNextTick);
    $c68e419b2a37d2b9$var$draining = true;
    var len = $c68e419b2a37d2b9$var$queue.length;
    while(len){
        $c68e419b2a37d2b9$var$currentQueue = $c68e419b2a37d2b9$var$queue;
        $c68e419b2a37d2b9$var$queue = [];
        while(++$c68e419b2a37d2b9$var$queueIndex < len)if ($c68e419b2a37d2b9$var$currentQueue) $c68e419b2a37d2b9$var$currentQueue[$c68e419b2a37d2b9$var$queueIndex].run();
        $c68e419b2a37d2b9$var$queueIndex = -1;
        len = $c68e419b2a37d2b9$var$queue.length;
    }
    $c68e419b2a37d2b9$var$currentQueue = null;
    $c68e419b2a37d2b9$var$draining = false;
    $c68e419b2a37d2b9$var$runClearTimeout(timeout);
}
$c68e419b2a37d2b9$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $c68e419b2a37d2b9$var$queue.push(new $c68e419b2a37d2b9$var$Item(fun, args));
    if ($c68e419b2a37d2b9$var$queue.length === 1 && !$c68e419b2a37d2b9$var$draining) $c68e419b2a37d2b9$var$runTimeout($c68e419b2a37d2b9$var$drainQueue);
};
// v8 likes predictible objects
function $c68e419b2a37d2b9$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$c68e419b2a37d2b9$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$c68e419b2a37d2b9$var$process.title = "browser";
$c68e419b2a37d2b9$var$process.browser = true;
$c68e419b2a37d2b9$var$process.env = {};
$c68e419b2a37d2b9$var$process.argv = [];
$c68e419b2a37d2b9$var$process.version = ""; // empty string to avoid regexp issues
$c68e419b2a37d2b9$var$process.versions = {};
function $c68e419b2a37d2b9$var$noop() {}
$c68e419b2a37d2b9$var$process.on = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.addListener = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.once = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.off = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.removeListener = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.removeAllListeners = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.emit = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.prependListener = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.prependOnceListener = $c68e419b2a37d2b9$var$noop;
$c68e419b2a37d2b9$var$process.listeners = function(name) {
    return [];
};
$c68e419b2a37d2b9$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$c68e419b2a37d2b9$var$process.cwd = function() {
    return "/";
};
$c68e419b2a37d2b9$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$c68e419b2a37d2b9$var$process.umask = function() {
    return 0;
};


var $0fcaf2d1ae326745$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
};
var $0fcaf2d1ae326745$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
};
var $0fcaf2d1ae326745$var$_closed;
const $0fcaf2d1ae326745$var$browser = typeof window !== "undefined";
function $0fcaf2d1ae326745$export$eb729c9df13ba112(text) {
    text = text.replace(/[\u001b\u009b][[()#;?]*(?:[0-9]{1,4}(?:;[0-9]{0,4})*)?[0-9A-ORZcf-nqry=><]/g, "");
    // let index = text.indexOf("\x1b");
    // while (index >= 0) {
    //     text = text.substring(0, index) + text.substring(index + 5, text.length);
    //     index = text.indexOf("\x1b");
    // }
    return text;
}
const $0fcaf2d1ae326745$var$adapterCache = new WeakMap();
class $0fcaf2d1ae326745$var$AdapterSet {
    constructor(){
        this.change = new (0, $f1f0edacc5982840$export$2e2bcd8739ae039)();
        this.adapters = new Set();
    }
    addAdapter(adapter) {
        if (!this.adapters.has(adapter)) {
            this.adapters.add(adapter);
            this.change.send({
                type: "add",
                adapter: adapter
            });
        }
    }
}
const $0fcaf2d1ae326745$var$consoleAdapter = new (0, $60c5eee14646e14a$export$c3b072b48cd5b818)();
const $0fcaf2d1ae326745$var$PROJECT_ROOT = typeof $c68e419b2a37d2b9$exports !== "undefined" ? $c68e419b2a37d2b9$exports.cwd() : undefined;
class $0fcaf2d1ae326745$export$da7379efd263556f {
    constructor(options, adapterSet){
        this._formatMap = new (0, $365fd75a9a8bbb7f$export$1abd5c3e02935dac)();
        this.adapter_init = [];
        this.timerMap = new Map();
        this.messageObservable = new (0, $f1f0edacc5982840$export$2e2bcd8739ae039)();
        this._logLevel = (0, $365fd75a9a8bbb7f$export$a3d46f0bb1b148e5).Debug;
        $0fcaf2d1ae326745$var$_closed.set(this, false);
        let opt;
        if (!options) opt = {};
        else if (typeof options === "string") opt = {
            name: options
        };
        else opt = options;
        let config = Object.assign({
            name: undefined,
            console: true,
            resolve_filename: true
        }, opt);
        if (config.name) this._name = config.name;
        this.resolve_filename = config.resolve_filename;
        for(let key in this)if (typeof this[key] === "function") this[key] = this[key].bind(this);
        if (adapterSet) {
            this.adapterSet = adapterSet;
            this.adapterSet.adapters.forEach((a)=>this.initAdapter(a));
        } else this.adapterSet = new $0fcaf2d1ae326745$var$AdapterSet();
        this.adapterSet.change.subscribe((change)=>{
            if (change.type === "add") this.initAdapter(change.adapter);
        });
        if (config.console) this.addAdapter($0fcaf2d1ae326745$var$consoleAdapter);
        //Binding function to this
        this.debug = this.debug.bind(this);
        this.log = this.log.bind(this);
        this.warn = this.warn.bind(this);
        this.warning = this.warning.bind(this);
        this.error = this.error.bind(this);
        this.errorMessage = this.errorMessage.bind(this);
        this.flush = this.flush.bind(this);
    }
    set formatMap(value) {
        this._formatMap = value;
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(value) {
        this._logLevel = value;
    }
    get name() {
        return this._name;
    }
    /**
     * Can be used to override function from super class
     * @param child New child logging instance
     */ postGetChild(child) {}
    /**
     * Creates a new logging instance, with the adapters liked together.
     * @param name Name/Prefix of the new child. The actual name will resolve as "<parent-name>/<name>"
     */ getChild(name) {
        let lg = new $0fcaf2d1ae326745$export$da7379efd263556f({
            console: false,
            name: this.name ? this.name + "/" + name : name
        }, this.adapterSet);
        return lg;
    }
    initAdapter(adapter) {
        let cached = $0fcaf2d1ae326745$var$adapterCache.get(adapter) || 0;
        $0fcaf2d1ae326745$var$adapterCache.set(adapter, cached + 1);
        let prms = Promise.resolve(adapter.init(this.messageObservable.getPublicApi()));
        this.adapter_init.push(prms);
    }
    addAdapter(adapter) {
        this.adapterSet.addAdapter(adapter);
    }
    flush(sync) {
        if (sync) this.adapterSet.adapters.forEach((elm)=>elm.flush(true));
        else {
            let adapters = [];
            this.adapterSet.adapters.forEach((elm)=>adapters.push(elm.flush(false)));
            return Promise.all(adapters).then(()=>{});
        }
    }
    close() {
        if ($0fcaf2d1ae326745$var$__classPrivateFieldGet(this, $0fcaf2d1ae326745$var$_closed)) return;
        $0fcaf2d1ae326745$var$__classPrivateFieldSet(this, $0fcaf2d1ae326745$var$_closed, true);
        this.adapterSet.adapters.forEach((adapter)=>{
            let cached = $0fcaf2d1ae326745$var$adapterCache.get(adapter);
            if (cached) {
                cached--;
                if (cached <= 0) {
                    $0fcaf2d1ae326745$var$adapterCache.delete(adapter);
                    adapter.close();
                } else $0fcaf2d1ae326745$var$adapterCache.set(adapter, cached);
            }
            adapter.close ? adapter.close() : undefined;
        });
        this.adapterSet = undefined;
        this.messageObservable.close();
    }
    waitForSetup() {
        return Promise.all(this.adapter_init);
    }
    debug(...message) {
        if (this._logLevel <= (0, $365fd75a9a8bbb7f$export$a3d46f0bb1b148e5).Debug) this.message((0, $365fd75a9a8bbb7f$export$a3d46f0bb1b148e5).Debug, message);
    }
    log(...message) {
        if (this._logLevel <= (0, $365fd75a9a8bbb7f$export$a3d46f0bb1b148e5).Log) this.message((0, $365fd75a9a8bbb7f$export$a3d46f0bb1b148e5).Log, message);
    }
    warning(...message) {
        if (this._logLevel <= (0, $365fd75a9a8bbb7f$export$a3d46f0bb1b148e5).Warning) this.message((0, $365fd75a9a8bbb7f$export$a3d46f0bb1b148e5).Warning, message);
    }
    warn(...message) {
        if (this._logLevel <= (0, $365fd75a9a8bbb7f$export$a3d46f0bb1b148e5).Warning) this.message((0, $365fd75a9a8bbb7f$export$a3d46f0bb1b148e5).Warning, message);
    }
    error(error, ...message) {
        if (this._logLevel > (0, $365fd75a9a8bbb7f$export$a3d46f0bb1b148e5).Error) return;
        if (!error) error = "Empty ERROR was passed, so no informations available";
        if (typeof error === "string") {
            let e = new Error("This is a fake error, to get a stack trace");
            this.message((0, $365fd75a9a8bbb7f$export$a3d46f0bb1b148e5).Error, [
                error,
                "\n",
                e.stack,
                "\n",
                ...message
            ]);
        } else this.message((0, $365fd75a9a8bbb7f$export$a3d46f0bb1b148e5).Error, [
            error.message,
            "\n",
            error.stack,
            "\n",
            ...message
        ], $0fcaf2d1ae326745$var$getCallerFromExisting(error));
    }
    errorMessage(...message) {
        if (this._logLevel <= (0, $365fd75a9a8bbb7f$export$a3d46f0bb1b148e5).Error) this.message((0, $365fd75a9a8bbb7f$export$a3d46f0bb1b148e5).Error, message);
    }
    getCurrentTime() {
        if ($0fcaf2d1ae326745$var$browser && window.performance && window.performance.now) return window.performance.now();
        else return Date.now();
    }
    /**
     * The time difference in milliseconds (fractions allowed!)
     * @param start Start time from getCurrentTime
     */ getTimeDiff(start) {
        if ($0fcaf2d1ae326745$var$browser && window.performance && window.performance.now) return window.performance.now() - start;
        else return Date.now() - start;
    }
    time(id, name = id) {
        if (!id) id = Math.floor(Math.random() * 899999 + 100000).toString();
        this.timerMap.set(id, {
            name: name,
            start: this.getCurrentTime()
        });
        return {
            id: id,
            end: ()=>this.timeEnd(id)
        };
    }
    timeEnd(id) {
        let timer = this.timerMap.get(id);
        if (timer) {
            let diff = this.getTimeDiff(timer.start);
            this.message((0, $365fd75a9a8bbb7f$export$a3d46f0bb1b148e5).Debug, [
                $0fcaf2d1ae326745$export$92406961568d7fbf((0, $365fd75a9a8bbb7f$export$c537fa0d021d010b).GREEN, `[${timer.name}]`),
                `->`,
                $0fcaf2d1ae326745$export$92406961568d7fbf((0, $365fd75a9a8bbb7f$export$c537fa0d021d010b).BLUE, diff.toFixed(4)),
                "ms"
            ]);
            return diff;
        }
        return -1;
    }
    message(type, message, caller) {
        if ($0fcaf2d1ae326745$var$__classPrivateFieldGet(this, $0fcaf2d1ae326745$var$_closed)) return;
        let date = new Date().toISOString().replace(/T/, " ").replace(/\..+/, "");
        let file = undefined;
        if (this.resolve_filename) {
            let file_raw = caller;
            if (!file_raw) try {
                file_raw = $0fcaf2d1ae326745$var$getCallerFile();
            } catch (err) {
                file_raw = {
                    file: "<unknown>",
                    line: 0,
                    column: 0
                };
            }
            if ($0fcaf2d1ae326745$var$PROJECT_ROOT && file_raw.file && file_raw.file.startsWith($0fcaf2d1ae326745$var$PROJECT_ROOT)) {
                let newF = file_raw.file.substring($0fcaf2d1ae326745$var$PROJECT_ROOT.length);
                if (newF.startsWith("/") || newF.startsWith("\\")) newF = newF.substring(1);
                file_raw.file = newF;
            }
            file = `${file_raw.file || "<unknown>"}:${file_raw.line}:${file_raw.column || 0}`;
        }
        let type_str = (0, $365fd75a9a8bbb7f$export$a3d46f0bb1b148e5)[type].toUpperCase().padEnd(5, " ");
        let type_format = [];
        switch(type){
            case (0, $365fd75a9a8bbb7f$export$a3d46f0bb1b148e5).Log:
                type_format = this._formatMap.log;
                break;
            case (0, $365fd75a9a8bbb7f$export$a3d46f0bb1b148e5).Error:
                type_format = this._formatMap.error;
                break;
            case (0, $365fd75a9a8bbb7f$export$a3d46f0bb1b148e5).Debug:
                type_format = this._formatMap.debug;
                break;
            case (0, $365fd75a9a8bbb7f$export$a3d46f0bb1b148e5).Warning:
                type_format = this._formatMap.warning;
                break;
        }
        const prefix = [];
        const a = (text, formats = [])=>{
            prefix.push({
                text: text,
                formats: formats
            });
        };
        a("[");
        a(date, this._formatMap.date);
        a("][");
        a(type_str, type_format);
        if (file) {
            a("][");
            a(file, this._formatMap.file);
        }
        a("]: ");
        let raw = [];
        const formatted = [];
        let line;
        const newLine = ()=>{
            if (line && line.length > 0) {
                formatted.push(line);
                raw.push(line.map((e)=>e.text).join(""));
            }
            line = [
                ...prefix
            ];
        };
        newLine();
        message.forEach((e, i)=>{
            let formats = [];
            if (typeof e !== "string") {
                if (e && typeof e === "object") {
                    if (e[$0fcaf2d1ae326745$var$colorSymbol]) {
                        formats.push({
                            type: (0, $365fd75a9a8bbb7f$export$f010f239efc4d445).COLOR,
                            color: e[$0fcaf2d1ae326745$var$colorSymbol]
                        });
                        e = e.value;
                    }
                }
                if (typeof e !== "string") e = (0, $118b38c65580de59$export$2e2bcd8739ae039)(e, {
                    colors: true,
                    showHidden: true,
                    depth: 3
                });
            }
            $0fcaf2d1ae326745$export$eb729c9df13ba112(e).split("\n").map((text, index, { length: length })=>{
                line.push({
                    text: text,
                    formats: formats
                });
                if (index < length - 1) newLine();
            });
            if (!e.endsWith("\n") && i < message.length - 1) line.push({
                text: " ",
                formats: []
            });
        });
        newLine();
        let msg = {
            date: new Date(),
            file: file,
            name: this._name,
            text: {
                raw: raw,
                formatted: formatted
            },
            type: type
        };
        this.messageObservable.send(msg);
    }
}
$0fcaf2d1ae326745$var$_closed = new WeakMap();
const $0fcaf2d1ae326745$var$colorSymbol = Symbol("color");
function $0fcaf2d1ae326745$export$92406961568d7fbf(color, value) {
    return {
        [$0fcaf2d1ae326745$var$colorSymbol]: color,
        value: value
    };
}
function $0fcaf2d1ae326745$var$getStack() {
    // Save original Error.prepareStackTrace
    let origPrepareStackTrace = Error.prepareStackTrace;
    try {
        // Override with function that just returns `stack`
        Error.prepareStackTrace = function(_, stack) {
            return stack;
        };
        // Create a new `Error`, which automatically gets `stack`
        let err = new Error();
        // Evaluate `err.stack`, which calls our new `Error.prepareStackTrace`
        let stack = err.stack;
        return stack;
    } finally{
        // Restore original `Error.prepareStackTrace`
        Error.prepareStackTrace = origPrepareStackTrace;
    }
}
function $0fcaf2d1ae326745$var$getCallerFile() {
    try {
        let stack = $0fcaf2d1ae326745$var$getStack();
        let current_file = stack.shift().getFileName();
        while(stack.length){
            let caller_file = stack.shift();
            if (current_file !== caller_file.getFileName()) return {
                file: caller_file.getFileName(),
                line: caller_file.getLineNumber(),
                column: caller_file.getColumnNumber()
            };
        }
    } catch (err) {}
    return {
        file: undefined,
        line: 0
    };
}
function $0fcaf2d1ae326745$var$getCallerFromExisting(err) {
    if (!err || !err.stack) return {
        file: "NOFILE",
        line: 0
    };
    let lines = err.stack.split("\n");
    lines.shift(); // removing first line
    while(lines.length > 0){
        let line = lines.shift();
        let matches = line.match(/[<]?([a-zA-Z]:)?([\/\\]?[a-zA-Z_-])+[.>][a-zA-Z_-]*([:][0-9]+)+/g);
        if (matches && matches.length > 0) {
            let match = matches[0].trim();
            let locationString = match.match(/([:][0-9]+)+$/gm)[0];
            let line;
            let column;
            if (locationString) {
                match = match.slice(0, match.length - locationString.length);
                locationString = locationString.substring(1);
                [line, column] = locationString.split(":").map(Number);
            }
            let file = match;
            return {
                file: file,
                line: line,
                column: column
            };
        }
    }
}




let $e1de5d3783fa30ff$export$f13b02179817fff = undefined;
$e1de5d3783fa30ff$export$f13b02179817fff = new (0, $0fcaf2d1ae326745$export$da7379efd263556f)();
var $e1de5d3783fa30ff$export$2e2bcd8739ae039 = $e1de5d3783fa30ff$export$f13b02179817fff;


class $b3b9117a88ecf6d3$export$65bd6083489bd8bb extends Error {
    constructor(status, statusText){
        super(statusText);
        this.status = status;
        this.statusText = statusText;
        console.log(statusText);
    }
}
var $b3b9117a88ecf6d3$export$d8ed98235b49d42e;
(function(WorkChangeTypes) {
    WorkChangeTypes[WorkChangeTypes["create_edit"] = 0] = "create_edit";
    WorkChangeTypes[WorkChangeTypes["delete"] = 1] = "delete";
    WorkChangeTypes[WorkChangeTypes["position"] = 2] = "position";
})($b3b9117a88ecf6d3$export$d8ed98235b49d42e || ($b3b9117a88ecf6d3$export$d8ed98235b49d42e = {}));
const $b3b9117a88ecf6d3$var$typeconv = [
    "manually",
    "epub",
    "wattpad",
    "ao3"
];
// const config: { authserver: string, client_id: string } = (<any>window).config;
// if (!config) alert("Configuration not found, please reload!")
const $b3b9117a88ecf6d3$var$ClientVersion = 1;
const $b3b9117a88ecf6d3$var$upgrades = {
    upgradeType: (work)=>{
        if (typeof work.type === "number") {
            work.type = $b3b9117a88ecf6d3$var$typeconv[work.type] || "manually";
            return true;
        }
        return false;
    }
};
class $b3b9117a88ecf6d3$var$EbookStorage {
    constructor(){
        this.idb = new (0, (/*@__PURE__*/$parcel$interopDefault($4672ca3638a76ec7$exports)))("eserver", [
            "works",
            "chapters"
        ]);
        this.chapterdb = this.idb.getStore("chapters");
        this.workdb = this.idb.getStore("works");
        this.databaseLock = new (0, $1ee0f1ea517deac2$export$2e2bcd8739ae039)();
        const lock = this.databaseLock.getLock().then(async (lock)=>this.upgrade().then(()=>lock.release()));
    }
    async upgrade() {
        const clientVersion = Number(localStorage.getItem("client_version") || 0);
        if ($b3b9117a88ecf6d3$var$ClientVersion !== clientVersion) {
            const tx = await this.idb.transaction();
            switch(clientVersion){
                case 0:
                    {
                        const all = await this.workdb.getAll(tx);
                        await Promise.all(all.map(async (elm)=>{
                            if ($b3b9117a88ecf6d3$var$upgrades.upgradeType(elm)) await this.workdb.set(elm._id, elm);
                            return this.chapterdb.get(elm._id, tx).then((res)=>{
                                if (!res) return this.chapterdb.set(elm._id, elm.chapters.map((e)=>({
                                        id: e.id,
                                        content: e.content
                                    })), tx).then(()=>{
                                    elm.chapters.forEach((ch)=>delete ch.content);
                                    return this.workdb.set(elm._id, elm, tx);
                                });
                            });
                        }));
                    }
            }
            localStorage.setItem("client_version", String($b3b9117a88ecf6d3$var$ClientVersion));
        }
    }
    getProgress(work) {
        // console.log("Get Progress", work);
        if (!work.position) return 0;
        let words = work.words || work.chapters.reduce((prev, curr)=>prev + curr.words, 0) || 0;
        let w = 0;
        work.chapters.find((e)=>{
            let is = e.id === work.position.chapter;
            if (!is) w += e.words;
            else w += work.position.progress * e.words;
            return is;
        });
        return w / words;
    }
    async clean() {
        await this.databaseLock.getLock().then((l)=>l.release());
        return Promise.all([
            this.workdb.clear(),
            this.chapterdb.clear()
        ]);
    }
    async getAll() {
        await this.databaseLock.getLock().then((l)=>l.release());
        return this.workdb.getAll();
    }
    async getWork(id) {
        await this.databaseLock.getLock().then((l)=>l.release());
        let [work, chapterData] = await Promise.all([
            this.workdb.get(id),
            this.chapterdb.get(id)
        ]);
        work.chapters.forEach((chap)=>{
            chap.content = chapterData.find((e)=>e.id == chap.id).content;
        });
        return work;
    }
    async deleteWork(id) {
        await this.databaseLock.getLock().then((l)=>l.release());
        const tx = await this.idb.transaction(this.workdb, this.chapterdb);
        await Promise.all([
            this.chapterdb.delete(id, tx),
            this.workdb.delete(id, tx)
        ]);
    }
    async saveWork(work) {
        await this.databaseLock.getLock().then((l)=>l.release());
        $b3b9117a88ecf6d3$var$upgrades.upgradeType(work);
        let chapterData = work.chapters.map((chapter)=>({
                id: chapter.id,
                content: chapter.content
            }));
        work.chapters.forEach((chapter)=>delete chapter.content);
        const tx = await this.idb.transaction(this.workdb, this.chapterdb);
        await Promise.all([
            this.chapterdb.set(work._id, chapterData, tx),
            this.workdb.set(work._id, work, tx)
        ]);
        return work;
    }
    async savePosition(id, position) {
        await this.databaseLock.getLock().then((l)=>l.release());
        let work = await this.workdb.get(id);
        if (!work) throw new Error("Work not found");
        work.position = position;
        work.progress = this.getProgress(work);
        work.new = false;
        await this.workdb.set(id, work);
        return work;
    }
}
class $b3b9117a88ecf6d3$export$2e2bcd8739ae039 {
    constructor(auth_server, client_id, version){
        this.auth_server = auth_server;
        this.client_id = client_id;
        this.version = version;
        this.logging = new (0, $0fcaf2d1ae326745$export$da7379efd263556f)({
            console: false,
            name: "ebookstore-client"
        });
        this.finishedLimit = 0.98;
        this.syncLock = new (0, $1ee0f1ea517deac2$export$2e2bcd8739ae039)();
        this.refreshToken = undefined;
        // private _idb = new IDB("eserver", ["works", "chapters"]);
        // private chapterdb = this._idb.getStore<{ id: string, content: string }[]>("chapters");
        // private workdb = this._idb.getStore<SmallWork>("works");
        this.storage = new $b3b9117a88ecf6d3$var$EbookStorage();
        this.workObersvableServer = new (0, $f1f0edacc5982840$export$2e2bcd8739ae039)(300);
        this.workObservable = this.workObersvableServer.getPublicApi();
        this.loginObeservableServer = new (0, $f1f0edacc5982840$export$2e2bcd8739ae039)();
        this.loginObservable = this.loginObeservableServer.getPublicApi();
        this._needLogin = true;
        this.authLock = new (0, $1ee0f1ea517deac2$export$2e2bcd8739ae039)();
        if (this.auth_server.endsWith("/")) this.auth_server = this.auth_server.slice(0, -1);
        const appVersion = Number(localStorage.getItem("app_version") || 0);
        if (appVersion !== version) this.storage.clean().then(()=>{
            localStorage.setItem("app_version", String(version));
        });
        // if (version === 0) {
        //     this.legacy = true;
        // }
        this.needLogin = !localStorage.getItem("refreshtoken");
        this.init();
    }
    get needLogin() {
        return this._needLogin;
    }
    set needLogin(val) {
        if (val !== this._needLogin) {
            this._needLogin = val;
            this.loginObeservableServer.send({
                need_login: val
            });
        }
    }
    get loginUrl() {
        return `${this.auth_server}/api/internal/oauth?client_id=${this.client_id}&redirect_uri=${encodeURIComponent(location.protocol + "//" + location.host)}`;
    }
    async getJWT() {
        this.logging.log("Getting JWT");
        let res = await this.makeRequest(this.auth_server + "/api/oauth/jwt?refreshtoken=" + this.refreshToken, "GET", undefined, undefined, true);
        this.jwt = res.token;
    }
    async init(nolock) {
        this.logging.log("Running init");
        let lock = undefined;
        if (!nolock) lock = await this.authLock.getLock();
        let token = localStorage.getItem("refreshtoken");
        let needLogin = false;
        if (token !== null && token !== "") {
            //ToDo just get JWT
            this.refreshToken = token;
            try {
                await this.getJWT();
                this.sync();
                setInterval(()=>this.sync(), 60000);
            } catch (e) {
                if (e instanceof $b3b9117a88ecf6d3$export$65bd6083489bd8bb) {
                    if (e.status === 400) {
                        //Bad Request
                        this.logging.log("Refresh token invalid, forward to login");
                        localStorage.removeItem("refreshtoken");
                        needLogin = true;
                    }
                }
            }
        } else needLogin = true;
        this.needLogin = needLogin;
        if (!nolock) lock.release();
    }
    async getToken(code) {
        let lock = await this.authLock.getLock();
        let res = await this.makeRequest("/api/get_refresh?code=" + code, "GET", undefined, undefined, true);
        localStorage.setItem("refreshtoken", res.token);
        await this.init(true);
        lock.release();
    }
    async logout() {
        await localStorage.clear();
        await this.storage.clean();
        this.jwt = undefined;
        this.refreshToken = undefined;
        this.needLogin = true;
    }
    async waitTillInitialized() {
        (await this.authLock.getLock()).release();
    }
    async makeRequest(url, method = "GET", body, contenttype, noauth, failjwt) {
        this.logging.debug("Making request: ", url, method, body, noauth, failjwt);
        let header = {
            "Content-Type": contenttype || "application/json"
        };
        if (contenttype === "noct") header = {};
        if (!noauth) header.Authorization = this.jwt;
        let bd;
        if (typeof body === "string") bd = body;
        else if (body instanceof Blob) bd = body;
        else bd = JSON.stringify(body);
        let res = await fetch(url, {
            headers: header,
            method: method,
            body: bd,
            credentials: "same-origin",
            mode: "cors"
        });
        const newJWT = async ()=>{
            await this.getJWT();
            return this.makeRequest(url, method, body, contenttype, noauth, true);
        };
        if (res.status === 418 && !failjwt) {
            //JWT is expired or invalid
            this.logging.log("JWT expired or invalid");
            return newJWT();
        }
        if (res.status !== 200) throw new $b3b9117a88ecf6d3$export$65bd6083489bd8bb(res.status, res.statusText);
        let data = await res.json();
        // console.log("Got data:", data)
        if (data.error) {
            if (data.status === 418 && !failjwt) {
                this.logging.log("JWT Expired");
                return newJWT();
            }
            throw new $b3b9117a88ecf6d3$export$65bd6083489bd8bb(data.status, data.error);
        }
        return data;
    }
    getVersion() {
        return this.makeRequest("/version_hash", "GET").then((e)=>e.version);
    }
    async getJsonWebToken() {
        await this.getJWT();
        return this.jwt;
    }
    fixCoverUrl(url) {
        if (!url) return undefined;
        if (!url.startsWith) return "/" + url;
        return url;
    }
    async getVerySmallWorksRemote() {
        return (await this.makeRequest("/api/works?small=true")).works;
    }
    async getWorksRemote() {
        return (await this.makeRequest("/api/works")).works;
    }
    async getWorks() {
        let works = (await this.storage.getAll()).map((e)=>{
            if (e.cover) e.cover = this.fixCoverUrl(e.cover);
            return e;
        });
        return works;
    }
    async getWorkRemote(id) {
        let work = await await this.makeRequest("/api/works/" + id);
        $b3b9117a88ecf6d3$var$upgrades.upgradeType(work);
        return work;
    }
    async getWork(id) {
        let work = await this.storage.getWork(id);
        if (!work) work = await this.getWorkRemote(id);
        if (work) work.cover = this.fixCoverUrl(work.cover);
        return work;
    }
    async resolveUrl(url) {
        return this.makeRequest("/api/resolve?url=" + encodeURIComponent(url));
    }
    async addWorkFromUrl(input) {
        const { type: type, id: id } = await this.resolveUrl(input);
        if (type && id) return this.addWorkWithId(type, id);
        throw new Error("URL cannot be identified!");
    }
    async addEPub(file) {
        let type = this.version === 0 ? 1 : "epub";
        let res = await this.makeRequest(`/api/works?type=${type}`, "POST", file, "noct");
        // await this.workdb.set(res._id, res);
        await this.storage.saveWork(res);
        this.workObersvableServer.send({
            type: $b3b9117a88ecf6d3$export$d8ed98235b49d42e.create_edit,
            work: res
        });
    }
    async addAO3(workid) {
        return this.addWorkWithId("ao3", workid);
    }
    async addWattpad(workid, pos) {
        return this.addWorkWithId("wattpad", workid, pos);
    }
    async addWorkWithId(type, id, pos) {
        let p = "";
        if (pos) p = `&position=${pos}`;
        let t;
        if (this.version === 0) t = type === "wattpad" ? 2 : 3;
        else t = type;
        let res = await this.makeRequest(`/api/works?type=${t}&workid=${id}`, "POST");
        await this.storage.saveWork(res);
        this.workObersvableServer.send({
            type: $b3b9117a88ecf6d3$export$d8ed98235b49d42e.create_edit,
            work: res
        });
    }
    async addManualWork(work) {
        let res = await this.makeRequest(`/api/works?type=manually`, "POST", JSON.stringify(work), "application/octet-stream");
        this.storage.saveWork(res);
        this.workObersvableServer.send({
            type: $b3b9117a88ecf6d3$export$d8ed98235b49d42e.create_edit,
            work: res
        });
    }
    async deleteWork(id) {
        let res = await this.makeRequest("/api/works/" + id, "DELETE");
        if (res.success) await this.storage.deleteWork(id);
        else throw new Error("Could not delete!");
        return;
    }
    async pushPositionRemote(id, position) {
        return this.makeRequest(`/api/works/${id}/position`, "POST", position);
    }
    async pushPositionLocal(id, position) {
        return this.storage.savePosition(id, position);
    }
    async pushPosition(id, position) {
        let work = await this.pushPositionLocal(id, position);
        this.workObersvableServer.send({
            type: $b3b9117a88ecf6d3$export$d8ed98235b49d42e.position,
            work: work
        });
        return this.pushPositionRemote(id, position);
    }
    async sync() {
        //Another Sync process is running currently, so another one is not necessary
        if (this.syncLock.locked) return;
        this.logging.log("Starting sync");
        const lock = await this.syncLock.getLock();
        try {
            this.logging.debug("Fetching local");
            let locals = await this.storage.getAll();
            this.logging.debug("Fetching remote");
            let remotes = await this.getVerySmallWorksRemote();
            let towait = [];
            let to_update = remotes.filter((rem)=>{
                let loc = locals.find((e)=>e._id === rem._id);
                if (!loc) return true;
                if (new Date(rem.creation_date).getTime() > new Date(loc.creation_date).getTime()) return true;
                else {
                    //Check if position changed or need to be changed!
                    if (!!loc.position || !!rem.position) {
                        if (!rem.position && loc.position || !loc.position && rem.position || rem.position.chapter !== loc.position.chapter || rem.position.progress !== loc.position.progress) {
                            if (!loc.position || rem.position && new Date(rem.position.date).getTime() >= new Date(loc.position.date).getTime()) {
                                // remote is newer
                                this.logging.debug("Updating local position:", rem._id);
                                // loc.position = rem.position;
                                // loc.progress = this.getProgress(loc);
                                // loc.new = false;
                                towait.push(this.storage.savePosition(rem._id, rem.position).then(()=>this.workObersvableServer.send({
                                        type: $b3b9117a88ecf6d3$export$d8ed98235b49d42e.position,
                                        work: loc
                                    })));
                            } else {
                                this.logging.debug("Updating remote position:", rem._id);
                                towait.push(this.pushPositionRemote(loc._id, loc.position));
                            }
                        }
                    }
                }
                return false;
            });
            await Promise.all(towait);
            const download = (async ()=>{
                let work = to_update.pop();
                while(work){
                    try {
                        this.logging.debug("Downloading and storing work", work);
                        let w = await this.getWorkRemote(work._id);
                        await this.storage.saveWork(w);
                        this.workObersvableServer.send({
                            type: $b3b9117a88ecf6d3$export$d8ed98235b49d42e.create_edit,
                            work: w
                        });
                    } catch (e) {
                        this.logging.error(e);
                    }
                    work = to_update.pop();
                }
            }).bind(this);
            if (to_update.length > 0) this.logging.debug("Updating local works");
            towait = [];
            for(let i = 0; i < 3; i++)towait.push(download());
            Promise.all(towait);
            let to_remove = locals.filter((a)=>!remotes.find((b)=>b._id === a._id));
            for (let work of to_remove){
                this.logging.debug("Deleting work", work);
                await this.storage.deleteWork(work._id);
                this.workObersvableServer.send({
                    type: $b3b9117a88ecf6d3$export$d8ed98235b49d42e.delete,
                    work: work
                });
            }
        } catch (e) {
            this.logging.error(e);
        } finally{
            lock.release();
            this.logging.log("Sync finished");
        }
    }
}



var $b2f717b74f2489cf$export$a3d46f0bb1b148e5;
(function(LoggingTypes) {
    LoggingTypes[LoggingTypes["Debug"] = 0] = "Debug";
    LoggingTypes[LoggingTypes["Log"] = 1] = "Log";
    LoggingTypes[LoggingTypes["Warn"] = 2] = "Warn";
    LoggingTypes[LoggingTypes["Error"] = 3] = "Error";
})($b2f717b74f2489cf$export$a3d46f0bb1b148e5 || ($b2f717b74f2489cf$export$a3d46f0bb1b148e5 = {}));
const $b2f717b74f2489cf$export$ba6e9f03e4136c09 = {
    Reset: "\x1b[0m",
    Bold: "\x1b[1m",
    Underscore: "\x1b[4m",
    Blink: "\x1b[5m",
    Reverse: "\x1b[7m",
    Hidden: "\x1b[8m",
    FgBlack: "\x1b[30m",
    FgRed: "\x1b[31m",
    FgGreen: "\x1b[32m",
    FgYellow: "\x1b[33m",
    FgBlue: "\x1b[34m",
    FgMagenta: "\x1b[35m",
    FgCyan: "\x1b[36m",
    FgWhite: "\x1b[37m",
    BgBlack: "\x1b[40m",
    BgRed: "\x1b[41m",
    BgGreen: "\x1b[42m",
    BgYellow: "\x1b[43m",
    BgBlue: "\x1b[44m",
    BgMagenta: "\x1b[45m",
    BgCyan: "\x1b[46m",
    BgWhite: "\x1b[47m"
};
var $b2f717b74f2489cf$export$2cc8290bb26d7f05;
(function(IColors) {
    IColors[IColors["NONE"] = 0] = "NONE";
    IColors[IColors["RED"] = 1] = "RED";
    IColors[IColors["GREEN"] = 2] = "GREEN";
    IColors[IColors["YELLOW"] = 3] = "YELLOW";
    IColors[IColors["BLUE"] = 4] = "BLUE";
    IColors[IColors["MAGENTA"] = 5] = "MAGENTA";
    IColors[IColors["CYAN"] = 6] = "CYAN";
    IColors[IColors["WHITE"] = 7] = "WHITE";
})($b2f717b74f2489cf$export$2cc8290bb26d7f05 || ($b2f717b74f2489cf$export$2cc8290bb26d7f05 = {}));
class $b2f717b74f2489cf$export$4eb8fc242550f5dd {
    static strip(formatted) {
        if (Array.isArray(formatted)) return formatted.reduce((p, c)=>p + c.content, "");
        else return formatted.content;
    }
    constructor(content, apply){
        if (content instanceof $b2f717b74f2489cf$export$4eb8fc242550f5dd) {
            this.color = content.color;
            this.bgcolor = content.bgcolor;
            this.bold = content.bold;
            this.italic = content.italic;
            this.blink = content.blink;
            this.underscore = content.underscore;
            this.content = content.content;
        } else this.content = content;
        if (apply) {
            this.color = apply.color;
            this.bgcolor = apply.bgcolor;
            this.bold = apply.bold;
            this.italic = apply.italic;
            this.blink = apply.blink;
            this.underscore = apply.underscore;
        }
    }
    color;
    bgcolor;
    bold;
    italic;
    blink;
    underscore;
    content;
    _color(c) {
        this.color = c;
        return this;
    }
    _bgcolor(c) {
        this.bgcolor = c;
        return this;
    }
    _bold(active = true) {
        this.bold = active;
        return this;
    }
    _italic(active = true) {
        this.italic = active;
        return this;
    }
    _blink(active = true) {
        this.blink = active;
        return this;
    }
}
const $b2f717b74f2489cf$var$AddColorFormat = (color)=>(content)=>{
        if (content instanceof $b2f717b74f2489cf$export$4eb8fc242550f5dd) {
            content.color = color;
            return content;
        } else {
            const d = new $b2f717b74f2489cf$export$4eb8fc242550f5dd(content);
            d.color = color;
            return d;
        }
    };
const $b2f717b74f2489cf$var$AddBGColorFormat = (color)=>(content)=>{
        if (content instanceof $b2f717b74f2489cf$export$4eb8fc242550f5dd) {
            content.bgcolor = color;
            return content;
        } else {
            const d = new $b2f717b74f2489cf$export$4eb8fc242550f5dd(content);
            d.bgcolor = color;
            return d;
        }
    };
const $b2f717b74f2489cf$export$93514d28bd18d75a = {
    none: $b2f717b74f2489cf$var$AddColorFormat($b2f717b74f2489cf$export$2cc8290bb26d7f05.NONE),
    red: $b2f717b74f2489cf$var$AddColorFormat($b2f717b74f2489cf$export$2cc8290bb26d7f05.RED),
    green: $b2f717b74f2489cf$var$AddColorFormat($b2f717b74f2489cf$export$2cc8290bb26d7f05.GREEN),
    yellow: $b2f717b74f2489cf$var$AddColorFormat($b2f717b74f2489cf$export$2cc8290bb26d7f05.YELLOW),
    blue: $b2f717b74f2489cf$var$AddColorFormat($b2f717b74f2489cf$export$2cc8290bb26d7f05.BLUE),
    magenta: $b2f717b74f2489cf$var$AddColorFormat($b2f717b74f2489cf$export$2cc8290bb26d7f05.MAGENTA),
    cyan: $b2f717b74f2489cf$var$AddColorFormat($b2f717b74f2489cf$export$2cc8290bb26d7f05.CYAN),
    white: $b2f717b74f2489cf$var$AddColorFormat($b2f717b74f2489cf$export$2cc8290bb26d7f05.WHITE),
    bgnone: $b2f717b74f2489cf$var$AddBGColorFormat($b2f717b74f2489cf$export$2cc8290bb26d7f05.NONE),
    bgred: $b2f717b74f2489cf$var$AddBGColorFormat($b2f717b74f2489cf$export$2cc8290bb26d7f05.RED),
    bggreen: $b2f717b74f2489cf$var$AddBGColorFormat($b2f717b74f2489cf$export$2cc8290bb26d7f05.GREEN),
    bgyellow: $b2f717b74f2489cf$var$AddBGColorFormat($b2f717b74f2489cf$export$2cc8290bb26d7f05.YELLOW),
    bgblue: $b2f717b74f2489cf$var$AddBGColorFormat($b2f717b74f2489cf$export$2cc8290bb26d7f05.BLUE),
    bgmagenta: $b2f717b74f2489cf$var$AddBGColorFormat($b2f717b74f2489cf$export$2cc8290bb26d7f05.MAGENTA),
    bgcyan: $b2f717b74f2489cf$var$AddBGColorFormat($b2f717b74f2489cf$export$2cc8290bb26d7f05.CYAN),
    bgwhite: $b2f717b74f2489cf$var$AddBGColorFormat($b2f717b74f2489cf$export$2cc8290bb26d7f05.WHITE),
    bold: (content)=>{
        if (content instanceof $b2f717b74f2489cf$export$4eb8fc242550f5dd) {
            content.bold = true;
            return content;
        } else {
            const d = new $b2f717b74f2489cf$export$4eb8fc242550f5dd(content);
            d.bold = true;
            return d;
        }
    },
    italic: (content)=>{
        if (content instanceof $b2f717b74f2489cf$export$4eb8fc242550f5dd) {
            content.italic = true;
            return content;
        } else {
            const d = new $b2f717b74f2489cf$export$4eb8fc242550f5dd(content);
            d.italic = true;
            return d;
        }
    }
};
class $b2f717b74f2489cf$export$1abd5c3e02935dac {
    error = new $b2f717b74f2489cf$export$4eb8fc242550f5dd()._color($b2f717b74f2489cf$export$2cc8290bb26d7f05.RED)._bold();
    warning = new $b2f717b74f2489cf$export$4eb8fc242550f5dd()._color($b2f717b74f2489cf$export$2cc8290bb26d7f05.YELLOW)._bold();
    log = new $b2f717b74f2489cf$export$4eb8fc242550f5dd()._color($b2f717b74f2489cf$export$2cc8290bb26d7f05.NONE)._bold();
    debug = new $b2f717b74f2489cf$export$4eb8fc242550f5dd()._color($b2f717b74f2489cf$export$2cc8290bb26d7f05.CYAN)._bold();
    date = new $b2f717b74f2489cf$export$4eb8fc242550f5dd()._color($b2f717b74f2489cf$export$2cc8290bb26d7f05.NONE);
    file = new $b2f717b74f2489cf$export$4eb8fc242550f5dd()._color($b2f717b74f2489cf$export$2cc8290bb26d7f05.NONE);
    names = new $b2f717b74f2489cf$export$4eb8fc242550f5dd()._bold()._color($b2f717b74f2489cf$export$2cc8290bb26d7f05.CYAN);
    names_delimiter = new $b2f717b74f2489cf$export$4eb8fc242550f5dd(" -> ")._bold();
}



const $79e5bbdd405d2bdb$var$browser = typeof window !== "undefined" && typeof Deno === "undefined";
const $79e5bbdd405d2bdb$var$deno = typeof Deno !== "undefined";
const $79e5bbdd405d2bdb$var$NodeJS = true;
class $79e5bbdd405d2bdb$export$c3b072b48cd5b818 {
    colors;
    level = (0, $b2f717b74f2489cf$export$a3d46f0bb1b148e5).Debug;
    constructor(colors = true){
        this.colors = colors;
    }
    init() {}
    flush() {}
    setLevel(level) {
        this.level = level;
    }
    // TODO: Check if required!
    // private escape(text: string): string {
    //    return text
    //       .replace(/%s/g, "%%s")
    //       .replace(/%c/g, "%%c")
    // }
    format(formatted) {
        let text = "";
        let style_formats = [];
        if (!$79e5bbdd405d2bdb$var$browser) // NodeJS or Deno
        for (const format of formatted){
            let formats = "";
            if (format.bold) formats += (0, $b2f717b74f2489cf$export$ba6e9f03e4136c09).Bold;
            if (format.blink) formats += (0, $b2f717b74f2489cf$export$ba6e9f03e4136c09).Blink;
            if (format.underscore) formats += (0, $b2f717b74f2489cf$export$ba6e9f03e4136c09).Underscore;
            if (format.color) switch(format.color){
                case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).RED:
                    formats += (0, $b2f717b74f2489cf$export$ba6e9f03e4136c09).FgRed;
                    break;
                case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).GREEN:
                    formats += (0, $b2f717b74f2489cf$export$ba6e9f03e4136c09).FgGreen;
                    break;
                case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).YELLOW:
                    formats += (0, $b2f717b74f2489cf$export$ba6e9f03e4136c09).FgYellow;
                    break;
                case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).BLUE:
                    formats += (0, $b2f717b74f2489cf$export$ba6e9f03e4136c09).FgBlue;
                    break;
                case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).MAGENTA:
                    formats += (0, $b2f717b74f2489cf$export$ba6e9f03e4136c09).FgMagenta;
                    break;
                case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).CYAN:
                    formats += (0, $b2f717b74f2489cf$export$ba6e9f03e4136c09).FgCyan;
                    break;
                case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).WHITE:
                    formats += (0, $b2f717b74f2489cf$export$ba6e9f03e4136c09).FgWhite;
                    break;
            }
            if (format.bgcolor) switch(format.bgcolor){
                case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).RED:
                    formats += (0, $b2f717b74f2489cf$export$ba6e9f03e4136c09).BgRed;
                    break;
                case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).GREEN:
                    formats += (0, $b2f717b74f2489cf$export$ba6e9f03e4136c09).BgGreen;
                    break;
                case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).YELLOW:
                    formats += (0, $b2f717b74f2489cf$export$ba6e9f03e4136c09).BgYellow;
                    break;
                case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).BLUE:
                    formats += (0, $b2f717b74f2489cf$export$ba6e9f03e4136c09).BgBlue;
                    break;
                case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).MAGENTA:
                    formats += (0, $b2f717b74f2489cf$export$ba6e9f03e4136c09).BgMagenta;
                    break;
                case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).CYAN:
                    formats += (0, $b2f717b74f2489cf$export$ba6e9f03e4136c09).BgCyan;
                    break;
                case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).WHITE:
                    formats += (0, $b2f717b74f2489cf$export$ba6e9f03e4136c09).BgWhite;
                    break;
            }
            text += formats + format.content + (0, $b2f717b74f2489cf$export$ba6e9f03e4136c09).Reset;
        // (formats.length > 0 ? TerminalFormats.Reset : ""); //TODO: Benchmark if this is better
        }
        else for (const format of formatted){
            let styles = [];
            let resetStyles = [];
            if (format.bold) {
                styles.push("font-weight: bold;");
                resetStyles.push("font-weight: unset");
            }
            if (format.underscore) {
                styles.push("text-decoration: underline");
                resetStyles.push("text-decoration: unset");
            }
            if (format.blink) {
                styles.push("text-decoration: blink");
                resetStyles.push("text-decoration: unset");
            }
            if (format.color) {
                let color = "";
                switch(format.color){
                    case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).RED:
                        color = "red";
                        break;
                    case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).GREEN:
                        color = "green";
                        break;
                    case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).YELLOW:
                        color = "gold";
                        break;
                    case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).BLUE:
                        color = "blue";
                        break;
                    case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).MAGENTA:
                        color = "magenta";
                        break;
                    case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).CYAN:
                        color = "cyan";
                        break;
                    case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).WHITE:
                        color = "white";
                        break;
                }
                styles.push("color: " + color);
                resetStyles.push("color: unset");
            }
            if (format.bgcolor) {
                let color = "";
                switch(format.bgcolor){
                    case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).RED:
                        color = "red";
                        break;
                    case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).GREEN:
                        color = "green";
                        break;
                    case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).YELLOW:
                        color = "gold";
                        break;
                    case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).BLUE:
                        color = "blue";
                        break;
                    case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).MAGENTA:
                        color = "magenta";
                        break;
                    case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).CYAN:
                        color = "cyan";
                        break;
                    case (0, $b2f717b74f2489cf$export$2cc8290bb26d7f05).WHITE:
                        color = "white";
                        break;
                }
                styles.push("background-color: " + color);
                resetStyles.push("background-color: unset");
            }
            text += "%c" + format.content.replace(/%c/g, "%%c") + "%c";
            style_formats.push(styles.join(";"), resetStyles.join(";"));
        }
        return [
            text,
            style_formats
        ];
    }
    onMessage(message) {
        if ($79e5bbdd405d2bdb$var$browser) {
            if (this.colors) {
                const [text, formats] = this.format(message.text);
                console.log(text, ...formats);
            } else console.log((0, $b2f717b74f2489cf$export$4eb8fc242550f5dd).strip(message.text));
        } else {
            const text = this.colors ? this.format(message.text)[0] : (0, $b2f717b74f2489cf$export$4eb8fc242550f5dd).strip(message.text);
            if ($79e5bbdd405d2bdb$var$deno) //TODO: Deno specific thing
            console.log(text);
            else if (typeof $c68e419b2a37d2b9$exports !== "undefined") //NodeJS
            $c68e419b2a37d2b9$exports.stdout.write(text + "\n");
            else console.log(text);
        }
    }
}


/**
 * Module exports.
 */ /**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 * @license MIT (© Joyent)
 */ /* legacy: obj, showHidden, depth, colors*/ function $670699f60aa8e991$export$2e2bcd8739ae039(obj, opts) {
    // default options
    let ctx = {
        seen: [],
        stylize: $670699f60aa8e991$var$stylizeNoColor,
        depth: undefined,
        colors: undefined,
        showHidden: undefined,
        customInspect: undefined
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($670699f60aa8e991$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    $670699f60aa8e991$var$_extend(ctx, opts);
    // set default options
    if ($670699f60aa8e991$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($670699f60aa8e991$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($670699f60aa8e991$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($670699f60aa8e991$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $670699f60aa8e991$var$stylizeWithColor;
    return $670699f60aa8e991$var$formatValue(ctx, obj, ctx.depth);
}
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$670699f60aa8e991$export$2e2bcd8739ae039.colors = {
    bold: [
        1,
        22
    ],
    italic: [
        3,
        23
    ],
    underline: [
        4,
        24
    ],
    inverse: [
        7,
        27
    ],
    white: [
        37,
        39
    ],
    grey: [
        90,
        39
    ],
    black: [
        30,
        39
    ],
    blue: [
        34,
        39
    ],
    cyan: [
        36,
        39
    ],
    green: [
        32,
        39
    ],
    magenta: [
        35,
        39
    ],
    red: [
        31,
        39
    ],
    yellow: [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$670699f60aa8e991$export$2e2bcd8739ae039.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    // "name": intentionally not styling
    regexp: "red"
};
function $670699f60aa8e991$var$stylizeNoColor(str, styleType) {
    return str;
}
function $670699f60aa8e991$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
function $670699f60aa8e991$var$isUndefined(arg) {
    return arg === void 0;
}
function $670699f60aa8e991$var$stylizeWithColor(str, styleType) {
    var style = $670699f60aa8e991$export$2e2bcd8739ae039.styles[styleType];
    if (style) return "\x1b[" + $670699f60aa8e991$export$2e2bcd8739ae039.colors[style][0] + "m" + str + "\x1b[" + $670699f60aa8e991$export$2e2bcd8739ae039.colors[style][1] + "m";
    else return str;
}
function $670699f60aa8e991$var$isFunction(arg) {
    return typeof arg === "function";
}
function $670699f60aa8e991$var$isString(arg) {
    return typeof arg === "string";
}
function $670699f60aa8e991$var$isNumber(arg) {
    return typeof arg === "number";
}
function $670699f60aa8e991$var$isNull(arg) {
    return arg === null;
}
function $670699f60aa8e991$var$hasOwn(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function $670699f60aa8e991$var$isRegExp(re) {
    return $670699f60aa8e991$var$isObject(re) && $670699f60aa8e991$var$objectToString(re) === "[object RegExp]";
}
function $670699f60aa8e991$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
function $670699f60aa8e991$var$isError(e) {
    return $670699f60aa8e991$var$isObject(e) && ($670699f60aa8e991$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
function $670699f60aa8e991$var$isDate(d) {
    return $670699f60aa8e991$var$isObject(d) && $670699f60aa8e991$var$objectToString(d) === "[object Date]";
}
function $670699f60aa8e991$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $670699f60aa8e991$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $670699f60aa8e991$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($670699f60aa8e991$var$hasOwn(value, String(i))) output.push($670699f60aa8e991$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($670699f60aa8e991$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $670699f60aa8e991$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $670699f60aa8e991$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $670699f60aa8e991$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== $670699f60aa8e991$export$2e2bcd8739ae039 && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$670699f60aa8e991$var$isString(ret)) ret = $670699f60aa8e991$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $670699f60aa8e991$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $670699f60aa8e991$var$arrayToHash(keys);
    try {
        if (ctx.showHidden && Object.getOwnPropertyNames) keys = Object.getOwnPropertyNames(value);
    } catch (e) {
    // ignore
    }
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($670699f60aa8e991$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $670699f60aa8e991$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($670699f60aa8e991$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($670699f60aa8e991$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($670699f60aa8e991$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($670699f60aa8e991$var$isError(value)) return $670699f60aa8e991$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if (Array.isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($670699f60aa8e991$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($670699f60aa8e991$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($670699f60aa8e991$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($670699f60aa8e991$var$isError(value)) base = " " + $670699f60aa8e991$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($670699f60aa8e991$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $670699f60aa8e991$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $670699f60aa8e991$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $670699f60aa8e991$var$reduceToSingleString(output, base, braces);
}
function $670699f60aa8e991$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = {
        value: void 0
    };
    try {
        // ie6 › navigator.toString
        // throws Error: Object doesn't support this property or method
        desc.value = value[key];
    } catch (e) {
    // ignore
    }
    try {
        // ie10 › Object.getOwnPropertyDescriptor(window.location, 'hash')
        // throws TypeError: Object doesn't support this action
        if (Object.getOwnPropertyDescriptor) desc = Object.getOwnPropertyDescriptor(value, key) || desc;
    } catch (e) {
    // ignore
    }
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$670699f60aa8e991$var$hasOwn(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($670699f60aa8e991$var$isNull(recurseTimes)) str = $670699f60aa8e991$var$formatValue(ctx, desc.value, null);
            else str = $670699f60aa8e991$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").substr(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($670699f60aa8e991$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.substr(1, name.length - 2);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $670699f60aa8e991$var$formatPrimitive(ctx, value) {
    if ($670699f60aa8e991$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($670699f60aa8e991$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($670699f60aa8e991$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($670699f60aa8e991$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($670699f60aa8e991$var$isNull(value)) return ctx.stylize("null", "null");
}
function $670699f60aa8e991$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}
function $670699f60aa8e991$var$_extend(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$670699f60aa8e991$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
}




const $30f03ab36070eb0b$var$browser = typeof window !== "undefined";
const $30f03ab36070eb0b$export$51d9b00fde9d6e0e = {
    startTimer: ()=>{
        if ($30f03ab36070eb0b$var$browser && window.performance && window.performance.now) return window.performance.now();
        else return Date.now();
    },
    endTimer: (start)=>{
        if ($30f03ab36070eb0b$var$browser && window.performance && window.performance.now) return window.performance.now() - start;
        else return Date.now() - start;
    }
};
const $30f03ab36070eb0b$var$consoleAdapter = new (0, $79e5bbdd405d2bdb$export$c3b072b48cd5b818)();
const $30f03ab36070eb0b$var$PROJECT_ROOT = typeof $c68e419b2a37d2b9$exports !== "undefined" ? $c68e419b2a37d2b9$exports.cwd() : undefined;
const $30f03ab36070eb0b$var$InitialisedAdapters = Symbol("@hibas123/logging:initialisedAdapters");
class $30f03ab36070eb0b$export$71b9bd1a26577a41 {
    #names;
    #timerMap = new Map();
    get names() {
        return [
            ...this.#names
        ];
    }
    constructor(names){
        this.#names = names;
        for(const key in this)if (typeof this[key] === "function") this[key] = this[key].bind(this);
    }
    debug(...message) {
        this.message((0, $b2f717b74f2489cf$export$a3d46f0bb1b148e5).Debug, this.#names, message);
    }
    log(...message) {
        this.message((0, $b2f717b74f2489cf$export$a3d46f0bb1b148e5).Log, this.#names, message);
    }
    warning(...message) {
        this.message((0, $b2f717b74f2489cf$export$a3d46f0bb1b148e5).Warn, this.#names, message);
    }
    warn(...message) {
        this.message((0, $b2f717b74f2489cf$export$a3d46f0bb1b148e5).Warn, this.#names, message);
    }
    error(error, ...message) {
        if (!error) error = "Empty ERROR was passed, so no informations available";
        if (typeof error === "string") {
            let e = new Error("This is a fake error, to get a stack trace");
            this.message((0, $b2f717b74f2489cf$export$a3d46f0bb1b148e5).Error, this.#names, [
                error,
                ...message,
                "\n",
                e.stack,
                "\n"
            ]);
        } else this.message((0, $b2f717b74f2489cf$export$a3d46f0bb1b148e5).Error, this.#names, [
            error.message,
            "\n",
            error.stack,
            "\n",
            ...message
        ], $30f03ab36070eb0b$var$getCallerFromExisting(error));
    }
    time(id) {
        if (!id) id = Math.floor(Math.random() * 899999 + 100000).toString();
        this.#timerMap.set(id, {
            name: id,
            start: $30f03ab36070eb0b$export$da7379efd263556f.nativeFunctions.startTimer()
        });
        return {
            id: id,
            end: ()=>this.timeEnd(id)
        };
    }
    timeEnd(id) {
        let timer = this.#timerMap.get(id);
        if (timer) {
            let diff = $30f03ab36070eb0b$export$da7379efd263556f.nativeFunctions.endTimer(timer.start);
            this.message((0, $b2f717b74f2489cf$export$a3d46f0bb1b148e5).Debug, this.#names, [
                (0, $b2f717b74f2489cf$export$93514d28bd18d75a).green(`[${timer.name}]`),
                `->`,
                (0, $b2f717b74f2489cf$export$93514d28bd18d75a).blue(diff.toFixed(4)),
                "ms"
            ]);
            return diff;
        }
        return -1;
    }
}
class $30f03ab36070eb0b$export$da7379efd263556f extends $30f03ab36070eb0b$export$71b9bd1a26577a41 {
    static [$30f03ab36070eb0b$var$InitialisedAdapters] = new Map();
    static nativeFunctions = $30f03ab36070eb0b$export$51d9b00fde9d6e0e;
    static DecoupledLogging = class extends $30f03ab36070eb0b$export$71b9bd1a26577a41 {
        #lg;
        constructor(names, lg){
            super(names);
            this.#lg = lg;
        }
        message(...params) {
            this.#lg.message(...params);
        }
        getChild(name) {
            return new $30f03ab36070eb0b$export$da7379efd263556f.DecoupledLogging([
                ...this.names,
                name
            ], this.#lg);
        }
    };
    #closed = false;
    #logLevel = (0, $b2f717b74f2489cf$export$a3d46f0bb1b148e5).Debug;
    #resolve_filename;
    #format_map = new (0, $b2f717b74f2489cf$export$1abd5c3e02935dac)();
    #adapters = new Set();
    set logLevel(level) {
        this.#logLevel = level;
    }
    get logLevel() {
        return this.#logLevel;
    }
    constructor(options){
        super(options?.name ? [
            options.name
        ] : []);
        options = {
            console: true,
            resolve_filename: true,
            ...options
        };
        if (options.console) this.addAdapter($30f03ab36070eb0b$var$consoleAdapter);
    }
    async addAdapter(adapter) {
        const init = adapter.init();
        const add = ()=>{
            this.#adapters.add(adapter);
            if ($30f03ab36070eb0b$export$da7379efd263556f[$30f03ab36070eb0b$var$InitialisedAdapters].has(adapter)) $30f03ab36070eb0b$export$da7379efd263556f[$30f03ab36070eb0b$var$InitialisedAdapters].set(adapter, $30f03ab36070eb0b$export$da7379efd263556f[$30f03ab36070eb0b$var$InitialisedAdapters].get(adapter) + 1);
            else $30f03ab36070eb0b$export$da7379efd263556f[$30f03ab36070eb0b$var$InitialisedAdapters].set(adapter, 1);
        };
        if (!init) add();
        else await Promise.resolve(init).then(add);
    }
    getChild(name) {
        return new $30f03ab36070eb0b$export$da7379efd263556f.DecoupledLogging([
            ...this.names,
            name
        ], this);
    }
    message(type, names, message, caller) {
        if (this.#logLevel > type) return;
        if (this.#closed) //TODO: Maybe error?
        return;
        const date = new Date();
        const isoStr = date.toISOString();
        const date_str = isoStr.substring(0, 10) + " " + isoStr.substring(11, 19);
        let file = undefined;
        if (this.#resolve_filename) {
            let file_raw = caller;
            if (!file_raw) try {
                file_raw = $30f03ab36070eb0b$var$getCallerFile();
            } catch (err) {
                file_raw = {
                    file: "<unknown>",
                    line: 0,
                    column: 0
                };
            }
            if ($30f03ab36070eb0b$var$PROJECT_ROOT && file_raw.file && file_raw.file.startsWith($30f03ab36070eb0b$var$PROJECT_ROOT)) {
                let newF = file_raw.file.substring($30f03ab36070eb0b$var$PROJECT_ROOT.length);
                if (newF.startsWith("/") || newF.startsWith("\\")) newF = newF.substring(1);
                file_raw.file = newF;
            }
            file = `${file_raw.file || "<unknown>"}:${file_raw.line}:${file_raw.column || 0}`;
        }
        let type_str = (0, $b2f717b74f2489cf$export$a3d46f0bb1b148e5)[type].toUpperCase().padEnd(5, " ");
        let type_format;
        switch(type){
            case (0, $b2f717b74f2489cf$export$a3d46f0bb1b148e5).Log:
                type_format = this.#format_map.log;
                break;
            case (0, $b2f717b74f2489cf$export$a3d46f0bb1b148e5).Error:
                type_format = this.#format_map.error;
                break;
            case (0, $b2f717b74f2489cf$export$a3d46f0bb1b148e5).Debug:
                type_format = this.#format_map.debug;
                break;
            case (0, $b2f717b74f2489cf$export$a3d46f0bb1b148e5).Warn:
                type_format = this.#format_map.warning;
                break;
        }
        const nameFormatted = [];
        if (names.length > 0) {
            nameFormatted.push(new (0, $b2f717b74f2489cf$export$4eb8fc242550f5dd)("["));
            for(let i = 0; i < names.length; i++){
                nameFormatted.push(new (0, $b2f717b74f2489cf$export$4eb8fc242550f5dd)(names[i], this.#format_map.names));
                if (i < names.length - 1) nameFormatted.push(this.#format_map.names_delimiter);
            }
            nameFormatted.push(new (0, $b2f717b74f2489cf$export$4eb8fc242550f5dd)("]"));
        }
        let linePrefix = [
            new (0, $b2f717b74f2489cf$export$4eb8fc242550f5dd)("["),
            new (0, $b2f717b74f2489cf$export$4eb8fc242550f5dd)(date_str, this.#format_map.date),
            new (0, $b2f717b74f2489cf$export$4eb8fc242550f5dd)("]["),
            new (0, $b2f717b74f2489cf$export$4eb8fc242550f5dd)(type_str, type_format),
            ...file ? [
                new (0, $b2f717b74f2489cf$export$4eb8fc242550f5dd)("]["),
                new (0, $b2f717b74f2489cf$export$4eb8fc242550f5dd)(file, this.#format_map.file)
            ] : [],
            new (0, $b2f717b74f2489cf$export$4eb8fc242550f5dd)("]"),
            ...nameFormatted,
            new (0, $b2f717b74f2489cf$export$4eb8fc242550f5dd)(": ")
        ];
        let formattedMessage = [
            ...linePrefix
        ];
        message.forEach((msg, idx)=>{
            let format;
            if (msg instanceof (0, $b2f717b74f2489cf$export$4eb8fc242550f5dd)) {
                format = msg;
                msg = msg.content;
            } else format = new (0, $b2f717b74f2489cf$export$4eb8fc242550f5dd)();
            if (typeof msg !== "string") msg = (0, $670699f60aa8e991$export$2e2bcd8739ae039)(msg, {
                colors: false,
                showHidden: true,
                depth: 3
            });
            // removeColors(msg) // Remove colors is uncommented for now, since there are no real benefits of having it and it reduces performance
            msg.split("\n").forEach((text, index, { length: length })=>{
                if (index != length - 1) formattedMessage.push(new (0, $b2f717b74f2489cf$export$4eb8fc242550f5dd)(text + "\n", format), ...linePrefix);
                else formattedMessage.push(new (0, $b2f717b74f2489cf$export$4eb8fc242550f5dd)(text, format));
            });
            formattedMessage.push(new (0, $b2f717b74f2489cf$export$4eb8fc242550f5dd)(" "));
        });
        let msg = {
            date: date,
            file: file,
            names: names,
            text: formattedMessage,
            type: type
        };
        this.#adapters.forEach((adapter)=>{
            if (adapter.level <= type) adapter.onMessage(msg);
        });
    }
    async close() {
        if (this.#closed) return;
        this.#closed = true;
        for (const adapter of this.#adapters){
            const cnt = $30f03ab36070eb0b$export$da7379efd263556f[$30f03ab36070eb0b$var$InitialisedAdapters].get(adapter);
            if (!cnt) ;
            else if (cnt <= 1) {
                if (adapter.close) await adapter.close();
                $30f03ab36070eb0b$export$da7379efd263556f[$30f03ab36070eb0b$var$InitialisedAdapters].delete(adapter);
            } else $30f03ab36070eb0b$export$da7379efd263556f[$30f03ab36070eb0b$var$InitialisedAdapters].set(adapter, cnt - 1);
        }
    }
}
function $30f03ab36070eb0b$var$getStack() {
    // Save original Error.prepareStackTrace
    let origPrepareStackTrace = Error.prepareStackTrace;
    try {
        // Override with function that just returns `stack`
        Error.prepareStackTrace = function(_, stack) {
            return stack;
        };
        // Create a new `Error`, which automatically gets `stack`
        let err = new Error();
        // Evaluate `err.stack`, which calls our new `Error.prepareStackTrace`
        let stack = err.stack;
        return stack;
    } finally{
        // Restore original `Error.prepareStackTrace`
        Error.prepareStackTrace = origPrepareStackTrace;
    }
}
function $30f03ab36070eb0b$var$getCallerFile() {
    try {
        let stack = $30f03ab36070eb0b$var$getStack();
        let current_file = stack.shift().getFileName();
        while(stack.length){
            let caller_file = stack.shift();
            if (current_file !== caller_file.getFileName()) return {
                file: caller_file.getFileName(),
                line: caller_file.getLineNumber(),
                column: caller_file.getColumnNumber()
            };
        }
    } catch (err) {}
    return {
        file: undefined,
        line: 0
    };
}
function $30f03ab36070eb0b$var$getCallerFromExisting(err) {
    if (!err || !err.stack) return {
        file: "NOFILE",
        line: 0
    };
    let lines = err.stack.split("\n");
    lines.shift(); // removing first line
    while(lines.length > 0){
        let line = lines.shift();
        let matches = line.match(/[<]?([a-zA-Z]:)?([\/\\]?[a-zA-Z_-])+[.>][a-zA-Z_-]*([:][0-9]+)+/g);
        if (matches && matches.length > 0) {
            let match = matches[0].trim();
            let locationString = match.match(/([:][0-9]+)+$/gm)[0];
            let line;
            let column;
            if (locationString) {
                match = match.slice(0, match.length - locationString.length);
                locationString = locationString.substring(1);
                [line, column] = locationString.split(":").map(Number);
            }
            let file = match;
            return {
                file: file,
                line: line,
                column: column
            };
        }
    }
}
function $30f03ab36070eb0b$export$eb729c9df13ba112(text) {
    text = text.replace(// Putting regex here directly instead of externally actually improves performance. The cause of that is not clear for now.
    /[\u001b\u009b][[()#;?]*(?:[0-9]{1,4}(?:;[0-9]{0,4})*)?[0-9A-ORZcf-nqry=><]/g, "");
    return text;
}




const $7c800d04429fc171$var$Logging = new (0, $30f03ab36070eb0b$export$da7379efd263556f)();
var $7c800d04429fc171$export$2e2bcd8739ae039 = $7c800d04429fc171$var$Logging;


const $c1c041af559ee181$var$loggingInstances = new Map();
const $c1c041af559ee181$var$enabled = new Set();
(localStorage.getItem("LOGGING_ENABLED") || "").split(";").forEach((e)=>$c1c041af559ee181$var$enabled.add(e));
function $c1c041af559ee181$export$d1e2d247586bfe0(id) {
    let logging = $c1c041af559ee181$var$loggingInstances.get(id);
    if (!logging) {
        logging = new (0, $30f03ab36070eb0b$export$da7379efd263556f)({
            name: id,
            console: false
        });
        console.log(logging);
        logging.addAdapter(new (0, $79e5bbdd405d2bdb$export$c3b072b48cd5b818)());
        $c1c041af559ee181$var$loggingInstances.set(id, logging);
        logging.logLevel = $c1c041af559ee181$var$enabled.has(id) ? (0, $b2f717b74f2489cf$export$a3d46f0bb1b148e5).Debug : (0, $b2f717b74f2489cf$export$a3d46f0bb1b148e5).Error;
    }
    return logging;
}
function $c1c041af559ee181$export$4e1d237eb9e560af(logging) {
    if (!$c1c041af559ee181$var$loggingInstances.has(logging.name)) {
        $c1c041af559ee181$var$loggingInstances.set(logging.name, logging);
        logging.addAdapter(new (0, $79e5bbdd405d2bdb$export$c3b072b48cd5b818)());
        logging.logLevel = $c1c041af559ee181$var$enabled.has(logging.name) ? (0, $b2f717b74f2489cf$export$a3d46f0bb1b148e5).Debug : (0, $b2f717b74f2489cf$export$a3d46f0bb1b148e5).Error;
    }
}
function $c1c041af559ee181$export$f7036c7717b94b2d(id) {
    let newstate;
    if ($c1c041af559ee181$var$enabled.has(id)) {
        $c1c041af559ee181$var$enabled.delete(id);
        let ins = $c1c041af559ee181$var$loggingInstances.get(id);
        if (ins) ins.logLevel = (0, $b2f717b74f2489cf$export$a3d46f0bb1b148e5).Error;
        newstate = false;
    } else {
        $c1c041af559ee181$var$enabled.add(id);
        let ins = $c1c041af559ee181$var$loggingInstances.get(id);
        if (ins) ins.logLevel = (0, $b2f717b74f2489cf$export$a3d46f0bb1b148e5).Debug;
        newstate = true;
    }
    localStorage.setItem("LOGGING_ENABLED", Array.from($c1c041af559ee181$var$enabled.values()).join(";"));
    return newstate;
}
window.toggleLogging = (id)=>$c1c041af559ee181$export$f7036c7717b94b2d(id);
window.showLogging = ()=>{
    return $c1c041af559ee181$var$loggingInstances;
};


const $3de94ec6e8ed99ed$var$config = window.config;
if (!$3de94ec6e8ed99ed$var$config) alert("Configuration not found, please reload!");
if (!$3de94ec6e8ed99ed$var$config.version) console.warn("Running in legacy mode!");
else console.info("Running with API version:", $3de94ec6e8ed99ed$var$config.version);
const $3de94ec6e8ed99ed$var$Api = new (0, $b3b9117a88ecf6d3$export$2e2bcd8739ae039)($3de94ec6e8ed99ed$var$config.authserver, $3de94ec6e8ed99ed$var$config.client_id, $3de94ec6e8ed99ed$var$config.version || 0);
(0, $c1c041af559ee181$export$4e1d237eb9e560af)($3de94ec6e8ed99ed$var$Api.logging);
var $3de94ec6e8ed99ed$export$2e2bcd8739ae039 = $3de94ec6e8ed99ed$var$Api;



var $36125daf8ed1aaea$exports = {};
$36125daf8ed1aaea$exports = ".row{box-sizing:border-box;flex-flow:wrap;flex:0 auto;display:flex}.col-sm,[class^=col-sm-],[class^=col-sm-offset-],.row[class*=cols-sm-]>*{box-sizing:border-box;padding:0 calc(var(--universal-padding)/2);flex:none}.col-sm,.row.cols-sm>*{flex-grow:1;flex-basis:0;max-width:100%}.col-sm-1,.row.cols-sm-1>*{flex-basis:8.33333%;max-width:8.33333%}.col-sm-offset-0{margin-left:0}.col-sm-2,.row.cols-sm-2>*{flex-basis:16.6667%;max-width:16.6667%}.col-sm-offset-1{margin-left:8.33333%}.col-sm-3,.row.cols-sm-3>*{flex-basis:25%;max-width:25%}.col-sm-offset-2{margin-left:16.6667%}.col-sm-4,.row.cols-sm-4>*{flex-basis:33.3333%;max-width:33.3333%}.col-sm-offset-3{margin-left:25%}.col-sm-5,.row.cols-sm-5>*{flex-basis:41.6667%;max-width:41.6667%}.col-sm-offset-4{margin-left:33.3333%}.col-sm-6,.row.cols-sm-6>*{flex-basis:50%;max-width:50%}.col-sm-offset-5{margin-left:41.6667%}.col-sm-7,.row.cols-sm-7>*{flex-basis:58.3333%;max-width:58.3333%}.col-sm-offset-6{margin-left:50%}.col-sm-8,.row.cols-sm-8>*{flex-basis:66.6667%;max-width:66.6667%}.col-sm-offset-7{margin-left:58.3333%}.col-sm-9,.row.cols-sm-9>*{flex-basis:75%;max-width:75%}.col-sm-offset-8{margin-left:66.6667%}.col-sm-10,.row.cols-sm-10>*{flex-basis:83.3333%;max-width:83.3333%}.col-sm-offset-9{margin-left:75%}.col-sm-11,.row.cols-sm-11>*{flex-basis:91.6667%;max-width:91.6667%}.col-sm-offset-10{margin-left:83.3333%}.col-sm-12,.row.cols-sm-12>*{flex-basis:100%;max-width:100%}.col-sm-offset-11{margin-left:91.6667%}.col-sm-normal{order:initial}.col-sm-first{order:-999}.col-sm-last{order:999}@media screen and (width>=768px){.col-md,[class^=col-md-],[class^=col-md-offset-],.row[class*=cols-md-]>*{box-sizing:border-box;padding:0 calc(var(--universal-padding)/2);flex:none}.col-md,.row.cols-md>*{flex-grow:1;flex-basis:0;max-width:100%}.col-md-1,.row.cols-md-1>*{flex-basis:8.33333%;max-width:8.33333%}.col-md-offset-0{margin-left:0}.col-md-2,.row.cols-md-2>*{flex-basis:16.6667%;max-width:16.6667%}.col-md-offset-1{margin-left:8.33333%}.col-md-3,.row.cols-md-3>*{flex-basis:25%;max-width:25%}.col-md-offset-2{margin-left:16.6667%}.col-md-4,.row.cols-md-4>*{flex-basis:33.3333%;max-width:33.3333%}.col-md-offset-3{margin-left:25%}.col-md-5,.row.cols-md-5>*{flex-basis:41.6667%;max-width:41.6667%}.col-md-offset-4{margin-left:33.3333%}.col-md-6,.row.cols-md-6>*{flex-basis:50%;max-width:50%}.col-md-offset-5{margin-left:41.6667%}.col-md-7,.row.cols-md-7>*{flex-basis:58.3333%;max-width:58.3333%}.col-md-offset-6{margin-left:50%}.col-md-8,.row.cols-md-8>*{flex-basis:66.6667%;max-width:66.6667%}.col-md-offset-7{margin-left:58.3333%}.col-md-9,.row.cols-md-9>*{flex-basis:75%;max-width:75%}.col-md-offset-8{margin-left:66.6667%}.col-md-10,.row.cols-md-10>*{flex-basis:83.3333%;max-width:83.3333%}.col-md-offset-9{margin-left:75%}.col-md-11,.row.cols-md-11>*{flex-basis:91.6667%;max-width:91.6667%}.col-md-offset-10{margin-left:83.3333%}.col-md-12,.row.cols-md-12>*{flex-basis:100%;max-width:100%}.col-md-offset-11{margin-left:91.6667%}.col-md-normal{order:initial}.col-md-first{order:-999}.col-md-last{order:999}}@media screen and (width>=1280px){.col-lg,[class^=col-lg-],[class^=col-lg-offset-],.row[class*=cols-lg-]>*{box-sizing:border-box;padding:0 calc(var(--universal-padding)/2);flex:none}.col-lg,.row.cols-lg>*{flex-grow:1;flex-basis:0;max-width:100%}.col-lg-1,.row.cols-lg-1>*{flex-basis:8.33333%;max-width:8.33333%}.col-lg-offset-0{margin-left:0}.col-lg-2,.row.cols-lg-2>*{flex-basis:16.6667%;max-width:16.6667%}.col-lg-offset-1{margin-left:8.33333%}.col-lg-3,.row.cols-lg-3>*{flex-basis:25%;max-width:25%}.col-lg-offset-2{margin-left:16.6667%}.col-lg-4,.row.cols-lg-4>*{flex-basis:33.3333%;max-width:33.3333%}.col-lg-offset-3{margin-left:25%}.col-lg-5,.row.cols-lg-5>*{flex-basis:41.6667%;max-width:41.6667%}.col-lg-offset-4{margin-left:33.3333%}.col-lg-6,.row.cols-lg-6>*{flex-basis:50%;max-width:50%}.col-lg-offset-5{margin-left:41.6667%}.col-lg-7,.row.cols-lg-7>*{flex-basis:58.3333%;max-width:58.3333%}.col-lg-offset-6{margin-left:50%}.col-lg-8,.row.cols-lg-8>*{flex-basis:66.6667%;max-width:66.6667%}.col-lg-offset-7{margin-left:58.3333%}.col-lg-9,.row.cols-lg-9>*{flex-basis:75%;max-width:75%}.col-lg-offset-8{margin-left:66.6667%}.col-lg-10,.row.cols-lg-10>*{flex-basis:83.3333%;max-width:83.3333%}.col-lg-offset-9{margin-left:75%}.col-lg-11,.row.cols-lg-11>*{flex-basis:91.6667%;max-width:91.6667%}.col-lg-offset-10{margin-left:83.3333%}.col-lg-12,.row.cols-lg-12>*{flex-basis:100%;max-width:100%}.col-lg-offset-11{margin-left:91.6667%}.col-lg-normal{order:initial}.col-lg-first{order:-999}.col-lg-last{order:999}}";


var $9d140586885f60b8$exports = {};
$9d140586885f60b8$exports = ":root{--background:#f9f9f9;--on-background:black}.background-default{background:#f9f9f9}.elv-1{z-index:1;box-shadow:0 1px 1px #00000024,0 2px 1px -1px #0000001f,0 1px 3px #0003}.elv-1-imp{z-index:1;box-shadow:0 1px 1px #00000024,0 2px 1px -1px #0000001f,0 1px 3px #0003!important}.elv-2{z-index:2;box-shadow:0 2px 2px #00000024,0 3px 1px -2px #0000001f,0 1px 5px #0003}.elv-2-imp{z-index:2;box-shadow:0 2px 2px #00000024,0 3px 1px -2px #0000001f,0 1px 5px #0003!important}.elv-3{z-index:3;box-shadow:0 3px 4px #00000024,0 3px 3px -2px #0000001f,0 1px 8px #0003}.elv-3-imp{z-index:3;box-shadow:0 3px 4px #00000024,0 3px 3px -2px #0000001f,0 1px 8px #0003!important}.elv-4{z-index:4;box-shadow:0 4px 5px #00000024,0 1px 10px #0000001f,0 2px 4px -1px #0003}.elv-4-imp{z-index:4;box-shadow:0 4px 5px #00000024,0 1px 10px #0000001f,0 2px 4px -1px #0003!important}.elv-6{z-index:6;box-shadow:0 6px 10px #00000024,0 1px 18px #0000001f,0 3px 5px -1px #0003}.elv-6-imp{z-index:6;box-shadow:0 6px 10px #00000024,0 1px 18px #0000001f,0 3px 5px -1px #0003!important}.elv-8{z-index:8;box-shadow:0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f,0 5px 5px -3px #0003}.elv-8-imp{z-index:8;box-shadow:0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f,0 5px 5px -3px #0003!important}.elv-9{z-index:9;box-shadow:0 9px 12px 1px #00000024,0 3px 16px 2px #0000001f,0 5px 6px -3px #0003}.elv-9-imp{z-index:9;box-shadow:0 9px 12px 1px #00000024,0 3px 16px 2px #0000001f,0 5px 6px -3px #0003!important}.elv-12{z-index:12;box-shadow:0 12px 17px 2px #00000024,0 5px 22px 4px #0000001f,0 7px 8px -4px #0003}.elv-12-imp{z-index:12;box-shadow:0 12px 17px 2px #00000024,0 5px 22px 4px #0000001f,0 7px 8px -4px #0003!important}.elv-16{z-index:16;box-shadow:0 16px 24px 2px #00000024,0 6px 30px 5px #0000001f,0 8px 10px -5px #0003}.elv-16-imp{z-index:16;box-shadow:0 16px 24px 2px #00000024,0 6px 30px 5px #0000001f,0 8px 10px -5px #0003!important}.elv-24{z-index:24;box-shadow:0 24px 38px 3px #00000024,0 9px 46px 8px #0000001f,0 11px 15px -7px #0003}.elv-24-imp{z-index:24;box-shadow:0 24px 38px 3px #00000024,0 9px 46px 8px #0000001f,0 11px 15px -7px #0003!important}.elv-transition{transition:box-shadow .5s}html,body{color:#000;background:#f9f9f9}.btn-flat{color:#000;background:#ccc}.btn-flat:hover{background:#bfbfbf}.btn-flat:active{background:#d9d9d9}.btn,.modal .modal-action button{z-index:1;color:#000;background:#ccc;transition:box-shadow .2s;box-shadow:0 1px 1px #00000024,0 2px 1px -1px #0000001f,0 1px 3px #0003}.btn:focus,.modal .modal-action button:focus{z-index:6;box-shadow:0 6px 10px #00000024,0 1px 18px #0000001f,0 3px 5px -1px #0003}.btn:hover,.modal .modal-action button:hover{background:#bfbfbf}.btn:active,.modal .modal-action button:active{background:#d9d9d9}.fab{z-index:8;background:#ccc;transition:box-shadow .2s;box-shadow:0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f,0 5px 5px -3px #0003}.fab:focus{z-index:16;box-shadow:0 16px 24px 2px #00000024,0 6px 30px 5px #0000001f,0 8px 10px -5px #0003}.modal{z-index:24;background:#f9f9f9;box-shadow:0 24px 38px 3px #00000024,0 9px 46px 8px #0000001f,0 11px 15px -7px #0003}.inp,.input-group input{color:#000}.inp option,.input-group input option{color:#000;background:#f9f9f9}.input-checkbox span{background-color:#ccc}.list-clickable li:hover{background:#ececec}.list-selected{background:#e0e0e0}.header,.card{z-index:3;box-shadow:0 3px 4px #00000024,0 3px 3px -2px #0000001f,0 1px 8px #0003}.card-elevated{z-index:8;box-shadow:0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f,0 5px 5px -3px #0003}.table tr:nth-child(odd):not(:first-child){background:#e0e0e0}";


var $55f8a1f4830fff37$exports = {};
$55f8a1f4830fff37$exports = ":root{--background:#000;--on-background:white}.background-default{background:#000}.elv-1{z-index:1;background:#1a1a1a}.elv-1-imp{z-index:1;background:#1a1a1a!important}.elv-2{z-index:2;background:#1c1c1c}.elv-2-imp{z-index:2;background:#1c1c1c!important}.elv-3{z-index:3;background:#1f1f1f}.elv-3-imp{z-index:3;background:#1f1f1f!important}.elv-4{z-index:4;background:#1f1f1f}.elv-4-imp{z-index:4;background:#1f1f1f!important}.elv-6{z-index:6;background:#242424}.elv-6-imp{z-index:6;background:#242424!important}.elv-8{z-index:8;background:#262626}.elv-8-imp{z-index:8;background:#262626!important}.elv-9{z-index:9;background:#292929}.elv-9-imp{z-index:9;background:#292929!important}.elv-12{z-index:12;background:#2e2e2e}.elv-12-imp{z-index:12;background:#2e2e2e!important}.elv-16{z-index:16;background:#363636}.elv-16-imp{z-index:16;background:#363636!important}.elv-24{z-index:24;background:#424242}.elv-24-imp{z-index:24;background:#424242!important}.elv-transition{transition:background .5s}html,body{color:#fff;background:#000}.btn-flat{color:#000;background:#ccc}.btn-flat:hover{background:#bfbfbf}.btn-flat:active{background:#d9d9d9}.btn,.modal .modal-action button{z-index:1;color:#000;background:#ccc;transition:background .2s}.btn:focus,.modal .modal-action button:focus{z-index:6;background:#242424}.btn:hover,.modal .modal-action button:hover{background:#bfbfbf}.btn:active,.modal .modal-action button:active{background:#d9d9d9}.fab{z-index:8;background:#ccc;transition:background .2s}.fab:focus{z-index:16;background:#363636}.modal{z-index:24;background:#424242}.inp,.input-group input{color:#fff}.inp option,.input-group input option{color:#fff;background:#000}.input-checkbox span{background-color:#ccc}.list-clickable li:hover{background:#0d0d0d}.list-selected{background:#1a1a1a}.header,.card{z-index:3;background:#1f1f1f}.card-elevated{z-index:8;background:#262626}.table tr:nth-child(odd):not(:first-child){background:#1a1a1a}";


/**
 * Basic Locking mechanism for JavaScript
 *
 */ class $047cf3207cf79c4b$export$2e2bcd8739ae039 {
    _locked = false;
    /**
     * Returns the state of the Locken
     *
     * @returns {boolean}
     */ get locked() {
        return this._locked;
    }
    toCome = [];
    constructor(){
        this.release = this.release.bind(this);
    }
    /**
     * Waits till lock is free and returns a release function
     *
     * @return {function}
     */ async getLock() {
        if (!this._locked) return {
            release: this.lock()
        };
        else return new Promise((resolve)=>{
            this.toCome.push(()=>{
                resolve({
                    release: this.lock()
                });
            });
        });
    }
    lock() {
        this._locked = true;
        return this.release;
    }
    async release() {
        let next = this.toCome.shift();
        if (next) next();
        else this._locked = false;
    }
}


const $ae8634edd6e9fa90$var$ClosedSymbol = Symbol("Observable Closed");
class $ae8634edd6e9fa90$export$2e2bcd8739ae039 {
    collect_intervall;
    subscriber = [];
    subscriberCollect = [];
    events = [];
    timeout = undefined;
    // Use symbol to make sure this property cannot be changed from the outside
    [$ae8634edd6e9fa90$var$ClosedSymbol] = false;
    get closed() {
        return this[$ae8634edd6e9fa90$var$ClosedSymbol];
    }
    constructor(collect_intervall = 100){
        this.collect_intervall = collect_intervall;
    }
    subscribe(callback) {
        if (this[$ae8634edd6e9fa90$var$ClosedSymbol]) throw new Error("Observable is closed!");
        let oldcb = this.subscriber.find((e)=>e === callback);
        if (!oldcb) this.subscriber.push(callback);
        return ()=>this.unsubscribe(callback);
    }
    unsubscribe(callback) {
        if (this[$ae8634edd6e9fa90$var$ClosedSymbol]) return;
        let idx = this.subscriber.findIndex((e)=>e === callback);
        if (idx >= 0) this.subscriber.splice(idx, 1);
        else {
            idx = this.subscriberCollect.findIndex((e)=>e === callback);
            if (idx >= 0) this.subscriberCollect.splice(idx, 1);
        }
    }
    subscribeCollect(callback) {
        if (this[$ae8634edd6e9fa90$var$ClosedSymbol]) throw new Error("Observable is closed!");
        let oldcb = this.subscriberCollect.find((e)=>e === callback);
        if (!oldcb) this.subscriberCollect.push(callback);
        return ()=>this.unsubscribe(callback);
    }
    /**
     * Creates Public API with subscribe and unsubscribe
     *
     * @returns {object}
     */ getPublicApi() {
        if (this[$ae8634edd6e9fa90$var$ClosedSymbol]) throw new Error("Observable is closed!");
        return {
            subscribe: (callback)=>this.subscribe(callback),
            unsubscribe: (callback)=>this.unsubscribe(callback),
            subscribeCollect: (callback)=>this.subscribeCollect(callback)
        };
    }
    /**
     * Sends data to all subscribers
     * @param data data to be sent
     */ send(data) {
        if (this[$ae8634edd6e9fa90$var$ClosedSymbol]) throw new Error("Observable is closed!");
        Array.from(this.subscriber.values()).forEach((e)=>{
            try {
                e(data);
            } catch (err) {
                // Catch error, so it doesn't affect other subscribers
                console.error(err);
            }
        });
        if (this.subscribeCollect.length > 0) {
            this.events.push(data);
            if (!this.timeout) this.timeout = setTimeout(()=>{
                this.subscriberCollect.forEach((cb)=>{
                    cb(this.events);
                });
                this.events = [];
                this.timeout = undefined;
            }, this.collect_intervall);
        }
    }
    /**
     * Closes Observable. This will remove all subscribers and mark this observable as closed.
     * You won't be able to reopen this observable. All maybe collected data will be discardet.
     */ close() {
        this[$ae8634edd6e9fa90$var$ClosedSymbol] = true;
        this.subscriber = [];
        this.subscriberCollect = [];
        this.events = [];
        if (this.timeout) clearTimeout(this.timeout);
    }
}



class $5863cc0890fa3ad9$export$2e2bcd8739ae039 {
    _value;
    observable = new (0, $ae8634edd6e9fa90$export$2e2bcd8739ae039)();
    constructor(_value){
        this._value = _value;
        this.subscribe = this.subscribe.bind(this);
        this.unsubscribe = this.unsubscribe.bind(this);
    }
    /**
     * Get the current value
     */ get value() {
        return this._value;
    }
    /**
     * Set a new value and notify subscribers
     * @param value Value to be set
     */ send(value) {
        this._value = value;
        this.observable.send(value);
    }
    /**
     * Get the current value as well as all changes
     * @param handler Handler called on change
     */ subscribe(handler) {
        handler(this._value);
        return this.observable.subscribe(handler);
    }
    /**
     * Unsubscribe from changes
     * @param handler The handler to unsubscribe
     */ unsubscribe(handler) {
        this.observable.unsubscribe(handler);
    }
    /**
     * Await a specific value and return.
     *
     * For example if val = true then this function would block until the value
     * is actually true. If it is true, then the promise will resolve immediatly
     *
     * @param val Value to await
     */ awaitValue(val) {
        let ignore = ()=>undefined;
        let prms = new Promise((yes)=>{
            const cb = ()=>{
                if (typeof val === "function") {
                    if (val(this._value)) {
                        yes();
                        this.unsubscribe(cb);
                    }
                } else if (this._value === val) {
                    yes();
                    this.unsubscribe(cb);
                }
            };
            this.subscribe(cb);
        });
        return {
            then: prms.then.bind(prms),
            catch: prms.catch.bind(prms),
            ignore: ()=>ignore()
        };
    }
    /**
     * Creates Public API with subscribe and unsubscribe
     *
     * @returns {object}
     */ getPublicApi() {
        if (this.observable.closed) throw new Error("Observable is closed!");
        return {
            subscribe: (callback)=>this.subscribe(callback),
            unsubscribe: (callback)=>this.unsubscribe(callback),
            awaitValue: (value)=>this.awaitValue(value)
        };
    }
    /**
     * Close this store. All subscribers will be unsubscribed and any further operations will fail
     */ close() {
        this.observable.close();
    }
}



class $c78ff3ac0fdb5246$export$2e2bcd8739ae039 {
    awaiter = [];
    sendSignal() {
        this.awaiter.forEach((a)=>a());
        this.awaiter = [];
    }
    awaitSignal() {
        return new Promise((resolve)=>{
            this.awaiter.push(resolve);
        });
    }
}


class $3554690f94751f1d$export$2e2bcd8739ae039 {
    #onClose = [];
    #onData = new (0, $ae8634edd6e9fa90$export$2e2bcd8739ae039)();
    constructor(){}
    onClose(callback) {
        this.#onClose.push(callback);
    }
    getCallback() {
        return (error, data)=>{
            this.#onData.send({
                error: error,
                data: data,
                close: undefined
            });
        };
    }
    send(data) {
        this.#onData.send({
            error: undefined,
            data: data,
            close: undefined
        });
    }
    close() {
        this.#onData.send({
            close: true,
            data: undefined,
            error: undefined
        });
        this.#onData.close();
        this.#onClose.forEach((cb)=>cb());
    }
    [Symbol.asyncIterator]() {
        const queue = [];
        const signal = new (0, $c78ff3ac0fdb5246$export$2e2bcd8739ae039)();
        this.#onData.subscribe((data)=>{
            queue.push(data);
            signal.sendSignal();
        });
        return {
            async next () {
                const send = ()=>{
                    const value = queue.shift();
                    if (!value) throw new Error("Error in AsyncIter");
                    if (value.close) return {
                        done: true,
                        value: undefined
                    };
                    else if (value.error) throw value.error;
                    else return {
                        done: false,
                        value: value.data
                    };
                };
                if (queue.length > 0) return send();
                else {
                    await signal.awaitSignal();
                    return send();
                }
            }
        };
    }
}





document.head.appendChild(document.createElement("style")).innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($36125daf8ed1aaea$exports)));
var $ab361099379de31a$export$39acef56d7f48a30;
(function(ThemeStates) {
    ThemeStates[ThemeStates["AUTO"] = 0] = "AUTO";
    ThemeStates[ThemeStates["LIGHT"] = 1] = "LIGHT";
    ThemeStates[ThemeStates["DARK"] = 2] = "DARK";
})($ab361099379de31a$export$39acef56d7f48a30 || ($ab361099379de31a$export$39acef56d7f48a30 = {}));
let $ab361099379de31a$var$themeConfig = Number(localStorage.getItem("theme"));
if (Number.isNaN($ab361099379de31a$var$themeConfig)) $ab361099379de31a$var$themeConfig = 0;
let $ab361099379de31a$var$isDark = false;
let $ab361099379de31a$var$mediaIsDark = false;
if (window.matchMedia) {
    const mediaq = matchMedia("(prefers-color-scheme: dark)");
    $ab361099379de31a$var$mediaIsDark = mediaq.matches;
    mediaq.onchange = (ev)=>{
        $ab361099379de31a$var$mediaIsDark = ev.matches;
        $ab361099379de31a$var$apply();
    };
}
const $ab361099379de31a$var$isDarkObs = new (0, $ae8634edd6e9fa90$export$2e2bcd8739ae039)();
let $ab361099379de31a$var$styleElm;
function $ab361099379de31a$var$apply(force) {
    let shouldDark = $ab361099379de31a$var$themeConfig === 0 ? $ab361099379de31a$var$mediaIsDark : $ab361099379de31a$var$themeConfig === 2;
    if (force || shouldDark !== $ab361099379de31a$var$isDark) {
        if ($ab361099379de31a$var$styleElm) $ab361099379de31a$var$styleElm.remove();
        $ab361099379de31a$var$styleElm = document.createElement("style");
        document.head.appendChild($ab361099379de31a$var$styleElm);
        $ab361099379de31a$var$styleElm.innerHTML = shouldDark ? (0, (/*@__PURE__*/$parcel$interopDefault($55f8a1f4830fff37$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($9d140586885f60b8$exports)));
        $ab361099379de31a$var$isDark = shouldDark;
        $ab361099379de31a$var$isDarkObs.send($ab361099379de31a$var$isDark);
    }
}
$ab361099379de31a$var$apply(true);
function $ab361099379de31a$var$change(state, save) {
    $ab361099379de31a$var$themeConfig = state;
    if (save) localStorage.setItem("theme", String($ab361099379de31a$var$themeConfig));
    $ab361099379de31a$var$apply();
}
var $ab361099379de31a$export$2e2bcd8739ae039 = {
    active: ()=>$ab361099379de31a$var$themeConfig,
    change: (state, save = true)=>$ab361099379de31a$var$change(state, save),
    isDark: ()=>$ab361099379de31a$var$isDark,
    isDarkObservable: $ab361099379de31a$var$isDarkObs.getPublicApi()
};


class $26110e5e514dd1f1$export$43dbf75585287913 extends (0, $54cd03c1d32ebcab$export$16fa2f45be04daa8) {
    constructor(props){
        super(props);
    }
    componentWillMount() {
        this.current = (0, $ab361099379de31a$export$2e2bcd8739ae039).active();
        (0, $ab361099379de31a$export$2e2bcd8739ae039).change((0, $ab361099379de31a$export$39acef56d7f48a30).LIGHT, false);
    }
    componentWillUnmount() {
        (0, $ab361099379de31a$export$2e2bcd8739ae039).change(this.current, false);
    }
    render(props, state) {
        return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
            children: [
                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("header", {
                    class: "header",
                    style: "border-bottom: 0",
                    children: [
                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("a", {
                            href: "#",
                            class: "logo",
                            children: "EBook Store"
                        }),
                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("span", {
                            style: " position:absolute; right: 0;",
                            children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("a", {
                                href: (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).loginUrl,
                                class: "login",
                                children: "Sign In"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                    class: "splash-container",
                    children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                        class: "splash",
                        children: [
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("h1", {
                                class: "splash-head",
                                children: "Ebook Store"
                            }),
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("p", {
                                class: "splash-subhead",
                                children: "Keep your books in one place"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                    class: "content-wrapper",
                    children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                        class: "content",
                        children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                            class: "container",
                            children: [
                                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                    class: "row",
                                    children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("h2", {
                                        class: "content-head is-center",
                                        children: "Import from different locations:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                    className: "row provider-grid",
                                    children: [
                                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                            class: "col-sm-12 col-md-4 col-lg-4 provider-item",
                                            children: [
                                                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($533c30c7538d0ac3$exports))),
                                                    class: "provider-image"
                                                }),
                                                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("h2", {
                                                    class: "provider-name",
                                                    children: "Wattpad"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                            class: "col-sm-12 col-md-4 col-lg-4 provider-item",
                                            children: [
                                                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e62867419c0be676$exports))),
                                                    class: "provider-image"
                                                }),
                                                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("h2", {
                                                    class: "provider-name",
                                                    children: "AO3"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                            class: "col-sm-12 col-md-4 col-lg-4 provider-item",
                                            children: [
                                                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($2d511e294a23bdc8$exports))),
                                                    class: "provider-image"
                                                }),
                                                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("h2", {
                                                    class: "provider-name",
                                                    children: "Epub"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        });
    }
}







var $5c3d1d9675d0a11e$export$c717c2ee03fc6c49;
(function(Pages) {
    Pages[Pages["Library"] = 0] = "Library";
    Pages[Pages["Stats"] = 1] = "Stats";
    Pages[Pages["Reader"] = 2] = "Reader";
    Pages[Pages["Add"] = 3] = "Add";
    Pages[Pages["Details"] = 4] = "Details";
    Pages[Pages["Browse"] = 5] = "Browse";
    Pages[Pages["Edit"] = 6] = "Edit";
})($5c3d1d9675d0a11e$export$c717c2ee03fc6c49 || ($5c3d1d9675d0a11e$export$c717c2ee03fc6c49 = {}));
class $5c3d1d9675d0a11e$export$2e2bcd8739ae039 {
    static{
        this._page = 0;
    }
    static{
        this.pageObservableServer = new (0, $ae8634edd6e9fa90$export$2e2bcd8739ae039)();
    }
    static{
        this.pageObservable = $5c3d1d9675d0a11e$export$2e2bcd8739ae039.pageObservableServer.getPublicApi();
    }
    static get state() {
        return $5c3d1d9675d0a11e$export$2e2bcd8739ae039._state;
    }
    static setPage(page, state) {
        // console.log("Set page:", page);
        if ($5c3d1d9675d0a11e$export$2e2bcd8739ae039.page !== page || JSON.stringify(state) !== JSON.stringify($5c3d1d9675d0a11e$export$2e2bcd8739ae039.state)) {
            $5c3d1d9675d0a11e$export$2e2bcd8739ae039._state = state;
            $5c3d1d9675d0a11e$export$2e2bcd8739ae039._page = page;
            let s = "";
            if (state) s = "&state=" + encodeURIComponent(JSON.stringify(state));
            let newhash = "#" + $5c3d1d9675d0a11e$export$c717c2ee03fc6c49[page] + s;
            if (window.location.hash !== newhash) window.history.pushState({}, document.title, newhash);
            this.pageObservableServer.send({
                page: page,
                state: state
            });
        }
    }
    static get page() {
        return this._page;
    }
    static onHashChange() {
        let hash = window.location.hash.substring(1);
        if (hash && hash !== "") {
            let [page, state] = hash.split("&state=");
            if (page && Number(page) !== Number.NaN) {
                let p = $5c3d1d9675d0a11e$export$c717c2ee03fc6c49[page];
                if (!p) p = 0;
                let s = undefined;
                if (state) try {
                    s = JSON.parse(decodeURIComponent(state));
                } catch (err) {
                    s = undefined;
                    console.error(err);
                }
                $5c3d1d9675d0a11e$export$2e2bcd8739ae039.setPage(p, s);
            }
        } else $5c3d1d9675d0a11e$export$2e2bcd8739ae039.setPage(0, undefined);
    }
}
window.onhashchange = ()=>{
    $5c3d1d9675d0a11e$export$2e2bcd8739ae039.onHashChange();
};
$5c3d1d9675d0a11e$export$2e2bcd8739ae039.onHashChange();




const $e989e101ea7a53c6$export$882edb4b4a2c0561 = (props)=>{
    const color = props.color || "currentColor";
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (0, $54cd03c1d32ebcab$export$c8a8987d4410bf2d)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    }, props), (0, $54cd03c1d32ebcab$export$c8a8987d4410bf2d)("circle", {
        cx: "12",
        cy: "12",
        r: "1"
    }), (0, $54cd03c1d32ebcab$export$c8a8987d4410bf2d)("circle", {
        cx: "12",
        cy: "5",
        r: "1"
    }), (0, $54cd03c1d32ebcab$export$c8a8987d4410bf2d)("circle", {
        cx: "12",
        cy: "19",
        r: "1"
    }));
};



async function $fa18f20fb7e134af$var$clearCache(evt) {
    evt.preventDefault();
    if ("serviceWorker" in navigator) {
        let reg = await navigator.serviceWorker.getRegistration();
        if (reg) reg.active.postMessage("clear_cache");
    }
}
function $fa18f20fb7e134af$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
        class: "header",
        children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("header", {
            style: "border-bottom: unset;",
            children: [
                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("span", {
                    class: "logo",
                    onClick: (evt)=>evt.preventDefault() || (0, $5c3d1d9675d0a11e$export$2e2bcd8739ae039).setPage((0, $5c3d1d9675d0a11e$export$c717c2ee03fc6c49).Library, undefined),
                    children: "EBook Store"
                }),
                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("span", {
                    style: "position:absolute; right: 0;",
                    children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                        class: "dd",
                        children: [
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("button", {
                                class: "db",
                                "aria-label": "more",
                                children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $e989e101ea7a53c6$export$882edb4b4a2c0561), {})
                            }),
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                class: "dc",
                                children: [
                                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("a", {
                                        href: "#",
                                        onClick: (evt)=>evt.preventDefault() || (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).logout(),
                                        children: "logout"
                                    }),
                                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("a", {
                                        href: "#",
                                        onClick: (evt)=>evt.preventDefault() || (0, $5c3d1d9675d0a11e$export$2e2bcd8739ae039).setPage((0, $5c3d1d9675d0a11e$export$c717c2ee03fc6c49).Stats, undefined),
                                        children: "show stats"
                                    }),
                                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("a", {
                                        href: "#",
                                        onClick: $fa18f20fb7e134af$var$clearCache,
                                        children: "clear site cache"
                                    }),
                                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                        style: "display: flex;",
                                        children: [
                                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("a", {
                                                href: "#",
                                                onClick: (e)=>{
                                                    e.preventDefault();
                                                    (0, $ab361099379de31a$export$2e2bcd8739ae039).change(0);
                                                },
                                                children: "auto"
                                            }),
                                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("a", {
                                                href: "#",
                                                onClick: (e)=>{
                                                    e.preventDefault();
                                                    (0, $ab361099379de31a$export$2e2bcd8739ae039).change(1);
                                                },
                                                children: "light"
                                            }),
                                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("a", {
                                                href: "#",
                                                onClick: (e)=>{
                                                    e.preventDefault();
                                                    (0, $ab361099379de31a$export$2e2bcd8739ae039).change(2);
                                                },
                                                children: "dark"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("p", {
                                        style: "padding: 1em",
                                        children: "Version: 2.2"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}












const $2a7c4fa827e68cd8$export$124e3c1601ad9a28 = (props)=>{
    const color = props.color || "currentColor";
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (0, $54cd03c1d32ebcab$export$c8a8987d4410bf2d)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    }, props), (0, $54cd03c1d32ebcab$export$c8a8987d4410bf2d)("polyline", {
        points: "23 4 23 10 17 10"
    }), (0, $54cd03c1d32ebcab$export$c8a8987d4410bf2d)("polyline", {
        points: "1 20 1 14 7 14"
    }), (0, $54cd03c1d32ebcab$export$c8a8987d4410bf2d)("path", {
        d: "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
    }));
};



var $65fbc7b903df891b$exports = {};
$65fbc7b903df891b$exports = new URL("NewBadge.8f7e2e04.svg", import.meta.url).toString();


var $232d771ed3d18185$exports = {};
$232d771ed3d18185$exports = new URL("FinishedBadge.f68e586d.svg", import.meta.url).toString();




const $0152a03585a3dfe6$var$MIN_TOUCH = 10;
class $0152a03585a3dfe6$export$2e2bcd8739ae039 extends (0, $54cd03c1d32ebcab$export$16fa2f45be04daa8) {
    constructor(props, ctx){
        super(props, ctx);
        this.touch = false;
        this.right = false;
        this.onStart = this.onStart.bind(this);
        this.onEnd = this.onEnd.bind(this);
        this.cancel = this.cancel.bind(this);
        this.onContext = this.onContext.bind(this);
    }
    onContext(evt) {
        evt.preventDefault();
        if (this.props.context) this.props.context();
    }
    onStart(evt) {
        if (evt.button == 2) this.right = true;
        else if (evt.button == 0 || evt instanceof TouchEvent) {
            if (this.timeout) clearTimeout(this.timeout);
            this.touch = true;
            this.start = new Date();
            this.timeout = setTimeout(()=>{
                this.timeout = undefined;
                if (this.props.longclick) this.props.longclick();
            }, 1000);
        }
    }
    onEnd(evt) {
        if (evt.cancelable) evt.preventDefault();
        if (evt.button == 2) {
            if (this.right) {
                this.right = false;
                if (this.props.context) this.props.context();
            }
        } else if (evt.button == 0 || evt instanceof TouchEvent) {
            if (this.touch) {
                if (this.timeout) {
                    clearTimeout(this.timeout);
                    console.log(new Date().valueOf() - this.start.valueOf());
                    if (this.start && new Date().valueOf() - this.start.valueOf() > $0152a03585a3dfe6$var$MIN_TOUCH) {
                        console.log("Click");
                        if (this.props.click) this.props.click();
                    }
                }
                this.touch = false;
            }
        }
    }
    cancel(evt) {
        if (this.timeout) clearTimeout(this.timeout);
        this.touch = false;
    }
    componentWillMount() {
        window.addEventListener("scroll", this.cancel);
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.cancel);
    }
    render() {
        return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
            onTouchStart: this.onStart,
            onTouchEnd: this.onEnd,
            onTouchMove: this.cancel,
            onMouseDown: this.onStart,
            onMouseUp: this.onEnd,
            // onMouseOut={this.cancel}
            // onMouseMove={this.cancel}
            onScroll: this.cancel,
            onContextMenuCapture: this.onContext,
            onClick: (evt)=>evt.preventDefault(),
            onContextMenu: (evt)=>evt.preventDefault(),
            children: this.props.children
        });
    }
}


class $2f9e3554202bc888$export$9040a54ae695c16f extends (0, $54cd03c1d32ebcab$export$16fa2f45be04daa8) {
    componentDidMount() {}
    render(props, state) {
        let work = props.work;
        let badge;
        if (props.work.new) badge = /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($65fbc7b903df891b$exports))),
            alt: "is new",
            style: "position: absolute; top: 0; bottom: 0; height:25%"
        });
        else if (props.work.finished) badge = /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($232d771ed3d18185$exports))),
            alt: "is finished",
            style: "position: absolute; top: 0; bottom: 0; height:25%"
        });
        let reload;
        if (props.work.reload) reload = /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("a", {
            href: "#",
            class: "work-reload-button",
            "aria-label": "reload work " + props.work.title + " by " + props.work.author,
            onClick: async (evt)=>{
                evt.stopPropagation();
                evt.preventDefault();
                if (work && (work.type === "ao3" || work.type === "wattpad")) // if (e.parentElement)
                // e.parentElement.classList.add("book-card-disabled");
                // this.disabled_works.push(id);
                await (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).addWorkWithId(work.type, work.workid);
            },
            children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $2a7c4fa827e68cd8$export$124e3c1601ad9a28), {})
        });
        let cover = !work.cover ? undefined : /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("img", {
            style: "position: absolute; top: 0; bottom: 0; height: 100%; width: 100%",
            src: work.cover,
            alt: "image cover"
        });
        return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $0152a03585a3dfe6$export$2e2bcd8739ae039), {
            click: ()=>(0, $5c3d1d9675d0a11e$export$2e2bcd8739ae039).setPage((0, $5c3d1d9675d0a11e$export$c717c2ee03fc6c49).Reader, work._id),
            longclick: ()=>(0, $5c3d1d9675d0a11e$export$2e2bcd8739ae039).setPage((0, $5c3d1d9675d0a11e$export$c717c2ee03fc6c49).Details, work._id),
            context: ()=>(0, $5c3d1d9675d0a11e$export$2e2bcd8739ae039).setPage((0, $5c3d1d9675d0a11e$export$c717c2ee03fc6c49).Details, work._id),
            children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                class: "work-container" + (work.disabled ? " work-disabled" : ""),
                children: [
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                        class: "work-image elv-8",
                        children: [
                            cover,
                            badge,
                            reload,
                            work.progress && work.progress > 0 ? /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("a", {
                                class: "work-progress",
                                children: [
                                    Math.round(work.progress * 100),
                                    "%"
                                ]
                            }) : undefined
                        ]
                    }),
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                        class: "",
                        children: [
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                class: "work-title",
                                children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("b", {
                                    children: work.title
                                })
                            }),
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                class: "work-subtitle",
                                children: work.author
                            })
                        ]
                    })
                ]
            })
        });
    }
}



const $368a3878b75366d6$export$6ed0965c9443aaa6 = (props)=>{
    const color = props.color || "currentColor";
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (0, $54cd03c1d32ebcab$export$c8a8987d4410bf2d)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    }, props), (0, $54cd03c1d32ebcab$export$c8a8987d4410bf2d)("path", {
        d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
    }), (0, $54cd03c1d32ebcab$export$c8a8987d4410bf2d)("path", {
        d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
    }));
};


const $95f3e248299245ff$export$2d9ac7aa84f97a08 = (props)=>{
    const color = props.color || "currentColor";
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (0, $54cd03c1d32ebcab$export$c8a8987d4410bf2d)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    }, props), (0, $54cd03c1d32ebcab$export$c8a8987d4410bf2d)("line", {
        x1: "12",
        y1: "5",
        x2: "12",
        y2: "19"
    }), (0, $54cd03c1d32ebcab$export$c8a8987d4410bf2d)("line", {
        x1: "5",
        y1: "12",
        x2: "19",
        y2: "12"
    }));
};


const $5cb3d4452dd91ee8$export$4b85d3515bd863a5 = (props)=>{
    const color = props.color || "currentColor";
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (0, $54cd03c1d32ebcab$export$c8a8987d4410bf2d)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    }, props), (0, $54cd03c1d32ebcab$export$c8a8987d4410bf2d)("circle", {
        cx: "11",
        cy: "11",
        r: "8"
    }), (0, $54cd03c1d32ebcab$export$c8a8987d4410bf2d)("line", {
        x1: "21",
        y1: "21",
        x2: "16.65",
        y2: "16.65"
    }));
};






var $79abdce4f0f4201e$var$t, $79abdce4f0f4201e$var$r, $79abdce4f0f4201e$var$u, $79abdce4f0f4201e$var$i, $79abdce4f0f4201e$var$o = 0, $79abdce4f0f4201e$var$f = [], $79abdce4f0f4201e$var$c = (0, $54cd03c1d32ebcab$export$41c562ebe57d11e2), $79abdce4f0f4201e$var$e = $79abdce4f0f4201e$var$c.__b, $79abdce4f0f4201e$var$a = $79abdce4f0f4201e$var$c.__r, $79abdce4f0f4201e$var$v = $79abdce4f0f4201e$var$c.diffed, $79abdce4f0f4201e$var$l = $79abdce4f0f4201e$var$c.__c, $79abdce4f0f4201e$var$m = $79abdce4f0f4201e$var$c.unmount, $79abdce4f0f4201e$var$s = $79abdce4f0f4201e$var$c.__;
function $79abdce4f0f4201e$var$d(n, t) {
    $79abdce4f0f4201e$var$c.__h && $79abdce4f0f4201e$var$c.__h($79abdce4f0f4201e$var$r, n, $79abdce4f0f4201e$var$o || t), $79abdce4f0f4201e$var$o = 0;
    var u = $79abdce4f0f4201e$var$r.__H || ($79abdce4f0f4201e$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $79abdce4f0f4201e$export$60241385465d0a34(n) {
    return $79abdce4f0f4201e$var$o = 1, $79abdce4f0f4201e$export$13e3392192263954($79abdce4f0f4201e$var$D, n);
}
function $79abdce4f0f4201e$export$13e3392192263954(n, u, i) {
    var o = $79abdce4f0f4201e$var$d($79abdce4f0f4201e$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $79abdce4f0f4201e$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $79abdce4f0f4201e$var$r, !$79abdce4f0f4201e$var$r.u)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !(!i && o.__c.props === n) && (!c || c.call(this, n, t, r));
        };
        $79abdce4f0f4201e$var$r.u = !0;
        var c = $79abdce4f0f4201e$var$r.shouldComponentUpdate, e = $79abdce4f0f4201e$var$r.componentWillUpdate;
        $79abdce4f0f4201e$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $79abdce4f0f4201e$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $79abdce4f0f4201e$export$6d9c69b0de29b591(n, u) {
    var i = $79abdce4f0f4201e$var$d($79abdce4f0f4201e$var$t++, 3);
    !$79abdce4f0f4201e$var$c.__s && $79abdce4f0f4201e$var$C(i.__H, u) && (i.__ = n, i.i = u, $79abdce4f0f4201e$var$r.__H.__h.push(i));
}
function $79abdce4f0f4201e$export$e5c5a5f917a5871c(n, u) {
    var i = $79abdce4f0f4201e$var$d($79abdce4f0f4201e$var$t++, 4);
    !$79abdce4f0f4201e$var$c.__s && $79abdce4f0f4201e$var$C(i.__H, u) && (i.__ = n, i.i = u, $79abdce4f0f4201e$var$r.__h.push(i));
}
function $79abdce4f0f4201e$export$b8f5890fc79d6aca(n) {
    return $79abdce4f0f4201e$var$o = 5, $79abdce4f0f4201e$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $79abdce4f0f4201e$export$d5a552a76deda3c2(n, t, r) {
    $79abdce4f0f4201e$var$o = 6, $79abdce4f0f4201e$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $79abdce4f0f4201e$export$1538c33de8887b59(n, r) {
    var u = $79abdce4f0f4201e$var$d($79abdce4f0f4201e$var$t++, 7);
    return $79abdce4f0f4201e$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $79abdce4f0f4201e$export$35808ee640e87ca7(n, t) {
    return $79abdce4f0f4201e$var$o = 8, $79abdce4f0f4201e$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $79abdce4f0f4201e$export$fae74005e78b1a27(n) {
    var u = $79abdce4f0f4201e$var$r.context[n.__c], i = $79abdce4f0f4201e$var$d($79abdce4f0f4201e$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($79abdce4f0f4201e$var$r)), u.props.value) : n.__;
}
function $79abdce4f0f4201e$export$dc8fbce3eb94dc1e(n, t) {
    $79abdce4f0f4201e$var$c.useDebugValue && $79abdce4f0f4201e$var$c.useDebugValue(t ? t(n) : n);
}
function $79abdce4f0f4201e$export$c052f6604b7d51fe(n) {
    var u = $79abdce4f0f4201e$var$d($79abdce4f0f4201e$var$t++, 10), i = $79abdce4f0f4201e$export$60241385465d0a34();
    return u.__ = n, $79abdce4f0f4201e$var$r.componentDidCatch || ($79abdce4f0f4201e$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $79abdce4f0f4201e$export$f680877a34711e37() {
    var n = $79abdce4f0f4201e$var$d($79abdce4f0f4201e$var$t++, 11);
    if (!n.__) {
        for(var u = $79abdce4f0f4201e$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $79abdce4f0f4201e$var$j() {
    for(var n; n = $79abdce4f0f4201e$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($79abdce4f0f4201e$var$z), n.__H.__h.forEach($79abdce4f0f4201e$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $79abdce4f0f4201e$var$c.__e(t, n.__v);
    }
}
$79abdce4f0f4201e$var$c.__b = function(n) {
    $79abdce4f0f4201e$var$r = null, $79abdce4f0f4201e$var$e && $79abdce4f0f4201e$var$e(n);
}, $79abdce4f0f4201e$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $79abdce4f0f4201e$var$s && $79abdce4f0f4201e$var$s(n, t);
}, $79abdce4f0f4201e$var$c.__r = function(n) {
    $79abdce4f0f4201e$var$a && $79abdce4f0f4201e$var$a(n), $79abdce4f0f4201e$var$t = 0;
    var i = ($79abdce4f0f4201e$var$r = n.__c).__H;
    i && ($79abdce4f0f4201e$var$u === $79abdce4f0f4201e$var$r ? (i.__h = [], $79abdce4f0f4201e$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.i = n.__N = void 0;
    })) : (i.__h.forEach($79abdce4f0f4201e$var$z), i.__h.forEach($79abdce4f0f4201e$var$B), i.__h = [], $79abdce4f0f4201e$var$t = 0)), $79abdce4f0f4201e$var$u = $79abdce4f0f4201e$var$r;
}, $79abdce4f0f4201e$var$c.diffed = function(n) {
    $79abdce4f0f4201e$var$v && $79abdce4f0f4201e$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $79abdce4f0f4201e$var$f.push(t) && $79abdce4f0f4201e$var$i === $79abdce4f0f4201e$var$c.requestAnimationFrame || (($79abdce4f0f4201e$var$i = $79abdce4f0f4201e$var$c.requestAnimationFrame) || $79abdce4f0f4201e$var$w)($79abdce4f0f4201e$var$j)), t.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.i = void 0;
    })), $79abdce4f0f4201e$var$u = $79abdce4f0f4201e$var$r = null;
}, $79abdce4f0f4201e$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($79abdce4f0f4201e$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $79abdce4f0f4201e$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $79abdce4f0f4201e$var$c.__e(r, n.__v);
        }
    }), $79abdce4f0f4201e$var$l && $79abdce4f0f4201e$var$l(n, t);
}, $79abdce4f0f4201e$var$c.unmount = function(n) {
    $79abdce4f0f4201e$var$m && $79abdce4f0f4201e$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $79abdce4f0f4201e$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $79abdce4f0f4201e$var$c.__e(t, r.__v));
};
var $79abdce4f0f4201e$var$k = "function" == typeof requestAnimationFrame;
function $79abdce4f0f4201e$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $79abdce4f0f4201e$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $79abdce4f0f4201e$var$k && (t = requestAnimationFrame(r));
}
function $79abdce4f0f4201e$var$z(n) {
    var t = $79abdce4f0f4201e$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $79abdce4f0f4201e$var$r = t;
}
function $79abdce4f0f4201e$var$B(n) {
    var t = $79abdce4f0f4201e$var$r;
    n.__c = n.__(), $79abdce4f0f4201e$var$r = t;
}
function $79abdce4f0f4201e$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $79abdce4f0f4201e$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}



const $ddd8694e50ec82d7$var$modalObservable = new (0, $5863cc0890fa3ad9$export$2e2bcd8739ae039)(undefined);
function $ddd8694e50ec82d7$export$d7e8d4d4450c819c(modal) {
    $ddd8694e50ec82d7$var$modalObservable.send(modal);
    console.log($ddd8694e50ec82d7$var$modalObservable);
    return {
        close: ()=>{
            console.log($ddd8694e50ec82d7$var$modalObservable.value, modal);
            if ($ddd8694e50ec82d7$var$modalObservable.value === modal) $ddd8694e50ec82d7$var$modalObservable.send(undefined);
        }
    };
}
function $ddd8694e50ec82d7$export$d507f25e63650365() {
    const [modal, setModal] = (0, $79abdce4f0f4201e$export$60241385465d0a34)(()=>$ddd8694e50ec82d7$var$modalObservable.value);
    (0, $79abdce4f0f4201e$export$6d9c69b0de29b591)(()=>{
        const db = (modal)=>{
            setModal(()=>modal);
        };
        $ddd8694e50ec82d7$var$modalObservable.subscribe(db);
        return ()=>$ddd8694e50ec82d7$var$modalObservable.unsubscribe(db);
    }, []);
    console.log(modal);
    return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
        class: "modal-controller",
        children: [
            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                class: "bg" + (modal ? " active" : ""),
                onClick: (evt)=>{
                    $ddd8694e50ec82d7$var$modalObservable.send(undefined);
                }
            }),
            modal && /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                className: "modal",
                children: modal()
            })
        ]
    }, modal);
}







function $34cf621a66f62afb$export$2e2bcd8739ae039({ icon: icon, items: items }) {
    const [open, setOpen] = (0, $79abdce4f0f4201e$export$60241385465d0a34)(false);
    return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
        class: "cfab",
        children: [
            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("a", {
                class: "elv-16 btn btn-primary",
                // style="color:white;"
                style: {
                    transform: open ? "rotateZ(135deg)" : undefined
                },
                "aria-label": "add",
                onClick: (evt)=>evt.preventDefault() || setOpen((o)=>!o),
                children: icon
            }),
            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("ul", {
                class: open ? "visible" : "",
                children: items.map((i)=>/*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("li", {
                        children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("a", {
                            class: "elv-16 btn btn-primary",
                            // style="color:white;"
                            "aria-label": i.label,
                            onClick: (evt)=>{
                                evt.preventDefault();
                                setOpen(false);
                                i.onClick();
                            },
                            children: i.icon
                        })
                    }))
            })
        ]
    });
}


// import ScrollViewport from "preact-scroll-viewport";
// import VirtualList from "../../virtual_scroll";
// import VirtualList from "preact-virtual-list/src/index.js";
function $c8531f9e595511bf$var$showAddModal() {
    const controls = (0, $ddd8694e50ec82d7$export$d7e8d4d4450c819c)(()=>{
        const [loading, setLoading] = (0, $79abdce4f0f4201e$export$60241385465d0a34)(false);
        const [message, setMessage] = (0, $79abdce4f0f4201e$export$60241385465d0a34)("");
        const [error, setError] = (0, $79abdce4f0f4201e$export$60241385465d0a34)(undefined);
        const textInput = (0, $79abdce4f0f4201e$export$b8f5890fc79d6aca)();
        const addFromFile = async (file)=>{
            if (file.name.endsWith(".epub")) {
                console.log("Epub found!");
                try {
                    await (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).addEPub(file);
                } catch (e) {
                    alert("Some error occured, please try again later: " + e.message);
                }
            } else await new Promise((yes, no)=>{
                let r = new FileReader();
                r.onload = async (e)=>{
                    try {
                        setLoading(true);
                        let content = e.target.result;
                        let wks = content.split("\n").map((e)=>e.trim()).filter((e)=>e !== "");
                        let current = 0;
                        let drawpg = ()=>{
                            setMessage(`Converted ${current} from ${wks.length}`);
                        };
                        drawpg();
                        for (let w of wks){
                            await (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).addWorkFromUrl(w);
                            current++;
                            drawpg();
                        }
                    } catch (e) {
                        alert("Some error occured, please try again later: " + e.message);
                    } finally{
                        yes();
                    }
                };
                r.readAsText(file);
            });
        };
        const fileSelectedHandler = async (evt)=>{
            let files = evt.target.files;
            setLoading(true);
            try {
                for (let file of files){
                    setMessage("Uploading " + file.name);
                    await addFromFile(file);
                }
                controls.close();
            } catch (e) {
                alert("Failed to load file");
            }
            setMessage("");
            setLoading(false);
            evt.target.value = null;
        };
        const addFromUrl = async (evt)=>{
            setMessage("Working");
            setLoading(true);
            let url = textInput.current.value;
            if (url) await (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).addWorkFromUrl(url).then(()=>{
                if (textInput.current) textInput.current.value = null;
                controls.close();
            }).catch((err)=>alert(err.message));
            setMessage("");
            setLoading(false);
        };
        return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $54cd03c1d32ebcab$export$ffb0004e005737fa), {
            children: [
                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                    className: "modal-title",
                    children: "Add"
                }),
                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                    className: "modal-content",
                    children: loading ? /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                        id: "add_work_loader",
                        style: "display:{{#if loader_visibility}}block{{else}}none{{/if}};",
                        children: [
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("h3", {
                                children: message
                            }),
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                style: "width: 65px; height: 65px; margin: 0 auto;",
                                children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("svg", {
                                    class: "spinner",
                                    viewBox: "0 0 66 66",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("circle", {
                                        class: "circle",
                                        fill: "none",
                                        "stroke-width": "6",
                                        "stroke-linecap": "round",
                                        cx: "33",
                                        cy: "33",
                                        r: "30"
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                        children: [
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                class: "input-group",
                                children: [
                                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("label", {
                                        for: "url",
                                        children: "Enter URL of work"
                                    }),
                                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("input", {
                                        type: "text",
                                        id: "url",
                                        name: "url",
                                        autofocus: true,
                                        value: textInput?.current?.value,
                                        ref: textInput
                                    }),
                                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                        class: "error invisible",
                                        id: "url_error"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                class: "group",
                                children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("input", {
                                    class: "btn",
                                    id: "add_wp_book_bulk",
                                    type: "file",
                                    multiple: true,
                                    onChange: fileSelectedHandler
                                })
                            }),
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("button", {
                                id: "add_work_save",
                                type: "submit",
                                class: "btn",
                                onClick: addFromUrl,
                                children: "Add"
                            })
                        ]
                    })
                })
            ]
        });
    });
}
class $c8531f9e595511bf$export$9f2b2187e67812d8 extends (0, $54cd03c1d32ebcab$export$16fa2f45be04daa8) {
    set search(value) {
        value = value.toLowerCase();
        if (this._search !== value) {
            let full = true;
            if (value.startsWith(this._search)) full = false;
            this._search = value;
            let filtered = this.filter(full);
            this.setState({
                searchWorks: this.resort(filtered)
            });
        }
    }
    get search() {
        return this._search;
    }
    constructor(){
        super();
        this.works = [];
        this._search = "";
        this.rowHeight = 340.4;
        this.state = {
            searchWorks: [],
            noFinished: true
        };
        this.onChange = this.onChange.bind(this);
    }
    onChange(events) {
        events.forEach(({ type: type, work: work })=>{
            switch(type){
                case (0, $b3b9117a88ecf6d3$export$d8ed98235b49d42e).position:
                case (0, $b3b9117a88ecf6d3$export$d8ed98235b49d42e).create_edit:
                    {
                        let idx = this.works.findIndex((e)=>e._id === work._id);
                        if (idx < 0) {
                            type;
                            this.works.push(work);
                        } else this.works[idx] = work;
                        break;
                    }
                case (0, $b3b9117a88ecf6d3$export$d8ed98235b49d42e).delete:
                    {
                        let idx = this.works.findIndex((e)=>e._id === work._id);
                        if (idx >= 0) this.works.splice(idx, 1);
                        break;
                    }
            }
        });
        let filtered = this.filter(true);
        this.setState({
            searchWorks: this.resort(filtered)
        });
    }
    componentWillMount() {
        (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).workObservable.subscribeCollect(this.onChange);
        (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).getWorks().then((works)=>{
            this.works = works;
            let filtered = this.filter(true);
            this.setState({
                searchWorks: this.resort(filtered)
            });
        });
    }
    componentWillUnmount() {
        (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).workObservable.unsubscribe(this.onChange);
    }
    filter(full) {
        if (!this.search || this.search === "") return this.works;
        else {
            let works = full ? this.works : this.state.searchWorks;
            let search = this.search;
            let onlyAuthor = false;
            let onlyTags = false;
            if (search.startsWith("@")) {
                onlyAuthor = true;
                search = search.slice(1, search.length);
            } else if (search.startsWith("#")) {
                onlyTags = true;
                search = search.slice(1, search.length);
            }
            // console.log(search, onlyAuthor, onlyTags);
            let parts = search.split(" ");
            let getVals = (e)=>{
                let arr = [];
                if (onlyAuthor) arr = [
                    e.author
                ];
                else if (onlyTags) arr = e.tags;
                else arr = [
                    e.author,
                    e.title,
                    e.summary
                ].concat(e.tags);
                return arr;
            };
            const match = (text)=>parts.every((el)=>text.toLowerCase().indexOf(el) > -1);
            const any = (parts)=>parts.findIndex((e)=>match(e)) > -1;
            return works.filter((e)=>any(getVals(e)));
        }
    }
    resort(works) {
        return works.sort((e1, e2)=>{
            // Works with position are higher ranked that these without.
            // The next parameter is the date of last read.
            // if (!e1.position && !e2.position) {
            //    return new Date(e2.creation_date).getTime() - new Date(e1.creation_date).getTime();
            // } else if (!e1.position) return -1;
            // else if (!e2.position) return 1;
            const e1Finished = e1.progress >= (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).finishedLimit;
            const e2Finished = e2.progress >= (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).finishedLimit;
            if (e1Finished !== e2Finished) {
                if (e1Finished) return 1;
                if (e2Finished) return -1;
            }
            let d1 = e1.position ? e1.position.date : e1.creation_date;
            let d2 = e2.position ? e2.position.date : e2.creation_date;
            return new Date(d2).getTime() - new Date(d1).getTime();
        });
    }
    render(props, state) {
        let wks = state.searchWorks;
        if (state.noFinished) wks = state.searchWorks.filter((e)=>e.progress < (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).finishedLimit);
        let works = wks.map((work)=>{
            let w = {
                ...work,
                disabled: false,
                reload: work.type === "ao3" || work.type === "wattpad",
                finished: (Number.isNaN(work.progress) ? 0 : work.progress) >= (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).finishedLimit
            };
            return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                class: "col col-4 col-sm-4 col-md-3 col-lg-2 col-xl-2",
                children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $2f9e3554202bc888$export$9040a54ae695c16f), {
                    id: work._id,
                    work: w
                })
            }, w._id);
        });
        return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
            children: [
                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                    class: "container library_container",
                    children: [
                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                            class: "row",
                            children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                class: "col-sm-12",
                                children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("input", {
                                    class: "inp elv-4 libary_input",
                                    type: "text",
                                    name: "search",
                                    placeholder: "Search",
                                    "aria-label": "search",
                                    onKeyUp: (evt)=>{
                                        this.search = evt.target.value;
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                            id: "library_works",
                            class: "row",
                            children: works
                        }),
                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                            class: "row",
                            children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                class: "col-sm-12",
                                style: "display: flex;",
                                children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("button", {
                                    class: "btn btn-primary",
                                    style: "margin:auto",
                                    onClick: ()=>this.setState({
                                            noFinished: !this.state.noFinished
                                        }),
                                    children: [
                                        this.state.noFinished ? "List" : "Hide",
                                        " Finished"
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $34cf621a66f62afb$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $95f3e248299245ff$export$2d9ac7aa84f97a08), {}),
                    items: [
                        {
                            icon: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $95f3e248299245ff$export$2d9ac7aa84f97a08), {}),
                            onClick: ()=>$c8531f9e595511bf$var$showAddModal(),
                            label: "Add"
                        },
                        {
                            icon: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $5cb3d4452dd91ee8$export$4b85d3515bd863a5), {}),
                            onClick: ()=>(0, $5c3d1d9675d0a11e$export$2e2bcd8739ae039).setPage((0, $5c3d1d9675d0a11e$export$c717c2ee03fc6c49).Browse, undefined),
                            label: "Browse"
                        },
                        {
                            icon: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $368a3878b75366d6$export$6ed0965c9443aaa6), {}),
                            onClick: ()=>(0, $5c3d1d9675d0a11e$export$2e2bcd8739ae039).setPage((0, $5c3d1d9675d0a11e$export$c717c2ee03fc6c49).Edit, undefined),
                            label: "Add manually"
                        }
                    ]
                })
            ]
        });
    }
} // function AddButtons() {
 //    return ;
 // }







const $6543a170b8c9f912$export$b94310965bed44e6 = (props)=>{
    const color = props.color || "currentColor";
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (0, $54cd03c1d32ebcab$export$c8a8987d4410bf2d)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    }, props), (0, $54cd03c1d32ebcab$export$c8a8987d4410bf2d)("path", {
        d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
    }), (0, $54cd03c1d32ebcab$export$c8a8987d4410bf2d)("polyline", {
        points: "9 22 9 12 15 12 15 22"
    }));
};


const $54e332c81e40f046$export$c72f6eaae7b9adff = (props)=>{
    const color = props.color || "currentColor";
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (0, $54cd03c1d32ebcab$export$c8a8987d4410bf2d)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
    }, props), (0, $54cd03c1d32ebcab$export$c8a8987d4410bf2d)("circle", {
        cx: "12",
        cy: "12",
        r: "3"
    }), (0, $54cd03c1d32ebcab$export$c8a8987d4410bf2d)("path", {
        d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
    }));
};











const $8e63b50d4ac44ee0$var$ShadowLogging = (0, $c1c041af559ee181$export$d1e2d247586bfe0)("shadow");
function $8e63b50d4ac44ee0$export$2e2bcd8739ae039({ children: children }) {
    const container = (0, $79abdce4f0f4201e$export$b8f5890fc79d6aca)();
    const [root, setRoot] = (0, $79abdce4f0f4201e$export$60241385465d0a34)(null);
    const rnd = (0, $79abdce4f0f4201e$export$1538c33de8887b59)(()=>Math.random(), []);
    $8e63b50d4ac44ee0$var$ShadowLogging.log("Call to Shadow", rnd);
    const render_content = (content)=>{
        if (root) (0, $54cd03c1d32ebcab$export$b3890eb0ae9dca99)(content, root, root.firstChild);
    };
    (0, $79abdce4f0f4201e$export$6d9c69b0de29b591)(()=>{
        if (container.current) {
            if (root) {
                render_content(null); //Unrender
                root.parentElement.remove();
            }
            // let iframe = document.createElement("iframe");
            // iframe.style.width = "100%";
            // iframe.onload = (evt) => {
            //    iframe.contentWindow.requestAnimationFrame(() => {
            //       iframe.contentWindow.requestAnimationFrame(() => {
            //          iframe.style.height = (iframe.contentWindow.document.body.scrollHeight + 50) + "px";
            //       });
            //    })
            // }
            // container.current.appendChild(iframe);
            // setRoot(iframe.contentWindow.document.body);
            let p = document.createElement("x-shadow");
            container.current.appendChild(p);
            let shadow = p.attachShadow({
                mode: "open"
            });
            $8e63b50d4ac44ee0$var$ShadowLogging.log("Creating Shadow", rnd, shadow);
            setRoot(shadow);
        }
        return ()=>{
            if (root) {
                render_content(null);
                root.parentElement.remove();
                setRoot(null);
            }
        };
    }, [
        container
    ]);
    (0, $79abdce4f0f4201e$export$6d9c69b0de29b591)(()=>{
        $8e63b50d4ac44ee0$var$ShadowLogging.log("Rendering Shadow", rnd);
        render_content((0, $54cd03c1d32ebcab$export$c8a8987d4410bf2d)((0, $54cd03c1d32ebcab$export$ffb0004e005737fa), {}, ...(0, $54cd03c1d32ebcab$export$47e4c5b300681277)(children)));
    }, [
        root,
        children
    ]);
    return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
        ref: container
    });
}


const $3a4a07bba9e88a38$var$ReaderLogging = (0, $c1c041af559ee181$export$d1e2d247586bfe0)("reader");
const $3a4a07bba9e88a38$var$color_themes = {
    white: {
        background: "#FFFFFF",
        color: "#000000"
    },
    black: {
        background: "#000000",
        color: "#FFFFFF"
    },
    sepia: {
        background: "#e9d8ba",
        color: "#412811"
    }
};
const $3a4a07bba9e88a38$var$fonts = {
    "Open Sans": "'Open Sans', sans-serif",
    Roboto: "'Roboto', sans-serif",
    "Roboto Mono": " 'Roboto Mono', monospace",
    Oswald: " 'Oswald', sans-serif",
    "Liu Jian Mao Cao": "'Liu Jian Mao Cao', cursive",
    Anton: "'Anton', sans-serif"
};
const $3a4a07bba9e88a38$var$between = (x, min, max)=>x >= min && x <= max;
const $3a4a07bba9e88a38$var$LS_THEME_COLOR = "reader-color_theme";
const $3a4a07bba9e88a38$var$LS_THEME_FONT = "reader-font";
const $3a4a07bba9e88a38$var$LS_THEME_FONT_SIZE = "reader-font_size";
const $3a4a07bba9e88a38$var$LS_THEME_PADDING = "reader-padding";
const $3a4a07bba9e88a38$var$ThemeStore = new (0, $5863cc0890fa3ad9$export$2e2bcd8739ae039)({
    color_theme: localStorage.getItem($3a4a07bba9e88a38$var$LS_THEME_COLOR) || "white",
    font: localStorage.getItem($3a4a07bba9e88a38$var$LS_THEME_FONT) || $3a4a07bba9e88a38$var$fonts.Roboto,
    font_size: Number(localStorage.getItem($3a4a07bba9e88a38$var$LS_THEME_FONT_SIZE)) || 16,
    padding: Number(localStorage.getItem($3a4a07bba9e88a38$var$LS_THEME_PADDING)) ?? 32
});
$3a4a07bba9e88a38$var$ThemeStore.subscribe((theme)=>{
    if (theme) {
        // Store Theme into Local Storage on change!
        localStorage.setItem($3a4a07bba9e88a38$var$LS_THEME_COLOR, theme.color_theme);
        localStorage.setItem($3a4a07bba9e88a38$var$LS_THEME_FONT, theme.font);
        localStorage.setItem($3a4a07bba9e88a38$var$LS_THEME_FONT_SIZE, theme.font_size.toString());
        localStorage.setItem($3a4a07bba9e88a38$var$LS_THEME_PADDING, theme.padding.toString());
    }
});
const $3a4a07bba9e88a38$var$generateColorStyles = (theme)=>{
    let ct = $3a4a07bba9e88a38$var$color_themes[theme.color_theme];
    return `;background-color: ${ct.background};color:${ct.color};`;
};
const $3a4a07bba9e88a38$var$generateAllStyles = (theme)=>{
    return $3a4a07bba9e88a38$var$generateColorStyles(theme) + `font-family: ${$3a4a07bba9e88a38$var$fonts[theme.font]}; font-size: ${theme.font_size}px; padding: ${theme.padding}px;`;
};
function $3a4a07bba9e88a38$var$useReaderTheme() {
    const [theme, setTheme] = (0, $79abdce4f0f4201e$export$60241385465d0a34)($3a4a07bba9e88a38$var$ThemeStore.value);
    (0, $79abdce4f0f4201e$export$6d9c69b0de29b591)(()=>{
        let s = $3a4a07bba9e88a38$var$ThemeStore.subscribe((value)=>setTheme(value));
        return ()=>s();
    }, []);
    let res = {
        theme: theme,
        styles_color: $3a4a07bba9e88a38$var$generateColorStyles(theme),
        styles_all: $3a4a07bba9e88a38$var$generateAllStyles(theme)
    };
    return [
        res,
        (theme)=>$3a4a07bba9e88a38$var$ThemeStore.send(theme)
    ];
}
function $3a4a07bba9e88a38$var$ReaderModal({ work: work, chapterID: chapterID, changeChapter: changeChapter, close: close }) {
    const [theme, setTheme] = $3a4a07bba9e88a38$var$useReaderTheme();
    return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
        class: "modal",
        style: "border: 1px white solid;" + theme.styles_color,
        children: [
            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                class: "modal-content",
                children: [
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                        class: "input-group",
                        children: [
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("label", {
                                children: "Chapter"
                            }),
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("select", {
                                class: "inp",
                                style: theme.styles_color,
                                onChange: (evt)=>{
                                    let elm = evt.srcElement;
                                    let value = elm.options[elm.selectedIndex].value;
                                    let chapter = work.chapters.find((e)=>e.id === value);
                                    if (chapter) changeChapter(chapter.id);
                                },
                                children: work.chapters.map((chapter)=>/*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("option", {
                                        value: chapter.id,
                                        selected: chapter.id === chapterID,
                                        children: chapter.title
                                    }, chapter.id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                        class: "input-group",
                        children: [
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("label", {
                                children: "Color Theme"
                            }),
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("select", {
                                class: "inp",
                                style: theme.styles_color,
                                onChange: (evt)=>{
                                    let elm = evt.srcElement;
                                    let value = elm.value || "white";
                                    setTheme({
                                        ...theme.theme,
                                        color_theme: value
                                    });
                                },
                                children: Object.keys($3a4a07bba9e88a38$var$color_themes).map((name)=>/*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("option", {
                                        value: name,
                                        selected: name === theme.theme.color_theme,
                                        children: name
                                    }, name))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                        class: "input-group",
                        children: [
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("label", {
                                children: "Font"
                            }),
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("select", {
                                class: "inp",
                                style: theme.styles_color,
                                onChange: (evt)=>{
                                    let elm = evt.srcElement;
                                    let value = elm.value || "white";
                                    setTheme({
                                        ...theme.theme,
                                        font: value
                                    });
                                },
                                children: Object.keys($3a4a07bba9e88a38$var$fonts).map((name)=>/*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("option", {
                                        value: name,
                                        selected: name === theme.theme.font,
                                        style: "font-family:" + $3a4a07bba9e88a38$var$fonts[name] + ";",
                                        children: name
                                    }, name))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                        class: "input-group",
                        children: [
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("label", {
                                children: "Font Size"
                            }),
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("input", {
                                type: "range",
                                style: theme.styles_color,
                                min: "12",
                                max: "64",
                                step: "2",
                                value: theme.theme.font_size,
                                onChange: (evt)=>{
                                    let elm = evt.srcElement;
                                    let value = Number(elm.value) || 16;
                                    setTheme({
                                        ...theme.theme,
                                        font_size: value
                                    });
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                        class: "input-group",
                        children: [
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("label", {
                                children: "Padding"
                            }),
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("input", {
                                type: "range",
                                style: theme.styles_color,
                                min: "0",
                                max: "128",
                                step: "8",
                                value: theme.theme.padding,
                                onChange: (evt)=>{
                                    let elm = evt.srcElement;
                                    let value = Number(elm.value) ?? 32;
                                    setTheme({
                                        ...theme.theme,
                                        padding: value
                                    });
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                className: "modal-action",
                children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("button", {
                    onClick: ()=>close(),
                    children: "Close"
                })
            })
        ]
    });
}
function $3a4a07bba9e88a38$var$ReaderOverlay({ work: work, chapterID: chapterID, changeChapter: changeChapter, toggle: toggle }) {
    const [overlay, setOverlay] = (0, $79abdce4f0f4201e$export$60241385465d0a34)(false);
    const [modalActive, setModalActive] = (0, $79abdce4f0f4201e$export$60241385465d0a34)(false);
    (0, $79abdce4f0f4201e$export$6d9c69b0de29b591)(()=>{
        $3a4a07bba9e88a38$var$ReaderLogging.log("ReaderOverlay subscribe toggle");
        const onToggle = ()=>{
            $3a4a07bba9e88a38$var$ReaderLogging.log("ReaderOverlay Changing visibility to", !overlay);
            if (overlay) {
                setOverlay(false);
                setModalActive(false);
            } else setOverlay(true);
        };
        toggle.subscribe(onToggle);
        return ()=>toggle.unsubscribe(onToggle);
    }, [
        toggle,
        overlay
    ]);
    $3a4a07bba9e88a38$var$ReaderLogging.debug("ReaderOverlay Visibility:", overlay, "Modal:", modalActive);
    return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $54cd03c1d32ebcab$export$ffb0004e005737fa), {
        children: [
            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                class: "reader-overlay" + (overlay ? " reader-overlay-visible" : ""),
                children: [
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                        class: "reader-settings-icon right",
                        onClick: ()=>setModalActive(!modalActive),
                        children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $54e332c81e40f046$export$c72f6eaae7b9adff), {})
                    }),
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                        class: "reader-settings-icon left",
                        onClick: ()=>(0, $5c3d1d9675d0a11e$export$2e2bcd8739ae039).setPage((0, $5c3d1d9675d0a11e$export$c717c2ee03fc6c49).Library, undefined),
                        children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $6543a170b8c9f912$export$b94310965bed44e6), {})
                    })
                ]
            }),
            modalActive && /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)($3a4a07bba9e88a38$var$ReaderModal, {
                work: work,
                chapterID: chapterID,
                changeChapter: changeChapter,
                close: ()=>{
                    setModalActive(false);
                    setOverlay(false);
                }
            })
        ]
    });
}
function $3a4a07bba9e88a38$var$ChapterNavigation({ prev: prev, next: next }) {
    return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
        style: "display:flex; margin: 16px;",
        children: [
            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("a", {
                id: "reader_prev_chap",
                href: "#",
                style: !prev ? "display:none" : "",
                onClick: (evt)=>{
                    evt.preventDefault();
                    prev();
                },
                children: "Previous Chapter"
            }),
            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("span", {
                style: "flex-grow: 1"
            }),
            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("a", {
                id: "reader_next_chap",
                href: "#",
                style: !next ? "display:none" : "",
                onClick: (evt)=>{
                    evt.preventDefault();
                    next();
                },
                children: "Next Chapter"
            })
        ]
    });
}
function $3a4a07bba9e88a38$export$2e2bcd8739ae039({ id: id }) {
    const [work, setWork] = (0, $79abdce4f0f4201e$export$60241385465d0a34)(null);
    const [position, setPosition] = (0, $79abdce4f0f4201e$export$60241385465d0a34)(null);
    const [chapterIdx, chapter] = (0, $79abdce4f0f4201e$export$1538c33de8887b59)(()=>{
        if (work && position) {
            let idx = work.chapters.findIndex((e)=>e.id === position.chapter);
            return [
                idx,
                work.chapters[idx]
            ];
        }
        return [];
    }, [
        work,
        position
    ]);
    const [theme] = $3a4a07bba9e88a38$var$useReaderTheme();
    const overlayToggle = (0, $79abdce4f0f4201e$export$1538c33de8887b59)(()=>new (0, $ae8634edd6e9fa90$export$2e2bcd8739ae039)(), []);
    (0, $79abdce4f0f4201e$export$6d9c69b0de29b591)(()=>{
        (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).getWork(id).then((work)=>{
            if (!work.position) work.position = {
                chapter: work.chapters[0].id,
                date: new Date(),
                progress: 0
            };
            setPosition(work.position);
            setWork(work);
        });
    }, [
        id
    ]);
    // End hooks
    const updatePosition = (chapter, progress)=>{
        $3a4a07bba9e88a38$var$ReaderLogging.log("Updating positon to:", chapter, progress);
        let np = {
            date: new Date(),
            chapter: chapter ? chapter : position.chapter,
            progress: progress
        };
        if (chapter) setPosition(np);
        (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).pushPosition(work._id, np);
    };
    (0, $79abdce4f0f4201e$export$6d9c69b0de29b591)(()=>{
        if (!chapter) return;
        let oldScroll = 0;
        setTimeout(()=>{
            let pos = document.documentElement.scrollHeight * position.progress;
            $3a4a07bba9e88a38$var$ReaderLogging.debug("Scrolling to:", pos, position.progress);
            document.documentElement.scrollTo({
                top: pos
            });
            this.oldScroll = pos;
        }, 100);
        const iv = setInterval(()=>{
            let { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = document.documentElement;
            $3a4a07bba9e88a38$var$ReaderLogging.log("Check position: ", scrollTop, scrollHeight, clientHeight);
            if (scrollTop + clientHeight + 20 >= scrollHeight) {
                //Is on bottom of page
                scrollTop = scrollTop + scrollHeight;
                if (scrollTop != oldScroll) {
                    oldScroll = scrollTop;
                    updatePosition(undefined, 1);
                }
            } else if (!$3a4a07bba9e88a38$var$between(oldScroll, scrollTop - 50, scrollTop + 50)) {
                oldScroll = scrollTop;
                let c = scrollTop / scrollHeight;
                updatePosition(undefined, c);
            }
        }, 3000);
        return ()=>clearInterval(iv);
    }, [
        chapter
    ]);
    if (!work) return;
    const next = chapterIdx < work.chapters.length - 1 ? ()=>updatePosition(work.chapters[chapterIdx + 1].id, 0) : undefined;
    const prev = chapterIdx > 0 ? ()=>updatePosition(work.chapters[chapterIdx - 1].id, 0) : undefined;
    function toggleOverlay(evt) {
        // console.log(evt.composedPath(), evt);
        const is = (elm)=>elm.classList ? elm.classList.contains("modal") || elm.classList.contains("reader-settings-icon") : false;
        if (evt.composedPath().find((e)=>is(e))) ;
        else overlayToggle.send("asd");
    }
    if (work) return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
        class: "reader-container",
        style: theme.styles_color,
        onClick: toggleOverlay,
        children: [
            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)($3a4a07bba9e88a38$var$ReaderOverlay, {
                work: work,
                chapterID: chapter.id,
                changeChapter: (id)=>updatePosition(id, 0),
                toggle: overlayToggle
            }),
            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                className: "row",
                children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                    class: "col col-12 col-sm-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 col-xl-6 col-xl-offset-3",
                    children: [
                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)($3a4a07bba9e88a38$var$ChapterNavigation, {
                            next: next,
                            prev: prev
                        }),
                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $8e63b50d4ac44ee0$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("style", {
                                    children: `
.reader {
   overflow: hidden;
   word-wrap: break-word;
   word-break: break-word;
   user-select: none;
   max-width: 100%;
   // min-height: calc(100vh - var(--header-height));
}

.reader p {
   max-width: 100%;
}

.reader img {
   width: 100%;
}                     
                     `
                                }),
                                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                    className: "reader",
                                    style: theme.styles_all,
                                    children: [
                                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("h1", {
                                            children: chapter.title
                                        }),
                                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: chapter.content
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)($3a4a07bba9e88a38$var$ChapterNavigation, {
                            next: next,
                            prev: prev
                        })
                    ]
                })
            })
        ]
    });
    return null;
}





class $edacaa953ae62c6a$export$ad3116fa4cf196e9 extends (0, $54cd03c1d32ebcab$export$16fa2f45be04daa8) {
    constructor(props){
        super(props);
    }
    async componentWillMount() {
        let stats = "";
        let works = await (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).getWorks();
        stats += "Works: " + works.length.toString() + "<br>";
        let tag_cnt = [];
        let type_cnts = {};
        let words = 0;
        works.forEach((e)=>{
            words += e.words;
            if (!type_cnts[e.type]) type_cnts[e.type] = 0;
            type_cnts[e.type]++;
            e.tags.forEach((t)=>{
                let tc = tag_cnt.find((c)=>c.tag === t);
                if (tc) tc.count++;
                else tag_cnt.push({
                    tag: t,
                    count: 1
                });
            });
        });
        console.log(type_cnts);
        tag_cnt = tag_cnt.sort((e1, e2)=>e2.count - e1.count);
        stats += "Words: " + words.toString() + "<br>";
        stats += `- Wattpad : ${type_cnts["wattpad"] || 0}<br>`;
        stats += `- AO3     : ${type_cnts["ao3"] || 0}<br>`;
        stats += `- Epub    : ${type_cnts["epub"] || 0}<br>`;
        stats += `- Manually: ${type_cnts["manually"] || 0}<br>`;
        stats += "Most favourite tags: <br>";
        for(let i = 0; i < 10 && i < tag_cnt.length; i++)stats += `- ${tag_cnt[i].tag}: ${tag_cnt[i].count} <br>`;
        stats += `${tag_cnt.length} different tags`;
        this.setState({
            stats: stats
        });
    }
    //style="background-color: {{theme.background}}; color: {{theme.color}}; font-size: {{font_size}}"
    render(props, state) {
        return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
            style: "background: var(--background)",
            children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                class: "container",
                children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                    class: "row",
                    children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                        class: "col col-12 col-sm-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 col-xl-6 col-xl-offset-3",
                        ref: (elm)=>elm ? elm.innerHTML = state.stats || "" : undefined
                    })
                })
            })
        });
    }
}






var $91a1708048be5fb7$var$States;
(function(States) {
    States[States["Form"] = 0] = "Form";
    States[States["Spinner"] = 1] = "Spinner";
})($91a1708048be5fb7$var$States || ($91a1708048be5fb7$var$States = {}));
class $91a1708048be5fb7$export$827f4f7f7b0d0703 extends (0, $54cd03c1d32ebcab$export$16fa2f45be04daa8) {
    constructor(props){
        super(props);
        this.state = {
            state: 0,
            message: ""
        };
    }
    async addFromFile(file) {
        if (file.name.endsWith(".epub")) {
            console.log("Epub found!");
            try {
                await (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).addEPub(file);
            } catch (e) {
                alert("Some error occured, please try again later: " + e.message);
            }
        } else await new Promise((yes, no)=>{
            let r = new FileReader();
            r.onload = async (e)=>{
                try {
                    this.setState({
                        state: 1
                    });
                    let content = e.target.result;
                    let wks = content.split("\n").map((e)=>e.trim()).filter((e)=>e !== "");
                    let current = 0;
                    let drawpg = ()=>{
                        this.setState({
                            message: `Converted ${current} from ${wks.length}`
                        });
                    };
                    drawpg();
                    for (let w of wks){
                        await (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).addWorkFromUrl(w);
                        current++;
                        drawpg();
                    }
                } catch (e) {
                    alert("Some error occured, please try again later: " + e.message);
                } finally{
                    yes();
                }
            };
            r.readAsText(file);
        });
    }
    async componentWillMount() {}
    //style="background-color: {{theme.background}}; color: {{theme.color}}; font-size: {{font_size}}"
    render(props, state) {
        let content;
        switch(state.state){
            case 1:
                content = /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                    id: "add_work_loader",
                    style: "display:{{#if loader_visibility}}block{{else}}none{{/if}};",
                    children: [
                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("h3", {
                            children: state.message
                        }),
                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                            style: "width: 65px; height: 65px; margin: 0 auto;",
                            children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("svg", {
                                class: "spinner",
                                viewBox: "0 0 66 66",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("circle", {
                                    class: "circle",
                                    fill: "none",
                                    "stroke-width": "6",
                                    "stroke-linecap": "round",
                                    cx: "33",
                                    cy: "33",
                                    r: "30"
                                })
                            })
                        })
                    ]
                });
                break;
            case 0:
            default:
                content = /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                    children: [
                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                            class: "input-group",
                            children: [
                                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("label", {
                                    for: "url",
                                    children: "Enter URL of work"
                                }),
                                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("input", {
                                    type: "text",
                                    id: "url",
                                    name: "url",
                                    autofocus: true,
                                    ref: (elm)=>this.input = elm
                                }),
                                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                    class: "error invisible",
                                    id: "url_error"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                            class: "group",
                            children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("input", {
                                class: "btn",
                                id: "add_wp_book_bulk",
                                type: "file",
                                multiple: true,
                                onChange: async (evt)=>{
                                    let files = evt.target.files;
                                    this.setState({
                                        state: 1
                                    });
                                    try {
                                        for (let file of files){
                                            this.setState({
                                                message: "Uploading " + file.name
                                            });
                                            await this.addFromFile(file);
                                        }
                                        (0, $5c3d1d9675d0a11e$export$2e2bcd8739ae039).setPage((0, $5c3d1d9675d0a11e$export$c717c2ee03fc6c49).Library, undefined);
                                    } catch (e) {
                                        alert("Failed to load file");
                                    }
                                    this.setState({
                                        message: ""
                                    });
                                    this.setState({
                                        state: 0
                                    });
                                    evt.target.value = null;
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("button", {
                            id: "add_work_save",
                            type: "submit",
                            class: "btn",
                            onClick: async (evt)=>{
                                this.setState({
                                    message: "Working",
                                    state: 1
                                });
                                if (this.input) {
                                    let url = this.input.value;
                                    if (url) await (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).addWorkFromUrl(url).then(()=>{
                                        this.input && (this.input.value = null);
                                        (0, $5c3d1d9675d0a11e$export$2e2bcd8739ae039).setPage((0, $5c3d1d9675d0a11e$export$c717c2ee03fc6c49).Library, undefined);
                                    }).catch((err)=>alert(err.message));
                                    this.setState({
                                        message: "",
                                        state: 0
                                    });
                                }
                            },
                            children: "Add"
                        })
                    ]
                });
        }
        return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
            children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                style: "background: var(--background); margin-top: -1px; padding-top:1px; height: 100%;",
                children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                    style: "width: 100%;",
                    children: [
                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("h2", {
                            children: "Add work to library"
                        }),
                        content
                    ]
                })
            })
        });
    }
}








class $b4d0f364e06c4cdc$export$4d683b4e036af97 extends (0, $54cd03c1d32ebcab$export$16fa2f45be04daa8) {
    constructor(props, ctx){
        super(props, ctx);
        this.state = {
            work: undefined
        };
    }
    componentWillMount() {
        (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).getWork(this.props.id).then((work)=>{
            this.setState({
                work: work
            });
        }).catch((err)=>{
            console.log(err);
            (0, $5c3d1d9675d0a11e$export$2e2bcd8739ae039).setPage((0, $5c3d1d9675d0a11e$export$c717c2ee03fc6c49).Library, undefined);
        });
    }
    render(props, { work: work }) {
        if (!this.state.work) return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
            children: "Loading"
        });
        return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
            class: "details-continer fancy-background",
            children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                class: "content elv-4",
                children: [
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                        class: "image",
                        children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("img", {
                            src: work.cover,
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                        class: "title",
                        children: work.title
                    }),
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("hr", {}),
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                        class: "summary",
                        children: work.summary || "No summary"
                    }),
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("hr", {}),
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                        class: "tags",
                        children: work.tags.map((t)=>/*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("span", {
                                children: t
                            }))
                    }),
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                        class: "actions",
                        children: [
                            work.type == "wattpad" && /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("button", {
                                onClick: ()=>(0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).addWorkWithId(work.type, work.workid),
                                children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $2a7c4fa827e68cd8$export$124e3c1601ad9a28), {})
                            }),
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("button", {
                                onClick: ()=>{
                                    if (confirm("Really delete?")) (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).deleteWork(props.id).then(()=>{
                                        alert("Deleted!");
                                    }).catch((err)=>{
                                        console.error(err);
                                        alert("Could not delete!");
                                    }).then(()=>{
                                        (0, $5c3d1d9675d0a11e$export$2e2bcd8739ae039).setPage((0, $5c3d1d9675d0a11e$export$c717c2ee03fc6c49).Library, undefined);
                                    });
                                },
                                children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("svg", {
                                    viewBox: "0 0 24 24",
                                    width: "24",
                                    height: "24",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    fill: "none",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    class: "css-i6dzq1",
                                    children: [
                                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("polyline", {
                                            points: "3 6 5 6 21 6"
                                        }),
                                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("path", {
                                            d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                                        }),
                                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("line", {
                                            x1: "10",
                                            y1: "11",
                                            x2: "10",
                                            y2: "17"
                                        }),
                                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("line", {
                                            x1: "14",
                                            y1: "11",
                                            x2: "14",
                                            y2: "17"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
}











function $f64948dbb6631b93$var$showSummaryModal(story) {
    const controls = (0, $ddd8694e50ec82d7$export$d7e8d4d4450c819c)(()=>{
        const [state, setState] = (0, $79abdce4f0f4201e$export$60241385465d0a34)("overview");
        const [error, setError] = (0, $79abdce4f0f4201e$export$60241385465d0a34)(undefined);
        (0, $79abdce4f0f4201e$export$6d9c69b0de29b591)(()=>{
            setState("overview");
        }, [
            story.id
        ]);
        return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $54cd03c1d32ebcab$export$ffb0004e005737fa), {
            children: [
                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                    className: "modal-title",
                    children: story.title
                }),
                state == "overview" && /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                    className: "browse modal-content",
                    children: [
                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                            class: "summary",
                            dangerouslySetInnerHTML: {
                                __html: story.summary
                            }
                        }),
                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                            class: "tags",
                            children: story.tags.map((e)=>/*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("span", {
                                    children: e
                                }))
                        }),
                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                            children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("button", {
                                class: "btn btn-primary",
                                onClick: (evt)=>{
                                    evt.preventDefault();
                                    setState("loading");
                                    const then = ()=>{
                                        setState("finished");
                                    };
                                    const cat = (err)=>{
                                        console.log(err);
                                        setError(err.message);
                                        setState("error");
                                    };
                                    if (story.provider === "ao3") (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).addAO3(story.id).then(then).catch(cat);
                                    else if (story.provider === "wattpad") (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).addWattpad(story.id).then(then).catch(cat);
                                },
                                children: "Add to Library"
                            })
                        })
                    ]
                }),
                state === "loading" && /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                    className: "browse modal-content",
                    children: "Loading..."
                }),
                state === "finished" && /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                    className: "browse modal-content",
                    children: "Finished!"
                }),
                state === "error" && /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                    className: "browse modal-content",
                    children: [
                        "Error: ",
                        error
                    ]
                })
            ]
        });
    });
}
function $f64948dbb6631b93$var$useWorkSearchApi(initalTerm) {
    const [term, setTerm] = (0, $79abdce4f0f4201e$export$60241385465d0a34)(initalTerm);
    const [page, setPage] = (0, $79abdce4f0f4201e$export$60241385465d0a34)(0);
    const [loading, setLoading] = (0, $79abdce4f0f4201e$export$60241385465d0a34)(true);
    const [pages, setPages] = (0, $79abdce4f0f4201e$export$60241385465d0a34)([]);
    (0, $79abdce4f0f4201e$export$6d9c69b0de29b591)(()=>{
        let obsolete = false;
        Promise.resolve().then(async ()=>{
            setLoading(true);
            while(pages.length < page + 1 && term !== ""){
                console.log("ERASD", page, pages.length);
                const idx = pages.length;
                const res = await fetch(`/ao3/works/search?page=${idx}&q=${encodeURIComponent(term)}`);
                const data = await res.json();
                if (data.error) return; //TODO: Add error message etc.
                if (obsolete === true) return;
                const ao3 = data.map((s)=>({
                        ...s,
                        provider: "ao3"
                    }));
                const wpres = await fetch(`/wattpad/works/search?limit=20&offset=${idx * 20}&q=${encodeURIComponent(term)}`);
                const wpdata = await wpres.json();
                if (wpdata.error) return; //TODO: Add error message etc.
                if (obsolete === true) return;
                const wattpad = wpdata.map((s)=>({
                        ...s,
                        provider: "wattpad"
                    }));
                let r = [];
                for(let i = 0; i < 20; i++){
                    r.push(ao3[i]);
                    r.push(wattpad[i]);
                }
                pages[idx] = r;
            }
            setLoading(false);
        });
        return ()=>obsolete = true;
    }, [
        term,
        page
    ]);
    return {
        term: term,
        setTerm: (newTerm)=>{
            if (term != newTerm) {
                setTerm(newTerm);
                setPage(0);
                setPages([]);
                setLoading(true);
            }
        },
        page: page,
        pages: pages,
        loading: loading,
        next: ()=>{
            if (pages.length - 1 >= page) setPage((old)=>old + 1);
        }
    };
}
function $f64948dbb6631b93$var$useInput(initial) {
    const [value, setValue] = (0, $79abdce4f0f4201e$export$60241385465d0a34)(initial);
    return {
        value: value,
        onChange: (evt)=>setValue(evt.target.value)
    };
}
function $f64948dbb6631b93$export$2e2bcd8739ae039() {
    const termInput = $f64948dbb6631b93$var$useInput("");
    const api = $f64948dbb6631b93$var$useWorkSearchApi(termInput.value);
    return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
        class: "container browse",
        style: {
            paddingTop: "1rem"
        },
        children: [
            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                class: "elv-4",
                style: {
                    display: "flex"
                },
                children: [
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("input", {
                        class: "inp",
                        style: {
                            border: "none",
                            width: "100%"
                        },
                        onKeyUp: (evt)=>{
                            if (evt.keyCode === 13) api.setTerm(termInput.value);
                        },
                        ...termInput
                    }),
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("button", {
                        class: "btn btn-primary",
                        style: {
                            margin: 0,
                            height: "2rem"
                        },
                        onClick: ()=>api.setTerm(termInput.value),
                        children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $5cb3d4452dd91ee8$export$4b85d3515bd863a5), {
                            style: {
                                height: "1rem",
                                width: "1rem",
                                margin: 0,
                                padding: 0
                            }
                        })
                    })
                ]
            }),
            api.pages.map((page)=>page.map((story)=>/*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                        class: "story card",
                        onClick: (evt)=>{
                            evt.preventDefault();
                            $f64948dbb6631b93$var$showSummaryModal(story);
                        },
                        children: [
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                class: "provider",
                                children: story.provider == "ao3" ? /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e62867419c0be676$exports)))
                                }) : /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($533c30c7538d0ac3$exports)))
                                })
                            }),
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                class: "title",
                                children: story.title
                            }),
                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                class: "cnt",
                                children: [
                                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                        class: "cover",
                                        children: story.cover && /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("img", {
                                            src: story.cover
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                        class: "text-content",
                                        children: [
                                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                                class: "author",
                                                children: story.author
                                            }),
                                            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                                class: "summary",
                                                dangerouslySetInnerHTML: {
                                                    __html: story.summary
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }))).flat(),
            api.loading && /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                children: "Loading"
            }),
            !api.loading && /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("button", {
                class: "btn",
                onClick: ()=>api.next(),
                children: "More..."
            })
        ]
    });
}







const $a35f4f689c1fd8b6$export$2b646eea95309f00 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";


let $40b0ef4339cb3cfb$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $40b0ef4339cb3cfb$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = "";
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || "";
                if (id.length === size) return id;
            }
        }
    };
};
let $40b0ef4339cb3cfb$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$40b0ef4339cb3cfb$export$a5cee9e955a615e5(alphabet, size, $40b0ef4339cb3cfb$export$4385e60b38654f68);
let $40b0ef4339cb3cfb$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let bytes = crypto.getRandomValues(new Uint8Array(size));
    while(size--)id += (0, $a35f4f689c1fd8b6$export$2b646eea95309f00)[bytes[size] & 63];
    return id;
};





function $e636991ba871a692$var$reducer(state, action) {
    switch(action.type){
        case "setTitle":
            state = {
                ...state,
                title: action.value
            };
            break;
        case "setCover":
            state = {
                ...state,
                cover: action.value
            };
            break;
        case "setSummary":
            state = {
                ...state,
                summary: action.value
            };
            break;
        case "setAuthor":
            state = {
                ...state,
                author: action.value
            };
            break;
        case "setWorkID":
            state = {
                ...state,
                workid: action.value
            };
            break;
        case "addTag":
            state = {
                ...state,
                tags: [
                    ...state.tags.filter((e)=>e != action.value),
                    action.value
                ]
            };
            break;
        case "removeTag":
            state = {
                ...state,
                tags: state.tags.filter((e)=>e !== action.value)
            };
            break;
        case "setChapter":
            let a = [
                ...state.chapters
            ];
            let idx = a.findIndex((e)=>e.id === action.value.id);
            if (idx >= 0) a[idx] = action.value;
            else a.push(action.value);
            state = {
                ...state,
                chapters: a
            };
            break;
        case "removeChapter":
            state = {
                ...state,
                chapters: state.chapters.filter((e)=>e.id !== action.value)
            };
            break;
        default:
            return state;
    }
    localStorage.setItem("ebook-editor-temp", JSON.stringify(state));
    return state;
}
function $e636991ba871a692$var$initState(initialState) {
    let state = JSON.parse(JSON.stringify(initialState));
    let old = localStorage.getItem("ebook-editor-temp");
    if (old && old !== "") try {
        let s = JSON.parse(old);
        state = {
            ...state,
            ...s
        };
    } catch  {}
    return state;
}
function $e636991ba871a692$var$EditWork({ state: state, dispatch: dispatch }) {
    return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
        children: [
            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                class: "input-group",
                children: [
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("label", {
                        for: "title",
                        children: "Title"
                    }),
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("input", {
                        type: "text",
                        id: "title",
                        autofocus: true,
                        value: state.title,
                        onChange: (e)=>dispatch({
                                type: "setTitle",
                                value: e.target.value
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                class: "input-group",
                children: [
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("label", {
                        for: "author",
                        children: "Author"
                    }),
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("input", {
                        type: "text",
                        id: "author",
                        autofocus: true,
                        value: state.author,
                        onChange: (e)=>dispatch({
                                type: "setAuthor",
                                value: e.target.value
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                class: "input-group",
                children: [
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("label", {
                        for: "summary",
                        children: "Summary"
                    }),
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("textarea", {
                        type: "text",
                        id: "summary",
                        autofocus: true,
                        value: state.summary,
                        rows: 20,
                        onChange: (e)=>dispatch({
                                type: "setSummary",
                                value: e.target.value
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                class: "input-group",
                children: [
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("label", {
                        for: "cover",
                        children: "Cover"
                    }),
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("input", {
                        type: "text",
                        id: "cover",
                        autofocus: true,
                        value: state.cover,
                        onChange: (e)=>dispatch({
                                type: "setCover",
                                value: e.target.value
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                class: "input-group",
                children: [
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("label", {
                        for: "description",
                        children: "Description"
                    }),
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("input", {
                        type: "text",
                        id: "description",
                        autofocus: true,
                        value: state.workid,
                        onChange: (e)=>dispatch({
                                type: "setWorkID",
                                value: e.target.value
                            })
                    })
                ]
            })
        ]
    });
}
const $e636991ba871a692$var$emptyBook = {
    title: "",
    author: "",
    cover: "",
    summary: "",
    chapters: [],
    tags: [],
    type: "manually",
    workid: ""
};
function $e636991ba871a692$var$showChapterModal(chapter, save, rm) {
    const controls = (0, $ddd8694e50ec82d7$export$d7e8d4d4450c819c)(()=>{
        return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $54cd03c1d32ebcab$export$ffb0004e005737fa), {
            children: [
                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                    className: "modal-title",
                    children: "Add"
                }),
                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                    className: "modal-content",
                    children: [
                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                            class: "input-group",
                            children: [
                                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("label", {
                                    for: "title",
                                    children: "Title"
                                }),
                                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("input", {
                                    type: "text",
                                    id: "title",
                                    autofocus: true,
                                    value: chapter.title,
                                    onChange: (e)=>chapter.title = e.target.value
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                            class: "input-group",
                            children: [
                                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("label", {
                                    for: "content",
                                    children: "Content"
                                }),
                                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("textarea", {
                                    type: "text",
                                    id: "content",
                                    autofocus: true,
                                    value: chapter.content,
                                    rows: 20,
                                    onChange: (e)=>chapter.content = e.target.value
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                    class: "modal-action",
                    children: [
                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("button", {
                            class: "btn btn-error",
                            onClick: ()=>{
                                rm();
                                controls.close();
                            },
                            children: "Delete"
                        }),
                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("button", {
                            class: "btn btn-primary",
                            onClick: ()=>{
                                save();
                                controls.close();
                            },
                            children: "Save"
                        })
                    ]
                })
            ]
        });
    });
}
function $e636991ba871a692$export$2e2bcd8739ae039() {
    const [state, dispatch] = (0, $79abdce4f0f4201e$export$13e3392192263954)($e636991ba871a692$var$reducer, $e636991ba871a692$var$emptyBook, $e636991ba871a692$var$initState);
    console.log(state);
    // const [];
    return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
        class: "container",
        style: "margin-top:1rem",
        children: [
            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)($e636991ba871a692$var$EditWork, {
                state: state,
                dispatch: dispatch
            }),
            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("h3", {
                style: "margin-bottom: .5rem",
                children: "Chapters:"
            }),
            state.chapters.length <= 0 ? /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("h4", {
                style: "margin-left: 1rem",
                children: "No Chapters"
            }) : /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("ul", {
                class: "list list-divider list-clickable",
                children: state.chapters.map((e)=>/*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("li", {
                        onClick: ()=>{
                            $e636991ba871a692$var$showChapterModal(e, ()=>{
                                dispatch({
                                    type: "setChapter",
                                    value: e
                                });
                            }, ()=>{
                                dispatch({
                                    type: "removeChapter",
                                    value: e.id
                                });
                            });
                        },
                        children: e.title
                    }))
            }),
            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("button", {
                onClick: ()=>{
                    const c = {
                        id: (0, $40b0ef4339cb3cfb$export$ac4959f4f1338dfc)(),
                        content: "",
                        title: ""
                    };
                    $e636991ba871a692$var$showChapterModal(c, ()=>{
                        dispatch({
                            type: "setChapter",
                            value: c
                        });
                    }, ()=>null);
                },
                class: "btn btn-secondary",
                style: "margin-top: .5rem",
                children: "Add"
            }),
            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("br", {}),
            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                style: "display: flex",
                children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("button", {
                    onClick: async ()=>{
                        // TODO: Validation
                        await new Promise((resolve)=>{
                            const ctrls = (0, $ddd8694e50ec82d7$export$d7e8d4d4450c819c)(()=>{
                                return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $54cd03c1d32ebcab$export$ffb0004e005737fa), {
                                    children: [
                                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                            className: "modal-title",
                                            children: "Review"
                                        }),
                                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                            className: "modal-content",
                                            children: /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("code", {
                                                style: "white-space: pre",
                                                children: JSON.stringify(state, null, "   ")
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("br", {}),
                                        /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                                            className: "modal-actions",
                                            children: [
                                                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("button", {
                                                    class: "btn",
                                                    onClick: ()=>{
                                                        ctrls.close();
                                                        resolve();
                                                    },
                                                    children: "Save"
                                                }),
                                                /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("button", {
                                                    class: "btn",
                                                    onClick: ()=>ctrls.close(),
                                                    children: "Cancel"
                                                })
                                            ]
                                        })
                                    ]
                                });
                            });
                        });
                        console.log("Add work");
                        await (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).addManualWork(state).then(()=>{
                            alert("Success!");
                            (0, $5c3d1d9675d0a11e$export$2e2bcd8739ae039).setPage((0, $5c3d1d9675d0a11e$export$c717c2ee03fc6c49).Library, undefined);
                        }).catch((err)=>{
                            console.log(err);
                            alert("Error: " + err.message);
                        });
                    },
                    class: "btn btn-success",
                    style: "margin-left:auto; margin-top: .5rem",
                    children: "Save"
                })
            })
        ]
    });
}


function $82cbacefcb8f5d99$export$2e2bcd8739ae039() {
    const [loggedIn, setLoggedIn] = (0, $79abdce4f0f4201e$export$60241385465d0a34)(!(0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).needLogin);
    const [page, setPage] = (0, $79abdce4f0f4201e$export$60241385465d0a34)({
        page: (0, $5c3d1d9675d0a11e$export$2e2bcd8739ae039).page,
        state: (0, $5c3d1d9675d0a11e$export$2e2bcd8739ae039).state
    });
    (0, $79abdce4f0f4201e$export$6d9c69b0de29b591)(()=>{
        const onLogin = ({ need_login: need_login })=>{
            setLoggedIn(!need_login);
        };
        const onPage = (page)=>{
            setPage(page);
        };
        (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).loginObservable.subscribe(onLogin);
        (0, $5c3d1d9675d0a11e$export$2e2bcd8739ae039).pageObservable.subscribe(onPage);
        return ()=>{
            (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).loginObservable.unsubscribe(onLogin);
            (0, $5c3d1d9675d0a11e$export$2e2bcd8739ae039).pageObservable.unsubscribe(onPage);
        };
    }, []);
    if (!loggedIn) return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $26110e5e514dd1f1$export$43dbf75585287913), {});
    let component;
    switch(page.page){
        case (0, $5c3d1d9675d0a11e$export$c717c2ee03fc6c49).Library:
            component = /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $c8531f9e595511bf$export$9f2b2187e67812d8), {}, "Library");
            break;
        case (0, $5c3d1d9675d0a11e$export$c717c2ee03fc6c49).Reader:
            component = /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $3a4a07bba9e88a38$export$2e2bcd8739ae039), {
                id: page.state
            }, "Reader");
            break;
        case (0, $5c3d1d9675d0a11e$export$c717c2ee03fc6c49).Stats:
            component = /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $edacaa953ae62c6a$export$ad3116fa4cf196e9), {}, "Stats");
            break;
        case (0, $5c3d1d9675d0a11e$export$c717c2ee03fc6c49).Add:
            component = /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $91a1708048be5fb7$export$827f4f7f7b0d0703), {}, "Add");
            break;
        case (0, $5c3d1d9675d0a11e$export$c717c2ee03fc6c49).Details:
            component = /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $b4d0f364e06c4cdc$export$4d683b4e036af97), {
                id: page.state
            }, "Details");
            break;
        case (0, $5c3d1d9675d0a11e$export$c717c2ee03fc6c49).Browse:
            component = /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $f64948dbb6631b93$export$2e2bcd8739ae039), {}, "Browse");
            break;
        case (0, $5c3d1d9675d0a11e$export$c717c2ee03fc6c49).Edit:
            component = /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $e636991ba871a692$export$2e2bcd8739ae039), {}, "EditorPage");
            break;
    }
    return /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
        children: [
            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $ddd8694e50ec82d7$export$d507f25e63650365), {}),
            /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("div", {
                children: [
                    /*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $fa18f20fb7e134af$export$2e2bcd8739ae039), {}),
                    component
                ]
            })
        ]
    });
}
window.showModal = ()=>{
    (0, $ddd8694e50ec82d7$export$d7e8d4d4450c819c)(()=>/*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)("h1", {
            children: "Hallo Welt"
        }));
};




(0, $ab361099379de31a$export$2e2bcd8739ae039).isDarkObservable.subscribe((dark)=>console.log(dark ? "Dark Theme" : "Light Theme"));
let $037442ac700fa9df$var$u = new URL(window.location.href);
let $037442ac700fa9df$var$code = $037442ac700fa9df$var$u.searchParams.get("code");
if ($037442ac700fa9df$var$code) (0, $3de94ec6e8ed99ed$export$2e2bcd8739ae039).getToken($037442ac700fa9df$var$code).then(()=>{
    window.history.replaceState({}, document.title, "/");
});
(0, $54cd03c1d32ebcab$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, $45c58de8213b6dd9$export$34b9dba7ce09269b)((0, $82cbacefcb8f5d99$export$2e2bcd8739ae039), {}), document.body);


//# sourceMappingURL=index.3bf5355a.js.map
